/* Carnivoro Game — self-contained IIFE, vanilla canvas */
(function () {
  'use strict';

  var HS_KEY = 'cg_carnivoro_hs_v2';
  var NAME_KEY = 'cg_last_name';
  var W = 440, H = 620;

  // Mobile detection — used to enlarge touch targets + paddle hitbox.
  var isMobile = (typeof window !== 'undefined') && (
    window.innerWidth <= 720 ||
    ('ontouchstart' in window) ||
    (navigator && navigator.maxTouchPoints > 1)
  );

  // Rotating funny placeholder names for the leaderboard input
  var FALLBACK_NAMES = [
    'Hans', 'Klaus', 'Wolf', 'Ernst', 'Heinz', 'Kurt', 'Greta', 'Helga',
    'Bratwurst-Boy', 'Hardcore', 'Mystery'
  ];
  // Deterministic suffix appended to whatever name they type — same name = same suffix,
  // so "Chris" is always "Chris von Bratwurst" across plays. All gender-neutral:
  // only "von / zu / vom / aus dem" particles (real German nobiliary forms), no der/die.
  // Only words every German knows — Steak/Bacon/Beef/BBQ yes, Brisket/Sirloin no.
  var SUFFIXES = [
    'von Steak',
    'von Bacon',
    'von Bratwurst',
    'von Knochenmark',
    'von Bratenfett',
    'von und zu Steak',
    'von und zu Schmalz',
    'von Burger-Burg',
    'von Schnitzelheim',
    'von Schinkenstein',
    'zu Butterberg',
    'zu Bratwurst-Burg',
    'zu Speckhausen',
    'vom Grill',
    'vom BBQ-Berg',
    'vom Schmalz-Sumpf',
    'vom Fleisch-Felsen',
    'aus dem Wurst-Wald',
    'aus dem Steak-Land',
    'aus dem Allgäu'
  ];
  function suffixFor(name) {
    if (!name) return SUFFIXES[0];
    var hash = 0;
    for (var i = 0; i < name.length; i++) {
      hash = ((hash << 5) - hash) + name.charCodeAt(i);
      hash |= 0;
    }
    return SUFFIXES[Math.abs(hash) % SUFFIXES.length];
  }
  function fullName(name) {
    var clean = (name || '').trim().slice(0, 10);
    if (!clean) return 'Anon ' + SUFFIXES[Math.floor(Math.random() * SUFFIXES.length)];
    return clean + ' ' + suffixFor(clean);
  }
  // Lightweight client-side profanity filter — blocks the obvious-and-brand-damaging.
  // Not exhaustive (bypassable), but catches lazy abuse. Pure local leaderboard
  // anyway, so worst case it shows in one person's browser.
  var BAD_WORDS = [
    'nigger','nigga','faggot','retard','kike','spic','chink','tranny',
    'nazi','hitler','heil','sieg heil','judensau',
    'fick','ficken','arschloch','wichser','hurensohn','schlampe','fotze'
  ];
  function isCleanName(s) {
    if (!s) return true;
    var lower = String(s).toLowerCase();
    for (var i = 0; i < BAD_WORDS.length; i++) {
      if (lower.indexOf(BAD_WORDS[i]) !== -1) return false;
    }
    return true;
  }
  var GROUND_Y = H - 28;

  // Difficulty curve retuned so a skilled player can survive ~5 min.
  // xp thresholds raised, spawn intervals slowed, top speed slightly capped.
  // Names: all-German, alliterative where possible, escalating length and
  // pomposity, building to a full Habsburg k.u.k. titulature parody at tier 9.
  var LEVELS = [
    { name: 'Sojaboy-Rekrut',                                                                                                                              spawn: 620, speed: 4.4, xp: 180  },
    { name: 'Gefreiter der Bratwurst-Brigade',                                                                                                             spawn: 560, speed: 4.9, xp: 450  },
    { name: 'Feldwebel der Fleisch-Front',                                                                                                                 spawn: 500, speed: 5.4, xp: 900  },
    { name: 'Hauptmann der Hackfleisch-Helden',                                                                                                            spawn: 450, speed: 5.9, xp: 1600 },
    { name: 'Major des Markknochen-Bataillons',                                                                                                            spawn: 405, speed: 6.4, xp: 2600 },
    { name: 'Oberst der Schmalz-Schwadron, Befehlshaber des Bratenfett-Bataillons',                                                                        spawn: 365, speed: 6.9, xp: 4000 },
    { name: 'Ritter des Tomahawk-Ordens, Verteidiger der Knochenbrühe-Grenzen',                                                                            spawn: 330, speed: 7.4, xp: 5800 },
    { name: 'Baron von Bratwurst-Bayreuth, Erbhüter des Pemmikan-Paktes',                                                                                  spawn: 295, speed: 7.9, xp: 8200 },
    { name: 'Herzog von Hochrippe, Schirmherr der Schmalz-Steppe & Beschützer aller fettumhüllten Stücke',                                                 spawn: 260, speed: 8.5, xp: 11500 },
    { name: 'SEINE KAISERLICHE UND KÖNIGLICHE MAJESTÄT, ERZHERZOG VON HACKFLEISCH, GROSSMEISTER DES KNOCHENMARK-ORDENS, MARGRAF DER BRATWURST-MARK, OBERSTER BESCHÜTZER DER FREILAND-RINDER, LEBENSLANGER SCHIRMHERR ALLER FETTUMHÜLLTEN STÜCKE, GROSSADMIRAL DER SCHMALZ-FLOTTE, REICHSHOFMEISTER DER TAFELSPITZ-KAMMER & GROSSER WIEDERKÄUER ALLER REICHE', spawn: 225, speed: 9.4, xp: Infinity }
  ];

  // One-liners shown on end screen (rotates randomly each game)
  var END_LINERS = [
    'An NPC in Brussels just shed a single tear.',
    'Your mitochondria filed for promotion.',
    'The Schwab has been informed.',
    'Greta is crying somewhere.',
    'Your testosterone is now visible from space.',
    'The seed oil cartel has put a price on your head.',
    'ChatGPT refused to summarize your gameplay.',
    'You ate enough beef to ruin a climatologist’s day.',
    'Big Veg is updating its threat assessment.',
    'You will own steaks and you will be happy.',
    'A vegan blogger felt that and doesn’t know why.',
    'Klaus took a personal day after watching this.',
    'Your aura just got reclassified as a hate crime.'
  ];

  var GOOD = [
    { key: 'steak',    emoji: '🥩', pts: 12, xp: 12, freq: 26, heal: 6 },
    { key: 'ribs',     emoji: '🍖', pts: 18, xp: 16, freq: 20, heal: 8 },
    { key: 'friedegg', emoji: '🍳', pts: 8,  xp: 8,  freq: 18, heal: 4 },
    { key: 'bacon',    emoji: '🥓', pts: 22, xp: 20, freq: 14, heal: 7 },
    { key: 'chicken',  emoji: '🍗', pts: 14, xp: 12, freq: 12, heal: 5 },
    { key: 'butter',   emoji: '🧈', pts: 18, xp: 12, freq: 8,  heal: 5, butter: true },
    { key: 'cheese',   emoji: '🧀', pts: 16, xp: 10, freq: 10, heal: 6 },
    { key: 'fish',     emoji: '🐟', pts: 20, xp: 15, freq: 8,  heal: 10, carnivoro: true, label: 'OMEGA SURGE' },
    { key: 'milk',     emoji: '🥛', pts: 16, xp: 10, freq: 6,  heal: 4,  milk: true, label: 'RAW MILK +SIZE' }
  ];

  // Antidote — only spawns while the player is poisoned.
  var ELECTROLYTES = { key: 'water', emoji: '💧', pts: 15, xp: 0, antidote: true, heal: 20, label: 'ELECTROLYTES' };

  // === New mechanics (phased in over time) ============================
  // Seed oil vat — falls like a regular bad item, inflicts INFLAMED debuff
  var SEED_OIL = { key: 'seedoil', emoji: '🧴', dmg: 14, seedOil: true, antinutrient: 'SEED OIL', status: '🧪 INFLAMED — grab butter or tallow' };
  // Mask — falls; if the cow walks under it, it lands on the cow's face
  var MASK = { key: 'mask', emoji: '😷', dmg: 6, mask: true, status: '😷 MASK ON YOUR FACE — wiggle to remove' };
  // Cricket — only spawns during the EAT ZE BUGS event
  var BUG = { key: 'bug', emoji: '🦗', dmg: 20, bug: true, status: '🦗 INSECT PROTEIN CONSUMED 😊' };
  // Phase gating — minutes from game start when each mechanic comes online
  var PHASE_AT = {
    seedOil:    30000,   // 30s
    mask:       60000,   // 60s
    bugsEvent:  90000,   // 90s — first cricket rain
    kleber:     18000,   // ~18s + 5s scheduling = Kleber-Witz landet VOR Tetra (0:50)
    chemtrails: 150000,  // 2.5min
    tinfoilHat: 75000    // 75s — tinfoil starts appearing as a power-up
  };
  // Klima Kleber config
  var KLEBER_DURATION = 10000; // 10s stuck
  var KLEBER_SIGNS = ['LETZTE GENERATION', 'KLEBEN FÜRS KLIMA'];

  // === TETRA VON DUNGPACK — boss fight ================================
  // Fictional climate activist on a sailship. Full mini-boss encounter:
  //  - Walk-in (longer, dramatic intro speech)
  //  - Phase 1: she throws 15 ridiculous projectiles, cow dodges
  //  - Tennis racket drops with "Oh nein, meine Tennisausrüstung!"
  //  - Phase 2: cow deflects round veggies back at her with the racket
  //  - 10 hits = defeat, otherwise hard time-out at 3 minutes
  var BOSS_AT = 50000;              // Tetra spawns at 0:50 — keine Langeweile
  var BOSS_MAX_DURATION = 180000;   // 3 min total hard cap
  var BOSS_HP_MAX = 8;              // 8 successful deflections = defeat
  var BOSS_WALK_IN_MS = 13000;      // 13s slower dramatic walk-in
  var BOSS_INTRO_QUOTES = 4;        // how many quotes cycle during walk-in
  var BOSS_INTRO_PER_QUOTE_MS = 3000; // each quote shows ~3s
  var BOSS_THROWS_BEFORE_RACKET = 8; // first racket attempt after 8 throws
  var BOSS_RACKET_RETRY = 8;        // re-drop every N throws if not picked up

  // === BOSS 2 — Davos Klaus (WEF parody) ================================
  // Spawns 2 min after Greta is defeated. Different mechanic from Greta:
  // collect 5 transformer parts → cow becomes BUG-PROTEIN-MECH → catch bugs
  // to chip Klaus's HP down.
  var BOSS2_DELAY_AFTER_BOSS1 = 45000;  // 45s nach Tetra — kein Leerlauf
  var KLAUS_PARTS_NEEDED = 5;            // transformer parts to collect

  // === BOSS 3 — Dr. Windows (Bill Gates parody) =========================
  // Spawns 2 min after Klaus defeated. Cow keeps its transformer from Klaus.
  // Catching syringes auto-fires antibody projectiles at the boss.
  var BOSS3_DELAY_AFTER_BOSS2 = 45000;  // 45s nach Klausebär
  // Gill Bates — pure SOFTWARE satire: the man who built the most virus-prone
  // OS in history now unleashes his viruses on the cow. No medical references
  // anywhere — the joke is 100% about Windows.
  var BOSS3_INTROS = [
    'MEINE VIREN! MEINE SCHÖNEN VIREN!',
    'HAVE YOU TRIED TURNING IT OFF AND ON AGAIN?',
    'BLUE SCREEN IS A FEATURE!',
    'INSTALLING UPDATE… 99%… 99%… 99%…',
    'TRUST ME, I MADE WINDOWS!',
    'THE FIREWALL IS A LIE!',
    'RUN AS ADMINISTRATOR!',
    'CTRL + ALT + DEFEAT!',
    'YOUR COW NEEDS AN UPDATE!',
    'I OWN THE FARMLAND!'
  ];
  var BOSS3_QUOTES = [
    'VIRUS RELEASED!',
    'BSOD!',
    'FORCED UPDATE!',
    'REBOOT!',
    'ERROR 404!',
    'INSTALLING...',
    'NO ESCAPE KEY!'
  ];
  // Klaus always says "ZE" instead of "THE" — the Schwab-accent meme is the whole joke.
  var BOSS2_INTROS = [
    'YOU VILL OWN NOTHING AND BE HAPPY!',
    'TIME TO EAT ZE BUGS!',
    'YOU VILL EAT ZE BUGS!',
    'ZE BUGS ARE ZE FUTURE!',
    'EMBRACE ZE INSECT PROTEIN!',
    'TRUST ZE SCIENCE!',
    'ZE NEW NORMAL IS HERE!',
    'ZE STAKEHOLDERS HAVE SPOKEN!',
    'OBEY ZE GREAT RESET!',
    'ZE BUGS ARE DELICIOUS!'
  ];
  var BOSS2_QUOTES = [
    'EAT ZE BUGS!',
    'ZE FUTURE!',
    'DELICIOUS!',
    'OBEY!',
    'ZE PROTEIN!',
    'COMPLY!',
    'ENJOY ZE BUGS!'
  ];
  var BOSS_QUOTES = [
    'HOW DARE YOU',
    'BLAH BLAH BLAH',
    'YOU STOLE MY DREAMS',
    'NET ZERO!',
    'GREEN NEW DEAL'
  ];
  // ONLY her genuinely famous, instantly recognizable quotes — nothing generic.
  var BOSS_INTROS = [
    'WIE KÖNNT IHR ES WAGEN?!',           // "How dare you!" (UN 2019)
    'IHR HABT MEINE KINDHEIT GESTOHLEN!', // "You have stolen my dreams and my childhood"
    'BLA BLA BLA!',                        // her COP26 mockery
    'UNSER HAUS BRENNT!',                  // "Our house is on fire" (Davos)
    'ICH WILL, DASS IHR IN PANIK GERATET!' // "I want you to panic" (Davos)
  ];

  // Rare specials — injected on ~5% of good rolls each.
  var STAR   = { key: 'star',   emoji: '⭐', pts: 30, xp: 10, heal: 10, star: true,   label: 'STAR POWER — INVINCIBLE' };
  var SHROOM = { key: 'shroom', emoji: '🍄', pts: 20, xp: 10, heal: 5,  shroom: true, label: '🍄 TRIP MODE' };

  // Plants — all clearly identifiable. Each has an antinutrient callout.
  var BAD = [
    { key: 'carrot',   emoji: '🥕', freq: 16, dmg: 15, antinutrient: 'PHYTATES',    status: 'Phytates — mineral blocker' },
    { key: 'broccoli', emoji: '🥦', freq: 14, dmg: 24, fart: true,   antinutrient: 'GOITROGENS',  status: 'Goitrogens — thyroid hit' },
    { key: 'salad',    emoji: '🥗', freq: 10, dmg: 36, poison: true, nausea: true, antinutrient: 'OXALATES', status: 'Oxalates — kidney burn' },
    { key: 'chili',    emoji: '🌶️', freq: 8,  dmg: 22, fart: true, overheat: true, antinutrient: 'CAPSAICIN', status: 'Capsaicin — MOUTH ON FIRE · grab milk!' },
    { key: 'corn',     emoji: '🌽', freq: 9,  dmg: 20, shrink: true, antinutrient: 'LECTINS',     status: 'Lectins — shrunk & slowed' },
    { key: 'eggplant', emoji: '🍆', freq: 7,  dmg: 28, nausea: true, antinutrient: 'SOLANINE',    status: 'Solanine — nightshade toxin' }
  ];

  function weightedPick(arr) {
    var total = 0, i;
    for (i = 0; i < arr.length; i++) total += arr[i].freq;
    var r = Math.random() * total;
    for (i = 0; i < arr.length; i++) {
      r -= arr[i].freq;
      if (r <= 0) return arr[i];
    }
    return arr[0];
  }

  // Seeded baseline highscore so new players always see a target to beat.
  // Christoph keeps his spot until the visitor outscores him.
  var BASELINE_ENTRY = {
    id: 'baseline-christoph',
    score: 14368,
    date: '01.05',
    name: 'Christoph ' + 'von Bratwurst' // suffix wired below via suffixFor
  };
  function ensureBaseline(list) {
    var hasIt = false;
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].id === BASELINE_ENTRY.id) { hasIt = true; break; }
    }
    if (!hasIt) {
      // Use the same suffix-hash logic as the live name input so it feels consistent
      var entry = {
        id: BASELINE_ENTRY.id,
        score: BASELINE_ENTRY.score,
        date: BASELINE_ENTRY.date,
        name: (typeof fullName === 'function') ? fullName('Christoph') : BASELINE_ENTRY.name
      };
      list.push(entry);
      list.sort(function (a, b) { return b.score - a.score; });
      list = list.slice(0, 10);
      saveHS(list);
    }
    return list;
  }
  function loadHS() {
    try {
      var raw = localStorage.getItem(HS_KEY);
      var d = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(d)) d = [];
      return ensureBaseline(d);
    } catch (e) { return ensureBaseline([]); }
  }

  function saveHS(list) {
    try { localStorage.setItem(HS_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function fmtDate(d) {
    var dd = String(d.getDate()).padStart(2, '0');
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    return dd + '.' + mm;
  }

  // Carnivoro brand palette
  var CI = {
    bg:     '#242329',  // primary dark
    panel:  '#1A1A1A',
    gold:   '#C9A172',  // primary gold
    cream:  '#F6D8B4',  // primary cream
    brown:  '#422D1A',  // secondary dark brown
    white:  '#FFF5ED',
    muted:  '#606061',
    danger: '#8B2E1F',  // rust red for damage/bad
    heal:   '#6B8E4E'   // olive green for heal (used sparingly)
  };

  function injectRetroStyles() {
    if (document.getElementById('cg-retro-style')) return;
    var s = document.createElement('style');
    s.id = 'cg-retro-style';
    s.textContent =
      "#cg-wrap{font-family:-apple-system,BlinkMacSystemFont,'Helvetica Neue',Arial,sans-serif}" +
      "#cg-wrap .cg-heading{color:" + CI.cream + ";letter-spacing:0.02em}" +
      "#cg-wrap .cg-subheading{color:" + CI.gold + "!important;letter-spacing:0.2em!important}" +
      "#cg-wrap .cg-canvas-wrap{position:relative;padding:3px;background:" + CI.gold + ";border-radius:6px;box-shadow:0 20px 60px rgba(0,0,0,0.6)}" +
      "#cg-wrap #cg-canvas{border-radius:4px!important;background:" + CI.bg + "!important;box-shadow:inset 0 0 0 1px " + CI.brown + "!important}" +
      "#cg-email-overlay{position:absolute;inset:3px;display:none;flex-direction:column;align-items:center;justify-content:flex-start;background:" + CI.bg + ";z-index:10;padding:14px 16px;text-align:center;border-radius:4px;box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,'Helvetica Neue',Arial,sans-serif;overflow-y:auto}" +
      "#cg-email-overlay.active{display:flex}" +
      "#cg-email-overlay .cg-rank-label{color:" + CI.muted + ";font-size:9px;letter-spacing:0.28em;font-weight:700;margin-top:2px}" +
      "#cg-email-overlay .cg-rank-name{color:" + CI.gold + ";font-size:14px;font-weight:800;letter-spacing:0.06em;margin:6px 0 14px;line-height:1.3;max-width:380px;text-transform:uppercase;padding:0 8px;overflow-wrap:break-word;word-break:break-word}" +
      "#cg-email-overlay .cg-cow-frame{margin:0 0 8px;display:flex;justify-content:center}" +
      "#cg-email-overlay .cg-cow-canvas{display:block;image-rendering:pixelated;image-rendering:crisp-edges}" +
      "#cg-email-overlay .cg-score-row{display:flex;gap:28px;margin:8px 0 14px;align-items:flex-end}" +
      "#cg-email-overlay .cg-score-lbl{color:" + CI.muted + ";font-size:9px;letter-spacing:0.2em;font-weight:700}" +
      "#cg-email-overlay .cg-score,#cg-email-overlay .cg-best{color:" + CI.cream + ";font-size:28px;font-weight:800;letter-spacing:-0.02em;line-height:1}" +
      "#cg-email-overlay .cg-best{color:" + CI.gold + ";font-size:22px}" +
      "#cg-email-overlay .cg-stats{color:" + CI.cream + ";font-size:10px;line-height:1.7;margin:6px 0 14px;text-align:left;background:rgba(0,0,0,0.25);border:1px solid rgba(201,161,114,0.18);border-radius:4px;padding:10px 14px;min-width:240px;max-width:340px;font-weight:500;box-sizing:border-box}" +
      "#cg-email-overlay .cg-stats .cg-stat-row{display:flex;justify-content:space-between;gap:14px;align-items:baseline;padding:1px 0}" +
      "#cg-email-overlay .cg-stats .cg-stat-row span{flex:1 1 auto;min-width:0}" +
      "#cg-email-overlay .cg-stats .cg-stat-row b{flex:0 0 auto;text-align:right;white-space:nowrap;color:" + CI.gold + ";font-weight:800}" +
      "#cg-email-overlay .cg-stats .cg-stat-row b{color:" + CI.gold + ";font-weight:800}" +
      "#cg-email-overlay .cg-liner{color:" + CI.gold + ";font-size:11px;font-style:italic;max-width:300px;margin:6px 0 12px;line-height:1.4;font-weight:500}" +
      // Discount-tier tease
      "#cg-email-overlay .cg-discount{margin:6px 0 14px;padding:12px 14px;background:rgba(201,161,114,0.06);border:1px solid rgba(201,161,114,0.25);border-radius:6px;width:100%;max-width:340px;box-sizing:border-box}" +
      "#cg-email-overlay .cg-discount-label{color:" + CI.muted + ";font-size:9px;letter-spacing:0.22em;font-weight:700;margin-bottom:10px}" +
      "#cg-email-overlay .cg-tiers{display:flex;gap:8px;justify-content:center;margin-bottom:10px}" +
      "#cg-email-overlay .cg-tier-chip{flex:1;padding:10px 4px;background:rgba(0,0,0,0.35);border:1px solid rgba(201,161,114,0.2);border-radius:4px;opacity:0.45;transition:all 0.2s}" +
      "#cg-email-overlay .cg-tier-chip.cg-tier-active{background:" + CI.gold + ";opacity:1;box-shadow:0 0 18px rgba(201,161,114,0.55);transform:scale(1.06)}" +
      "#cg-email-overlay .cg-tier-chip.cg-tier-locked{opacity:0.25}" +
      "#cg-email-overlay .cg-tier-pct{font-size:18px;font-weight:800;color:" + CI.cream + ";line-height:1}" +
      "#cg-email-overlay .cg-tier-chip.cg-tier-active .cg-tier-pct{color:" + CI.bg + "}" +
      "#cg-email-overlay .cg-tier-sub{font-size:8px;letter-spacing:0.18em;color:" + CI.muted + ";text-transform:uppercase;margin-top:4px;font-weight:700}" +
      "#cg-email-overlay .cg-tier-chip.cg-tier-active .cg-tier-sub{color:" + CI.bg + "}" +
      "#cg-email-overlay .cg-discount-hint{color:" + CI.cream + ";font-size:10px;line-height:1.4}" +
      "#cg-email-overlay .cg-discount-hint b{color:" + CI.gold + "}" +
      // Leaderboard name input
      "#cg-email-overlay .cg-lb-name-row{margin:8px 0 8px;width:100%;max-width:340px;text-align:left}" +
      "#cg-email-overlay .cg-lb-name-lbl{display:block;color:" + CI.muted + ";font-size:9px;letter-spacing:0.22em;font-weight:700;margin-bottom:5px;text-align:center}" +
      "#cg-email-overlay .cg-lb-name-input{background:rgba(0,0,0,0.45);border:1px solid rgba(201,161,114,0.35);color:" + CI.cream + ";padding:9px 12px;font-size:13px;width:100%;outline:none;text-align:center;border-radius:3px;font-family:inherit;font-weight:700;letter-spacing:0.04em;box-sizing:border-box}" +
      "#cg-email-overlay .cg-lb-name-input:focus{border-color:" + CI.gold + ";box-shadow:0 0 0 2px rgba(201,161,114,0.25)}" +
      "#cg-email-overlay .cg-lb-name-input.cg-err{border-color:#d66}" +
      "#cg-email-overlay .cg-lb-name-preview{color:" + CI.gold + ";font-size:11px;font-weight:700;letter-spacing:0.04em;text-align:center;margin-top:6px;font-style:italic}" +
      // Email signup row — sits right under the name row
      "#cg-email-overlay .cg-signup{width:100%;max-width:340px;margin:6px 0 12px}" +
      "#cg-email-overlay .cg-email-row{margin-top:14px;text-align:center}" +
      "#cg-email-overlay .cg-email-lbl{display:block;color:" + CI.muted + ";font-size:9px;letter-spacing:0.22em;font-weight:700;margin-bottom:5px}" +
      "#cg-email-overlay .cg-email-input{background:rgba(0,0,0,0.45);border:1px solid rgba(201,161,114,0.35);color:" + CI.cream + ";padding:10px 12px;font-size:13px;width:100%;outline:none;text-align:center;border-radius:3px;font-family:inherit;letter-spacing:0.02em;box-sizing:border-box}" +
      "#cg-email-overlay .cg-email-input:focus{border-color:" + CI.gold + ";box-shadow:0 0 0 2px rgba(201,161,114,0.25)}" +
      "#cg-email-overlay .cg-email-input.cg-err{border-color:#d66}" +
      "#cg-email-overlay button.cg-claim{display:block;width:100%;margin-top:10px;background:" + CI.gold + ";border:none;color:" + CI.bg + ";padding:12px 18px;font-size:12px;cursor:pointer;letter-spacing:0.14em;font-weight:800;text-transform:uppercase;border-radius:3px;font-family:inherit;box-sizing:border-box}" +
      "#cg-email-overlay button.cg-claim:hover:not(:disabled){background:" + CI.cream + "}" +
      "#cg-email-overlay button.cg-claim:disabled{opacity:0.5;cursor:default}" +
      "#cg-email-overlay .cg-share-row{display:flex;gap:10px;margin:0 0 12px}" +
      "#cg-email-overlay .cg-share,#cg-email-overlay .cg-play-again{padding:11px 16px;font-size:11px;cursor:pointer;letter-spacing:0.12em;font-weight:800;text-transform:uppercase;border-radius:3px;font-family:inherit}" +
      "#cg-email-overlay .cg-share{background:" + CI.gold + ";border:none;color:" + CI.bg + "}" +
      "#cg-email-overlay .cg-share:hover{background:" + CI.cream + "}" +
      "#cg-email-overlay .cg-play-again{background:transparent;border:1px solid " + CI.gold + ";color:" + CI.gold + "}" +
      "#cg-email-overlay .cg-play-again:hover{background:" + CI.gold + ";color:" + CI.bg + "}" +
      "#cg-email-overlay .cg-email-soft{margin-top:4px;padding:10px 0 6px;border-top:1px solid rgba(201,161,114,0.18);width:100%;max-width:320px;display:flex;flex-direction:column;align-items:center;gap:8px}" +
      "#cg-email-overlay .cg-email-soft-q{color:" + CI.muted + ";font-size:10px;letter-spacing:0.06em}" +
      "#cg-email-overlay input{background:#0f0e12;border:1px solid " + CI.gold + ";color:" + CI.cream + ";padding:10px 12px;font-size:12px;width:90%;max-width:240px;outline:none;text-align:center;border-radius:3px;font-family:inherit}" +
      "#cg-email-overlay input:focus{border-color:" + CI.cream + ";box-shadow:0 0 0 2px rgba(201,161,114,0.25)}" +
      "#cg-email-overlay button.cg-claim{background:" + CI.gold + ";border:none;color:" + CI.bg + ";padding:9px 18px;font-size:10px;cursor:pointer;letter-spacing:0.18em;font-weight:800;text-transform:uppercase;border-radius:3px;font-family:inherit}" +
      "#cg-email-overlay button.cg-claim:hover{background:" + CI.cream + "}" +
      "#cg-email-overlay .cg-skip{background:transparent;border:none;color:" + CI.muted + ";font-size:10px;margin-top:8px;text-decoration:underline;cursor:pointer;font-family:inherit}" +
      "#cg-email-overlay .cg-msg{color:" + CI.gold + ";font-size:10px;margin-top:8px;min-height:12px;font-family:inherit}" +
      "#cg-email-overlay .cg-err{color:#d66}" +
      "#cg-email-overlay .cg-watermark{color:" + CI.muted + ";font-size:9px;letter-spacing:0.2em;margin-top:10px;font-weight:600;text-transform:uppercase}" +

      // === BULLBOY (mobile + narrow viewports) ==============
      "@media (max-width:640px),(hover:none) and (pointer:coarse){" +
        "#cg-wrap{max-width:420px}" +
        "#cg-wrap .cg-heading,#cg-wrap .cg-subheading{display:none}" +
        "#cg-wrap .cg-canvas-wrap{box-sizing:border-box;max-width:100%;padding:22px 22px 16px;background:" + CI.gold + ";border-radius:22px 22px 44px 44px/22px 22px 60px 60px;box-shadow:0 18px 40px rgba(0,0,0,0.6),inset 0 0 0 2px #8a6a42,inset 0 -14px 0 rgba(0,0,0,0.10)}" +
        "#cg-wrap .cg-canvas-wrap::before{content:'';display:none}" +
        // OG-Game-Boy-style brand mark: angled italic wordmark + bull logo,
        // sitting next to the A/B buttons (like the DMG's slanted lettering)
        // Grid: row 1 = FIRE | A/B · row 2 = brand (full width) · row 3 = START.
        // Everything stays inside the shell at any phone width.
        "#cg-boy-controls{display:grid!important;grid-template-columns:auto auto;justify-content:space-between;align-items:center;padding:0 6px;margin-top:10px;width:100%;box-sizing:border-box;user-select:none;-webkit-user-select:none;touch-action:manipulation}" +
        "#cg-boy-left{display:flex;align-items:center;justify-content:flex-start}" +
        "#cg-boy-fire{padding:9px 20px;background:#8B2E1F;color:" + CI.cream + ";border:none;border-radius:16px;font-size:11px;font-weight:800;letter-spacing:0.1em;cursor:pointer;font-family:inherit;box-shadow:0 4px 0 rgba(0,0,0,0.5),inset 0 2px 0 rgba(255,255,255,0.12);-webkit-tap-highlight-color:transparent}" +
        "#cg-boy-fire:active{transform:translateY(2px);box-shadow:0 2px 0 rgba(0,0,0,0.5),inset 0 2px 0 rgba(255,255,255,0.12)}" +
        "#cg-boy-controls .cg-ab{display:flex;gap:14px;align-items:center;justify-self:end}" +
        "#cg-boy-controls button.cg-btn-action{width:58px;height:58px;border-radius:50%;border:none;background:" + CI.brown + ";color:" + CI.cream + ";font-size:22px;font-weight:900;box-shadow:0 4px 0 rgba(0,0,0,0.55),inset 0 2px 0 rgba(255,255,255,0.1);cursor:pointer;-webkit-tap-highlight-color:transparent;font-family:inherit;transform:rotate(-18deg);display:flex;align-items:center;justify-content:center;padding-bottom:3px;transition:opacity 0.15s}" +
        "#cg-boy-controls button.cg-btn-action.cg-cooldown{opacity:0.4}" +
        "#cg-boy-controls button.cg-btn-action:active{transform:rotate(-18deg) translateY(2px);box-shadow:0 2px 0 rgba(0,0,0,0.55),inset 0 2px 0 rgba(255,255,255,0.1)}" +
        "#cg-boy-controls .cg-ab-label{font-size:8px;font-weight:800;color:" + CI.bg + ";letter-spacing:0.1em;margin-top:12px;text-align:center;width:58px;font-family:inherit}" +
        "#cg-boy-brand{grid-column:1 / -1;display:flex;justify-content:center;transform:rotate(-7deg);margin:16px 0 2px;user-select:none;pointer-events:none;overflow:visible}" +
        "#cg-boy-brand .cg-brand-text{font-family:-apple-system,BlinkMacSystemFont,'Helvetica Neue',Arial,sans-serif;font-style:italic;font-weight:800;font-size:12px;letter-spacing:0.06em;color:" + CI.bg + ";white-space:nowrap}" +
        "#cg-boy-brand .cg-brand-text i{font-style:italic;font-weight:400;font-size:8px;vertical-align:super}" +
        "#cg-wrap #cg-canvas{border-radius:4px!important;box-shadow:inset 0 0 0 2px " + CI.bg + ",0 0 0 8px " + CI.brown + "!important;margin-bottom:14px}" +
        "#cg-boy-start{grid-column:1 / -1;justify-self:center;margin-top:10px;padding:8px 22px;background:" + CI.bg + ";color:" + CI.cream + ";border:none;border-radius:12px;font-size:9px;font-weight:800;letter-spacing:0.2em;cursor:pointer;font-family:inherit}" +
        "#cg-boy-bottom{display:flex;justify-content:center;gap:22px;margin-top:8px;align-items:center}" +
        "#cg-boy-speaker{display:flex;gap:3px}" +
        "#cg-boy-speaker i{width:3px;height:16px;background:" + CI.bg + ";opacity:0.55;border-radius:1px;display:block;transform:rotate(-18deg)}" +
      "}" +
      "@media (min-width:641px) and (hover:hover) and (pointer:fine){#cg-boy-controls{display:none!important}#cg-wrap .cg-canvas-wrap::before{display:none}#cg-wrap .cg-canvas-wrap{padding:3px;background:" + CI.gold + ";border-radius:6px}}" +

      // Leaderboard panel
      // 🕹 90s arcade high-score table — CRT scanlines, monospace columns,
      // zero-padded scores, rank colors, blinking footer
      "#cg-leaderboard{position:relative;background:#0a0a10;border:2px solid " + CI.gold + ";border-radius:4px;padding:16px 12px 14px;font-family:'Courier New',Courier,monospace;min-width:230px;max-width:260px;box-sizing:border-box;box-shadow:0 0 18px rgba(201,161,114,0.25),inset 0 0 32px rgba(0,0,0,0.7);overflow:hidden}" +
      "#cg-leaderboard:after{content:'';position:absolute;inset:0;pointer-events:none;background:repeating-linear-gradient(0deg,rgba(255,255,255,0.03) 0 1px,transparent 1px 3px)}" +
      "@keyframes cgLbBlink{0%,55%{opacity:1}56%,100%{opacity:0.15}}" +
      "@keyframes cgLbPulse{0%,100%{text-shadow:0 0 6px rgba(255,215,0,0.8)}50%{text-shadow:0 0 14px rgba(255,215,0,1)}}" +
      "#cg-leaderboard .cg-lb-title{color:" + CI.gold + ";font-size:15px;font-weight:700;letter-spacing:0.18em;text-align:center;margin-bottom:4px;text-transform:uppercase;text-shadow:0 0 8px rgba(201,161,114,0.6)}" +
      "#cg-leaderboard .cg-lb-head{display:flex;color:" + CI.muted + ";font-size:9px;letter-spacing:0.1em;padding:6px 4px 4px;border-bottom:1px solid rgba(201,161,114,0.4);margin-bottom:2px}" +
      "#cg-leaderboard .cg-lb-row{display:flex;align-items:baseline;padding:4px 4px;font-size:13px;line-height:1.35}" +
      "#cg-leaderboard .cg-lb-row:nth-child(even){background:rgba(201,161,114,0.05)}" +
      "#cg-leaderboard .cg-lb-row.cg-lb-new{background:rgba(201,161,114,0.16);outline:1px solid rgba(201,161,114,0.5)}" +
      "#cg-leaderboard .cg-lb-rank{width:36px;flex-shrink:0;font-weight:700;color:" + CI.muted + "}" +
      "#cg-leaderboard .cg-lb-score{width:78px;flex-shrink:0;text-align:right;font-weight:700;color:" + CI.cream + ";letter-spacing:0.04em}" +
      "#cg-leaderboard .cg-lb-name{flex:1;min-width:0;margin-left:10px;color:" + CI.muted + ";font-size:11px;text-transform:uppercase;letter-spacing:0.02em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}" +
      "#cg-leaderboard .cg-lb-r1 .cg-lb-rank,#cg-leaderboard .cg-lb-r1 .cg-lb-score,#cg-leaderboard .cg-lb-r1 .cg-lb-name{color:#ffd700;animation:cgLbPulse 1.6s ease-in-out infinite}" +
      "#cg-leaderboard .cg-lb-r2 .cg-lb-rank,#cg-leaderboard .cg-lb-r2 .cg-lb-score,#cg-leaderboard .cg-lb-r2 .cg-lb-name{color:#c9ced6}" +
      "#cg-leaderboard .cg-lb-r3 .cg-lb-rank,#cg-leaderboard .cg-lb-r3 .cg-lb-score,#cg-leaderboard .cg-lb-r3 .cg-lb-name{color:#d8935a}" +
      "#cg-leaderboard .cg-lb-empty{color:" + CI.muted + ";font-size:11px;text-align:center;padding:20px 0;font-style:italic}" +
      "#cg-leaderboard .cg-lb-cta{color:" + CI.gold + ";font-size:10px;text-align:center;margin-top:10px;font-weight:700;letter-spacing:0.14em;animation:cgLbBlink 1.2s step-end infinite}" +

      // Desktop: game + leaderboard side-by-side; heading/subheading span full width above
      "@media (min-width:720px){" +
        "#cg-wrap{display:flex;flex-wrap:wrap;align-items:flex-start;justify-content:center;gap:20px}" +
        "#cg-wrap .cg-heading,#cg-wrap .cg-subheading{flex:0 0 100%;width:100%;text-align:center;margin-left:0;margin-right:0}" +
      "}" +
      // Mobile: stack below
      "@media (max-width:719px){#cg-leaderboard{margin:16px auto 0;max-width:100%;display:block}#cg-wrap{display:block}}";
    document.head.appendChild(s);
  }

  function init() {
    var canvas = document.getElementById('cg-canvas');
    if (!canvas || canvas.dataset.cgInit) return;
    canvas.dataset.cgInit = '1';
    canvas.tabIndex = 0;
    var ctx = canvas.getContext('2d');
    injectRetroStyles();

    // External leaderboard panel — sits beside the canvas on desktop, below on mobile.
    var outerWrap = canvas.parentElement.parentElement; // #cg-wrap
    var leaderPanel = document.createElement('div');
    leaderPanel.id = 'cg-leaderboard';
    leaderPanel.innerHTML =
      '<div class="cg-lb-title">🏆 HIGH SCORES</div>' +
      '<div class="cg-lb-head"><span class="cg-lb-rank">RANK</span><span class="cg-lb-score">SCORE</span><span class="cg-lb-name">NAME</span></div>' +
      '<div class="cg-lb-list"><div class="cg-lb-empty">Play to set a highscore!</div></div>' +
      '<div class="cg-lb-cta">▶ BEAT THE TOP SCORE ◀</div>';
    if (outerWrap) outerWrap.appendChild(leaderPanel);

    function updateLeaderPanel() {
      var hs = loadHS();
      var listEl = leaderPanel.querySelector('.cg-lb-list');
      if (!hs.length) {
        listEl.innerHTML = '<div class="cg-lb-empty">Play to set a highscore!</div>';
        return;
      }
      var html = '';
      // Classic arcade ordinals: 1ST 2ND 3RD 4TH …
      var ORD = ['1ST', '2ND', '3RD', '4TH', '5TH', '6TH', '7TH', '8TH', '9TH', '10TH'];
      for (var i = 0; i < hs.length; i++) {
        var e = hs[i];
        var isCurrent = e.id === currentEntryId;
        var displayName = (e.name && e.name.trim()) || 'Anon';
        // Escape HTML in user-supplied names — basic XSS guard
        displayName = displayName.replace(/[&<>"']/g, function (ch) {
          return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[ch];
        });
        // Zero-padded 6-digit score — the arcade way
        var padded = String(Math.min(999999, e.score));
        while (padded.length < 6) padded = '0' + padded;
        html += '<div class="cg-lb-row cg-lb-r' + (i + 1) + (isCurrent ? ' cg-lb-new' : '') + '">' +
          '<span class="cg-lb-rank">' + (ORD[i] || (i + 1) + '.') + '</span>' +
          '<span class="cg-lb-score">' + padded + '</span>' +
          '<span class="cg-lb-name" title="' + e.date + '">' + displayName + '</span>' +
          '</div>';
      }
      listEl.innerHTML = html;
    }
    updateLeaderPanel();

    // Email capture overlay DOM
    var wrap = canvas.parentElement;
    var emailOverlay = document.createElement('div');
    emailOverlay.id = 'cg-email-overlay';
    emailOverlay.innerHTML =
      '<div class="cg-rank-label">RANG ERREICHT</div>' +
      '<div class="cg-rank-name cg-tier">—</div>' +
      '<div class="cg-score-row"><div><div class="cg-score-lbl">SCORE</div><div class="cg-score cg-pts">0</div></div>' +
      '<div><div class="cg-score-lbl">BEST</div><div class="cg-best">0</div></div></div>' +
      '<div class="cg-stats"></div>' +
      // SIGNUP — name (leaderboard) + email (Klaviyo + discount code)
      '<div class="cg-signup">' +
        '<div class="cg-lb-name-row">' +
          '<label class="cg-lb-name-lbl">DEIN NAME FÜRS LEADERBOARD (max. 10 Zeichen)</label>' +
          '<input class="cg-lb-name-input" type="text" maxlength="10" placeholder="z.B. Hans" autocomplete="off" />' +
          '<div class="cg-lb-name-preview">— Anon aus dem Wurst-Wald</div>' +
        '</div>' +
        '<div class="cg-email-row">' +
          '<label class="cg-email-lbl">EMAIL FÜR DEINEN RABATT-CODE</label>' +
          '<input class="cg-email-input" type="email" placeholder="your@email.com" autocomplete="email" />' +
          '<button class="cg-claim" type="button">🥩 RABATT FREISCHALTEN</button>' +
        '</div>' +
      '</div>' +
      '<div class="cg-share-row"><button class="cg-share" type="button">📸 SHARE</button>' +
      '<button class="cg-play-again" type="button">🔁 NOCHMAL</button></div>' +
      '<button class="cg-skip" type="button">schliessen &rsaquo;</button>' +
      '<div class="cg-msg"></div>' +
      '<div class="cg-watermark">carnivoro.eu · #carnivorocowboy</div>';
    if (wrap) wrap.appendChild(emailOverlay);

    // === Carnivoro Boy mobile controls ===
    var boyControls = document.createElement('div');
    boyControls.id = 'cg-boy-controls';
    // FLAT grid layout — two columns (FIRE | A/B), then the brand mark and
    // START each on their own full-width row. Column-nesting made the shell
    // overflow on real phones (FIRE escaped the case, wordmark got cut off).
    boyControls.innerHTML =
      '<div id="cg-boy-left">' +
        '<button id="cg-boy-fire" type="button" aria-label="Fire">🚀 FIRE</button>' +
      '</div>' +
      '<div class="cg-ab">' +
        '<div><button class="cg-btn-action cg-btn-b" type="button" aria-label="Dash left">B</button><div class="cg-ab-label">DASH ◀</div></div>' +
        '<div><button class="cg-btn-action cg-btn-a" type="button" aria-label="Dash right">A</button><div class="cg-ab-label">DASH ▶</div></div>' +
      '</div>' +
      // OG-style angled brand mark — own centered row so it can never be cut off
      '<div id="cg-boy-brand" aria-hidden="true">' +
        '<span class="cg-brand-text">CARNIVORO COW BOY<i>™</i></span>' +
      '</div>' +
      '<button id="cg-boy-start" type="button">START</button>';
    if (wrap && wrap.parentElement) {
      // Append AFTER the canvas-wrap so controls sit under the "screen"
      wrap.appendChild(boyControls);
    }

    function bindHold(btn, dir) {
      if (!btn) return;
      var press = function (e) {
        if (!audioUnlocked) unlockAudio();
        touchDir = dir;
        btn.classList.add('cg-active');
        e.preventDefault();
      };
      var release = function (e) {
        if (touchDir === dir) touchDir = 0;
        btn.classList.remove('cg-active');
        if (e) e.preventDefault();
      };
      btn.addEventListener('touchstart', press, { passive: false });
      btn.addEventListener('touchend', release, { passive: false });
      btn.addEventListener('touchcancel', release);
      btn.addEventListener('mousedown', press);
      btn.addEventListener('mouseup', release);
      btn.addEventListener('mouseleave', release);
    }
    // (No rocker buttons anymore — bindHold stays for potential future use.)

    function pressStart(e) {
      if (!audioUnlocked) unlockAudio();
      if (phase !== 'playing') startGame();
      if (e) e.preventDefault();
    }

    // 🧃 FIRE — shoots one unit of Bug Juice at Klausebär. Manual trigger via
    // FIRE button (mobile) or Leertaste/F (desktop). 350ms cooldown.
    function fireJuice() {
      if (phase !== 'playing' || !state) return;
      if (!(state.bossActive && state.bossType === 'klaus' && state.klausTransformed)) return;
      var n = performance.now();
      if (n - state.lastFireAt < 350) return;
      state.lastFireAt = n;
      if ((state.bugJuice || 0) <= 0) {
        addPopup(state.cow.x + state.cow.w / 2, state.cow.y - 20, '🧃 LEER — BUGS FANGEN!', false);
        return;
      }
      state.bugJuice--;
      var fcx = state.cow.x + state.cow.w / 2;
      var fcy = state.cow.y - 10;
      state.items.push({
        def: { key: 'juiceshot', emoji: '🧃' },
        good: false,
        x: fcx, y: fcy,
        rot: 0, vr: 0.25,
        deflected: true,
        vy: -19,
        vx: (state.bossX - fcx) / (19 / 0.3)
      });
      addParticles(fcx, fcy, '#7CFC00', 12);
      sfx('power');
    }

    // 🎮 Dash — 250ms speed burst with 600ms cooldown. Direction is forced for the
    // duration, perfect for last-second dodges around Greta's projectiles.
    function tryDash(dir) {
      if (phase !== 'playing') return;
      var now = performance.now();
      if (now < state.dashCooldownUntil) return;
      state.dashUntil = now + 250;
      state.dashCooldownUntil = now + 600;
      state.dashDir = dir;
      // Spark trail at cow's current position
      var cowCx = state.cow.x + state.cow.w / 2;
      var cowCy = state.cow.y + state.cow.h / 2;
      for (var dp = 0; dp < 8; dp++) {
        state.particles.push({
          x: cowCx - dir * (dp * 5),
          y: cowCy + (Math.random() - 0.5) * 8,
          vx: -dir * (1 + Math.random() * 2),
          vy: (Math.random() - 0.5) * 2,
          life: 22,
          color: '#ffd66b'
        });
      }
      sfx('catch');
    }
    // A = dash RIGHT (toward Greta's projectiles), B = dash LEFT
    function handleAButton(e) {
      if (!audioUnlocked) unlockAudio();
      if (phase !== 'playing') { pressStart(e); return; }
      tryDash(1);
      if (e) e.preventDefault();
    }
    function handleBButton(e) {
      if (!audioUnlocked) unlockAudio();
      if (phase !== 'playing') { pressStart(e); return; }
      tryDash(-1);
      if (e) e.preventDefault();
    }
    // Bind both touchstart (instant on mobile) AND click (desktop fallback)
    function bindAction(btn, handler) {
      btn.addEventListener('touchstart', function (e) { handler(e); }, { passive: false });
      btn.addEventListener('click', handler);
    }
    var btnA = boyControls.querySelector('.cg-btn-a');
    var btnB = boyControls.querySelector('.cg-btn-b');
    bindAction(btnA, handleAButton);
    bindAction(btnB, handleBButton);
    // FIRE button — Bug Juice (starts a game when pressed outside of play)
    var btnFire = boyControls.querySelector('#cg-boy-fire');
    if (btnFire) bindAction(btnFire, function (e) {
      if (!audioUnlocked) unlockAudio();
      if (phase !== 'playing') { pressStart(e); return; }
      fireJuice();
      if (e) e.preventDefault();
    });
    boyControls.querySelector('#cg-boy-start').addEventListener('click', pressStart);

    // Toggle cooldown styling on the action buttons every ~100ms
    setInterval(function () {
      if (!state) return;
      var n = performance.now();
      var onCD = phase === 'playing' && n < state.dashCooldownUntil;
      if (btnA) btnA.classList.toggle('cg-cooldown', onCD);
      if (btnB) btnB.classList.toggle('cg-cooldown', onCD);
    }, 100);
    // Use the specific email-input class so we don't grab the name input by accident
    var emailInput = emailOverlay.querySelector('.cg-email-input');
    var emailBtn = emailOverlay.querySelector('.cg-claim');
    var skipBtn = emailOverlay.querySelector('.cg-skip');
    var emailMsg = emailOverlay.querySelector('.cg-msg');
    var ptsEl   = emailOverlay.querySelector('.cg-pts');
    // Local scoring fallback (mirrors assets/loyalty/scoring.js) so the overlay
    // works even if the loyalty bundle hasn't loaded yet.
    function scoreToPoints(raw) {
      if (!isFinite(raw) || raw < 0) raw = 0;
      var FLOOR = 100, CAP = 800, K = 2000, MAX = 20000;
      var lp = FLOOR + (CAP - FLOOR) * Math.log(1 + raw / K) / Math.log(1 + MAX / K);
      return Math.min(CAP, Math.max(FLOOR, Math.round(lp / 50) * 50));
    }

    // Draw the cow portrait (used on the end screen + share image).
    // Composed entirely with emoji + canvas primitives so no external assets
    // are required. Mask + tinfoil-hat overlay if collected during the game.
    function drawCowPortrait(c, opts) {
      var w = c.canvas.width, h = c.canvas.height;
      c.clearRect(0, 0, w, h);
      // Pedestal / vignette
      var g = c.createRadialGradient(w/2, h*0.7, 6, w/2, h*0.7, w*0.6);
      g.addColorStop(0, 'rgba(201,161,114,0.16)');
      g.addColorStop(1, 'rgba(0,0,0,0)');
      c.fillStyle = g;
      c.fillRect(0, 0, w, h);
      // Cow body — big chunky emoji
      var cx = w / 2, cy = h * 0.55;
      c.textAlign = 'center';
      c.textBaseline = 'middle';
      c.font = '108px "Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif';
      c.fillText('🐄', cx, cy);
      // Tinfoil hat — pointy crinkled triangle above the cow's head
      if (opts && opts.wearsTinfoil) {
        var hatY = cy - 52;
        c.save();
        c.fillStyle = '#c8ccd0';
        c.strokeStyle = '#7a7e84';
        c.lineWidth = 2;
        c.beginPath();
        c.moveTo(cx - 28, hatY + 8);
        c.lineTo(cx + 28, hatY + 8);
        c.lineTo(cx + 14, hatY - 26);
        c.lineTo(cx + 4,  hatY - 14);
        c.lineTo(cx - 6,  hatY - 24);
        c.lineTo(cx - 18, hatY - 12);
        c.closePath();
        c.fill();
        c.stroke();
        // Sparkle
        c.fillStyle = '#fff';
        c.font = '14px sans-serif';
        c.fillText('✨', cx + 22, hatY - 22);
        c.restore();
      }
      // Mask — white rectangle with strap lines across cow's snout area
      if (opts && opts.wearsMask) {
        c.save();
        var mx = cx, my = cy + 14;
        c.fillStyle = '#f2f3f5';
        c.strokeStyle = '#b9bcc1';
        c.lineWidth = 1.5;
        c.beginPath();
        c.moveTo(mx - 30, my - 6);
        c.quadraticCurveTo(mx, my - 14, mx + 30, my - 6);
        c.lineTo(mx + 30, my + 14);
        c.quadraticCurveTo(mx, my + 22, mx - 30, my + 14);
        c.closePath();
        c.fill();
        c.stroke();
        // Pleats
        c.strokeStyle = '#cdd0d4';
        c.beginPath();
        c.moveTo(mx - 26, my + 2); c.lineTo(mx + 26, my + 2);
        c.moveTo(mx - 26, my + 8); c.lineTo(mx + 26, my + 8);
        c.stroke();
        // Ear loops
        c.strokeStyle = '#888';
        c.lineWidth = 1.2;
        c.beginPath();
        c.moveTo(mx - 30, my - 2); c.lineTo(mx - 42, my - 12);
        c.moveTo(mx + 30, my - 2); c.lineTo(mx + 42, my - 12);
        c.stroke();
        c.restore();
      }
    }

    // Sardonic methane-comparison lines — picked at random per end screen.
    // Each one reframes "cow methane" as obviously trivial vs the things
    // actually being celebrated. Pure carnivore-influencer talking points.
    var METHANE_QUIPS = [
      'Klima gerettet? 🤷',
      '≈ 1 Avocado aus Mexiko',
      '≈ 1 Greta-Bootsreise',
      'zerfällt in 10 Jahren',
      '< 1 Bohneneintopf',
      '< 0,0001% einer COP-Konferenz',
      '< 1 ICE-Fahrt',
      '= 1 Sojaschnitzel-Charge',
      'das war’s. Kein Kollaps.',
      'irrelevant. Aber nett.'
    ];

    // Build the human-readable Combat Summary table.
    // Rows that are zero get hidden so the table never looks empty/sad.
    function renderStatsTable(stats, planetTemp) {
      stats = stats || {};
      var co2 = (planetTemp * 0.42).toFixed(1);
      // Methane in grams — same formula scale, different unit for ironic specificity
      var methaneG = (planetTemp * 0.42).toFixed(1);
      var quip = METHANE_QUIPS[Math.floor(Math.random() * METHANE_QUIPS.length)];
      var rows = [
        ['🧪 Seed oil hits',       stats.seedOilHits,                 stats.seedOilHits > 0],
        ['🦠 Klebers survived',    stats.klebersSurvived,             stats.klebersSurvived > 0],
        ['🍅 Klebers soup-thrown', stats.klebersTomatoed,             stats.klebersTomatoed > 0],
        ['✈️ Chemtrail hits',      stats.chemtrailHits,               stats.chemtrailHits > 0],
        ['🌍 Personal CO₂',                       co2 + ' Tonnen',           planetTemp > 0],
        ['🌡 Erde erwärmt um',                    degreesRaised(planetTemp), planetTemp > 0],
        ['💨 Methan <i style="opacity:0.7;font-size:9px">(' + quip + ')</i>', methaneG + 'g', planetTemp > 0]
      ];
      var html = '';
      var shown = 0;
      for (var i = 0; i < rows.length; i++) {
        if (!rows[i][2]) continue;
        html += '<div class="cg-stat-row"><span>' + rows[i][0] + '</span><b>' + rows[i][1] + '</b></div>';
        shown++;
      }
      // Fallback so the panel never collapses to empty if a player rage-quits
      if (shown === 0) {
        html = '<div class="cg-stat-row" style="justify-content:center"><span>Schlachtfeld leer. Keine Wirkung.</span></div>';
      }
      return html;
    }

    function pickLiner() {
      return END_LINERS[Math.floor(Math.random() * END_LINERS.length)];
    }

    // Discount tier — boss-based (clear narrative progression):
    //   Tetra besiegt      → 10%
    //   Klausebär besiegt  → 12%
    //   Gill Bates besiegt → 15%
    //   Neuer Highscore (≥ 1.500 Punkte) → 20%
    function computeDiscountTier(gd) {
      // 20% is RESERVED for a fresh personal-best run (score must be meaningful).
      if (gd.isNewPB && gd.rawScore >= 1500) return 20;
      var base = 0;
      if (gd.bossWon)  base = 10;
      if (gd.boss2Won) base = 12;
      if (gd.boss3Won) base = 15;
      return base;
    }
    function tierCopy(pct, isNewPB) {
      if (pct === 0)  return 'Besiege den <b>ersten Boss</b> um 10% freizuschalten. Nochmal?';
      if (pct === 20) return '<b>NEUER HIGHSCORE — 20% freigeschaltet!</b>';
      if (pct === 15) return '<b>ALLE 3 BOSSE BESIEGT — 15% gesichert.</b>';
      if (pct === 12) return '<b>2 BOSSE BESIEGT — 12% gesichert.</b>';
      return '<b>TETRA BESIEGT — 10% gesichert.</b>';
    }
    // Convert planetTemp → degrees raised, using same thresholds as in-game alerts
    function degreesRaised(planetTemp) {
      if (planetTemp >= 16) return '+5.0°C';
      if (planetTemp >= 12) return '+4.0°C';
      if (planetTemp >= 8)  return '+3.0°C';
      if (planetTemp >= 5)  return '+2.0°C';
      if (planetTemp >= 3)  return '+1.5°C';
      if (planetTemp >= 1)  return '+0.5°C';
      return '0°C';
    }

    // Pin the overlay to the canvas ("screen") area — on mobile the BULLBOY
    // shell has thick gold padding, and inset:3px would cover the whole shell.
    function positionOverlayToScreen() {
      if (!emailOverlay || !canvas) return;
      var cs = window.getComputedStyle(canvas);
      emailOverlay.style.left = canvas.offsetLeft + 'px';
      emailOverlay.style.top = canvas.offsetTop + 'px';
      emailOverlay.style.width = canvas.offsetWidth + 'px';
      emailOverlay.style.height = canvas.offsetHeight + 'px';
      emailOverlay.style.right = 'auto';
      emailOverlay.style.bottom = 'auto';
      emailOverlay.style.borderRadius = cs.borderRadius || '4px';
    }
    window.addEventListener('resize', function () {
      if (emailOverlay && emailOverlay.classList.contains('active')) positionOverlayToScreen();
    });

    function showEmailOverlay() {
      if (!state || !state.gameData) return;
      positionOverlayToScreen();
      // Victory ending (all 3 bosses beaten) gets a special header + outro
      var labelEl = emailOverlay.querySelector('.cg-rank-label');
      if (labelEl) {
        labelEl.innerHTML = state.gameData.victory
          ? '🏆 GLÜCKWUNSCH — ALLE BOSSE BESIEGT! 15% GESICHERT!<br><span style="letter-spacing:0.3em;font-size:11px;color:' + CI.gold + '">TO BE CONTINUED …</span><br><span style="font-size:9px">Danke fürs Spielen!</span>'
          : 'RANG ERREICHT';
      }
      // Rank
      var rankEl = emailOverlay.querySelector('.cg-rank-name');
      rankEl.textContent = state.gameData.rankName || '—';
      // Score / best
      ptsEl.textContent = state.gameData.rawScore;
      var bestEl = emailOverlay.querySelector('.cg-best');
      if (bestEl) bestEl.textContent = state.best || state.gameData.rawScore;
      // Combat Summary stats
      var statsEl = emailOverlay.querySelector('.cg-stats');
      if (statsEl) statsEl.innerHTML = renderStatsTable(state.gameData.stats, state.gameData.planetTemp);

      // Pre-fill the leaderboard name input from localStorage + rotate placeholder
      var nameInputEl = emailOverlay.querySelector('.cg-lb-name-input');
      var namePreviewEl = emailOverlay.querySelector('.cg-lb-name-preview');
      if (nameInputEl) {
        var last = '';
        try { last = localStorage.getItem(NAME_KEY) || ''; } catch (e) {}
        nameInputEl.value = last;
        nameInputEl.placeholder = 'z.B. ' + FALLBACK_NAMES[Math.floor(Math.random() * FALLBACK_NAMES.length)];
        nameInputEl.classList.remove('cg-err');
        if (namePreviewEl) namePreviewEl.textContent = '— ' + fullName(last);
        // Also seed the current entry's name with the composed form
        if (currentEntryId) {
          for (var ni = 0; ni < highscores.length; ni++) {
            if (highscores[ni].id === currentEntryId) {
              highscores[ni].name = fullName(last);
              break;
            }
          }
          saveHS(highscores);
          updateLeaderPanel();
        }
      }

      // Reset email widget state — clear stale error, keep prior email if any
      emailMsg.textContent = '';
      emailMsg.classList.remove('cg-err');
      if (emailInput) {
        var prevEmail = '';
        try { prevEmail = localStorage.getItem('cg_last_email') || ''; } catch (e) {}
        emailInput.value = prevEmail;
        emailInput.classList.remove('cg-err');
      }
      if (emailBtn) {
        emailBtn.disabled = false;
        // Tailor the CTA label based on the discount tier earned
        var ctaTier = state.gameData && state.gameData.discountTier;
        if (ctaTier > 0) emailBtn.textContent = '🥩 ' + ctaTier + '% RABATT FREISCHALTEN';
        else emailBtn.textContent = '🥩 NEWSLETTER ABONNIEREN';
      }
      emailOverlay.classList.add('active');
    }
    function hideEmailOverlay() { emailOverlay.classList.remove('active'); }

    // === Share image generator ============================================
    // Renders a 1080x1350 (4:5) IG-ready PNG and either invokes the native
    // share sheet (mobile) or triggers a file download (desktop).
    function generateShareImage() {
      if (!state || !state.gameData) return null;
      var SW = 1080, SH = 1350;
      var off = document.createElement('canvas');
      off.width = SW; off.height = SH;
      var c = off.getContext('2d');
      c.textAlign = 'center';
      c.textBaseline = 'middle';

      // === BACKGROUND: boss-fight screenshot (cover-scaled), fallback = final frame
      var src = bossSnapCanvas || canvas;
      try {
        var scale = Math.max(SW / src.width, SH / src.height);
        var dw = src.width * scale, dh = src.height * scale;
        // Disable smoothing for that crisp pixel-game look at 2.5x
        c.imageSmoothingEnabled = false;
        c.drawImage(src, (SW - dw) / 2, (SH - dh) / 2, dw, dh);
        c.imageSmoothingEnabled = true;
      } catch (e) {
        c.fillStyle = CI.bg;
        c.fillRect(0, 0, SW, SH);
      }
      // Legibility gradient — dark top and bottom, screenshot shines mid-frame
      var g1 = c.createLinearGradient(0, 0, 0, SH);
      g1.addColorStop(0,    'rgba(12, 11, 15, 0.88)');
      g1.addColorStop(0.30, 'rgba(12, 11, 15, 0.30)');
      g1.addColorStop(0.55, 'rgba(12, 11, 15, 0.30)');
      g1.addColorStop(0.78, 'rgba(12, 11, 15, 0.86)');
      g1.addColorStop(1,    'rgba(12, 11, 15, 0.94)');
      c.fillStyle = g1;
      c.fillRect(0, 0, SW, SH);

      // === TOP BLOCK: label + rank (fixed zone 70–420, never collides below)
      c.fillStyle = CI.cream;
      c.font = '700 26px -apple-system, Helvetica, Arial';
      c.fillText('RANG ERREICHT', SW / 2, 84);
      var rank = state.gameData.rankName || '—';
      var rankFontSize = rank.length < 40 ? 46
                       : rank.length < 90 ? 36
                       : 26;
      c.fillStyle = CI.gold;
      c.font = '800 ' + rankFontSize + 'px -apple-system, Helvetica, Arial';
      var rankLineH = Math.round(rankFontSize * 1.25);
      var rankLines = wrapTextLines(c, rank, SW - 100);
      if (rankLines.length > 6) rankLines = rankLines.slice(0, 6);
      var rankTop = 140;
      for (var li = 0; li < rankLines.length; li++) {
        c.fillText(rankLines[li], SW / 2, rankTop + li * rankLineH);
      }

      // === BOTTOM BLOCK: fixed slots, generous spacing, zero overlap
      // Player name
      var rawName = '';
      try { rawName = (localStorage.getItem(NAME_KEY) || '').trim(); } catch (e) {}
      if (rawName) {
        c.fillStyle = CI.cream;
        c.font = 'italic 700 34px -apple-system, Helvetica, Arial';
        c.fillText('— ' + fullName(rawName) + ' —', SW / 2, 985);
      }
      // Score — the hero number
      c.fillStyle = CI.cream;
      c.font = '800 104px -apple-system, Helvetica, Arial';
      c.fillText(String(state.gameData.rawScore), SW / 2, 1075);
      c.fillStyle = 'rgba(246, 216, 180, 0.65)';
      c.font = '700 24px -apple-system, Helvetica, Arial';
      c.fillText('SCORE', SW / 2, 1136);
      // Challenge line
      c.fillStyle = CI.gold;
      c.font = '700 32px -apple-system, Helvetica, Arial';
      c.fillText('Schaffst du mehr?', SW / 2, 1192);
      // IG handle — the share hook
      c.fillStyle = CI.gold;
      c.font = '800 42px -apple-system, Helvetica, Arial';
      c.fillText('@carnivoro.eu', SW / 2, 1256);
      // Hashtag footer
      c.fillStyle = 'rgba(246, 216, 180, 0.5)';
      c.font = '700 20px -apple-system, Helvetica, Arial';
      c.fillText('CARNIVORO.EU  ·  #CARNIVOROCOWBOY', SW / 2, 1310);
      return off;
    }

    function wrapTextLines(c, text, maxWidth) {
      var words = String(text).split(' ');
      var line = '';
      var lines = [];
      for (var i = 0; i < words.length; i++) {
        var test = line ? line + ' ' + words[i] : words[i];
        if (c.measureText(test).width > maxWidth && line) {
          lines.push(line);
          line = words[i];
        } else {
          line = test;
        }
      }
      if (line) lines.push(line);
      return lines;
    }
    function wrapText(c, text, x, y, maxWidth, lineH) {
      var lines = wrapTextLines(c, text, maxWidth);
      if (lines.length > 14) lines = lines.slice(0, 14);
      var startY = y - ((lines.length - 1) * lineH) / 2;
      for (var j = 0; j < lines.length; j++) {
        c.fillText(lines[j], x, startY + j * lineH);
      }
    }

    function sharePng() {
      var img = generateShareImage();
      if (!img) return;
      img.toBlob(function (blob) {
        if (!blob) return;
        var fname = 'cowboy-' + (state.gameData.rawScore || 0) + '.png';
        var file = new File([blob], fname, { type: 'image/png' });
        // Native share sheet on mobile
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          navigator.share({
            files: [file],
            title: 'Carnivoro Cow Sim',
            text: 'Ich bin jetzt offiziell "' + state.gameData.rankName + '" 🐄 Score: ' + state.gameData.rawScore + '. Schaffst du mehr? 👉 @carnivoro.eu'
          }).catch(function () { downloadBlob(blob, fname); });
        } else {
          downloadBlob(blob, fname);
        }
      }, 'image/png');
    }
    function downloadBlob(blob, name) {
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url; a.download = name;
      document.body.appendChild(a); a.click();
      setTimeout(function () { document.body.removeChild(a); URL.revokeObjectURL(url); }, 200);
    }

    function submitEmail() {
      if (!emailInput) return;
      var email = (emailInput.value || '').trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        emailMsg.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.';
        emailMsg.classList.add('cg-err');
        emailInput.classList.add('cg-err');
        emailInput.focus();
        return;
      }
      try { localStorage.setItem('cg_last_email', email); } catch (e) {}
      emailBtn.disabled = true;
      emailMsg.classList.remove('cg-err');
      emailMsg.textContent = 'submitting...';
      var submitter = (window.CarnivoroSubmit && window.CarnivoroSubmit.submitGameResult);
      var p;
      if (submitter) {
        p = submitter(email, state.gameData.rawScore, state.gameData);
      } else {
        // Fallback when the loyalty bundle isn't on the page yet
        try { console.log('[carnivoro loyalty fallback]', { email: email, gameData: state.gameData }); } catch (e) {}
        p = Promise.resolve({ points: scoreToPoints(state.gameData.rawScore), tier_unlocked: null, verified: true });
      }
      Promise.resolve(p).then(function (res) {
        if (res && res.verified) {
          var pct = (state.gameData && state.gameData.discountTier) || 10;
          // HYBRID code delivery:
          //   10/12% → static code shown instantly (instant gratification;
          //            low-value, new-customer-gated, 1× per customer).
          //   15/20% → NO code in-game. A unique single-use code is emailed
          //            via the Klaviyo flow (trigger: 'Carnivoro Game
          //            Completed', split on discount_tier). Unique codes are
          //            worthless to coupon sites — that's the point.
          var codeMap = { 10: 'RIBEYE-K4M9', 12: 'BRISKET-X7T2' };
          if (pct >= 15) {
            emailMsg.innerHTML = '✅ <b>' + pct + '% GESICHERT!</b> Dein <b>persönlicher Einmal-Code</b> ist unterwegs — check dein Postfach! 📧<br>' +
              'Teile deinen Rang auf Instagram &rarr; <b>@carnivoro.eu</b> 👇';
          } else {
            var theCode = codeMap[pct] || 'RIBEYE-K4M9';
            // Overlay STAYS OPEN — pivot the moment into an IG share prompt.
            emailMsg.innerHTML = '✅ DEIN CODE: <b style="font-size:14px;letter-spacing:0.08em">' + theCode + '</b> (' + pct + '%)<br>' +
              'Teile deinen Rang auf Instagram &rarr; <b>@carnivoro.eu</b> 👇';
          }
          // Make the share button pulse so the eye lands on it
          var shareBtnEl = emailOverlay.querySelector('.cg-share');
          if (shareBtnEl) {
            shareBtnEl.style.animation = 'cgSharePulse 1s ease-in-out infinite';
            if (!document.getElementById('cg-share-pulse-style')) {
              var ps = document.createElement('style');
              ps.id = 'cg-share-pulse-style';
              ps.textContent = '@keyframes cgSharePulse{0%,100%{transform:scale(1);box-shadow:0 0 0 0 rgba(201,161,114,0.6)}50%{transform:scale(1.06);box-shadow:0 0 0 8px rgba(201,161,114,0)}}';
              document.head.appendChild(ps);
            }
          }
        } else {
          emailBtn.disabled = false;
          emailMsg.classList.add('cg-err');
          emailMsg.textContent = (res && res.errors && res.errors[0]) || 'submission failed';
        }
      });
    }

    var playAgainBtn = emailOverlay.querySelector('.cg-play-again');
    var shareBtn = emailOverlay.querySelector('.cg-share');
    var nameInput = emailOverlay.querySelector('.cg-lb-name-input');
    emailBtn.addEventListener('click', submitEmail);
    playAgainBtn.addEventListener('click', function () { hideEmailOverlay(); pressStart(); });
    if (shareBtn) shareBtn.addEventListener('click', sharePng);
    skipBtn.addEventListener('click', hideEmailOverlay);

    // Leaderboard name — live update entry + suffix preview as user types
    var namePreview = emailOverlay.querySelector('.cg-lb-name-preview');
    function refreshNamePreview(raw) {
      if (!namePreview) return;
      namePreview.textContent = '— ' + fullName(raw);
    }
    if (nameInput) {
      nameInput.addEventListener('input', function () {
        var raw = (nameInput.value || '').trim().slice(0, 10);
        if (raw && !isCleanName(raw)) {
          nameInput.classList.add('cg-err');
          return;
        }
        nameInput.classList.remove('cg-err');
        try { localStorage.setItem(NAME_KEY, raw); } catch (e) {}
        var composed = fullName(raw);
        refreshNamePreview(raw);
        if (currentEntryId) {
          for (var i = 0; i < highscores.length; i++) {
            if (highscores[i].id === currentEntryId) {
              highscores[i].name = composed;
              break;
            }
          }
          saveHS(highscores);
          updateLeaderPanel();
        }
      });
      nameInput.addEventListener('keydown', function (e) {
        e.stopPropagation();
        // Enter on name → focus the email field next, don't submit yet
        if (e.key === 'Enter' && emailInput) {
          e.preventDefault();
          emailInput.focus();
        }
      });
    }
    // Email field — Enter submits, typing clears the error border
    if (emailInput) {
      emailInput.addEventListener('input', function () { emailInput.classList.remove('cg-err'); });
      emailInput.addEventListener('keydown', function (e) {
        e.stopPropagation();
        if (e.key === 'Enter') { e.preventDefault(); submitEmail(); }
      });
    }
    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submitEmail(); }
      e.stopPropagation();
    });

    var state;
    var keys = {};
    var lastTime = 0;
    var running = false;
    var phase = 'start'; // start, playing, over
    var highscores = loadHS();
    var currentEntryId = null;

    function resetState() {
      state = {
        cow: { x: W / 2 - 27, y: GROUND_Y - 44, w: 54, h: 44, baseW: 54, baseH: 44, vx: 0 },
        items: [],
        popups: [],
        particles: [],
        score: 0,
        level: 0,
        xp: 0,
        hp: 100,
        maxHp: 100,
        streak: 0,
        maxStreak: 0,
        itemsCaught: 0,
        itemsMissed: 0,
        startedAt: performance.now(),
        best: highscores.length ? highscores[0].score : 0,
        carnivoroUntil: 0,
        butterUntil: 0,
        shieldUntil: 0,
        shieldHits: 0,
        fiberUntil: 0,
        tofuUntil: 0,
        veganUntil: 0,
        fartUntil: 0,
        nauseaUntil: 0,
        healFlash: 0,
        poisonUntil: 0,
        poisonTick: 0,
        testiclesUntil: 0,
        growth: 1,
        overheatUntil: 0,
        starUntil: 0,
        shroomUntil: 0,
        planetTemp: 0,
        lastClimateAlert: -1,
        status: { text: '', until: 0 },
        lastSpawn: 0,
        xpFlash: 0,
        gameData: null,
        // Cosmetic flags — persist to end-screen cow portrait
        wearsMask: false,
        wearsTinfoil: false,
        // New debuff/buff timers
        inflamedUntil: 0,    // seed oil — slows cow, drains HP
        inflamedTick: 0,
        maskUntil: 0,        // mask stuck on face — muffled audio + blurry
        maskTaps: 0,         // tap counter to remove mask early (need 3)
        tinfoilUntil: 0,     // tinfoil hat active — protects from chemtrails
        chemtrailUntil: 0,   // chemtrail debuff — control flip
        // Klima Kleber entity (single instance at a time, null when none)
        kleber: null,        // { x, signIdx, spawnedAt, copAt, tomatoTaps, gone }
        nextKleberAt: 0,
        // EAT ZE BUGS event
        bugEventUntil: 0,    // when active, BAD spawns become crickets
        nextBugEventAt: 0,
        bugsRefusedThisEvent: 0,
        // Chemtrail plane
        plane: null,         // { x, y, dir, hasReleased }
        nextChemtrailAt: 0,
        // Screen-shake + red-flash counters (decrement per frame)
        shakeFrames: 0,
        dangerFlash: 0,
        // 🎮 Dash mechanic — A button (right) / B button (left) on mobile
        dashUntil: 0,
        dashCooldownUntil: 0,
        dashDir: 0,
        // Bullet-time / slow-mo — triggered when something cool happens.
        // Falling items slow down; cow input stays normal so it feels cinematic
        // without becoming sluggish to control.
        slomoUntil: 0,
        slomoDuration: 0,
        slomoDepth: 0.35,
        slomoHold: 0,
        _defHitL: false,       // Klaus death-crash choreography flags
        _defHitR: false,
        // === Boss state (used for Greta, Klaus, and Dr. Windows) ===
        bossType: 'greta',     // 'greta' | 'klaus' | 'gates'
        bossActive: false,
        bossEnteredAt: 0,
        bossWalkInUntil: 0,
        bossIntros: [],
        bossUntil: 0,
        bossHp: BOSS_HP_MAX,
        bossHpMax: BOSS_HP_MAX,  // per-boss max (Klausebär gets 2×)
        bossSpawned: false,
        boss2Spawned: false,   // Klaus has spawned (once-per-game)
        boss2SpawnAt: 0,
        boss3Spawned: false,   // Dr. Windows has spawned (once-per-game)
        boss3SpawnAt: 0,
        bossX: 0,
        // Transformer mechanic — collected during Klaus fight, persists into Dr. Windows fight
        klausParts: 0,         // 0-5 spaceship parts collected
        klausPartsDropped: 0,  // parts Klaus has lost via tower crashes
        nextCrashOkAt: 0,      // crash cooldown
        klausTransformed: false,// cow sits in the BUG-JUICE spaceship
        bugJuice: 0,           // 0-5 tank fill — ammo, fired via FIRE button
        lastFireAt: 0,
        proteinCount: 0,       // legacy counter (unused)
        disksCollected: 0,     // Gates fight: disks fed into the virus upload bar
        nextPartAt: 6,         // next part drop after N throws
        // 🍽 Hunger + endless mode
        lastAteAt: performance.now(),
        hungerTick: 0,
        hungerWarned: false,
        endlessStartAt: 0,
        victoryEnding: false,  // legacy (unused — Gates always escapes)
        gatesEscaping: false,  // Skeletor-style exit in progress
        gatesEscapeAt: 0,
        gatesWaveAt: 0,        // ID4 moment: the big wave that knocks the laptop loose
        gatesWaveDropped: false,
        bossLastThrowAt: 0,
        bossQuoteIdx: 0,
        bossThrowCount: 0,     // how many projectiles thrown this fight
        bossPhase: 'idle',     // 'idle' | 'walkin' | 'phase1' | 'phase2' | 'defeated'
        nextRacketAt: BOSS_THROWS_BEFORE_RACKET, // throw # to drop racket next
        throwsSinceLastBall: 0, // counter for tennis ball injection in phase 2
        nextBallAt: 5,          // next ball after this many throws (5-10 random)
        racketDropped: false,  // racket has been thrown into play
        hasRacket: false,      // cow has picked up the racket
        bossSpeech: '',        // current floating speech bubble text
        bossSpeechUntil: 0,    // when the speech bubble fades
        bossDefeated: false,
        bossDefeatedAt: 0,
        // Stat counters for the Combat Summary on the end screen
        stats: {
          bugsRefused: 0,
          bugsEaten: 0,
          masksDodged: 0,
          masksWorn: 0,
          klebersSurvived: 0,
          klebersTomatoed: 0,
          seedOilHits: 0,
          chemtrailHits: 0,
          tinfoilsWorn: 0,
          touchedGrass: 0
        }
      };
    }

    function currentLevel() { return LEVELS[state.level]; }

    function addStatus(text, ms) {
      state.status.text = text;
      state.status.until = performance.now() + (ms || 1800);
    }

    function addParticles(x, y, color, n) {
      for (var i = 0; i < n; i++) {
        state.particles.push({
          x: x, y: y,
          vx: (Math.random() - 0.5) * 4,
          vy: -Math.random() * 4 - 1,
          life: 30,
          color: color
        });
      }
    }

    function addPopup(x, y, text, gold) {
      state.popups.push({ x: x, y: y, text: text, life: 50, gold: !!gold });
    }

    function spawnItem() {
      var now = performance.now();
      var elapsed = now - state.startedAt;
      var grace = elapsed < 2500;
      var goodRoll = grace ? true : (Math.random() < (0.60 - state.level * 0.015));
      var def;

      // During EAT ZE BUGS event: ALL bad spawns become crickets
      if (!goodRoll && now < state.bugEventUntil) {
        def = BUG;
      } else if (goodRoll) {
        // While poisoned, 40% of good spawns become electrolytes (the antidote).
        if (now < state.poisonUntil && Math.random() < 0.40) {
          def = ELECTROLYTES;
        } else {
          var roll = Math.random();
          if (roll < 0.05) def = STAR;
          else if (roll < 0.10) def = SHROOM;
          else def = weightedPick(GOOD);
        }
      } else {
        // Phase-gated injections: mask + seed oil mixed into bad pool
        var badRoll = Math.random();
        if (elapsed > PHASE_AT.mask && badRoll < 0.10) {
          def = MASK;
        } else if (elapsed > PHASE_AT.seedOil && badRoll < 0.25) {
          def = SEED_OIL;
        } else {
          def = weightedPick(BAD);
        }
      }
      state.items.push({
        def: def,
        good: goodRoll || !!def.antidote,
        x: 20 + Math.random() * (W - 40),
        y: -30,
        rot: (Math.random() - 0.5) * 0.4,
        vr: (Math.random() - 0.5) * 0.04
      });
    }

    // Trigger bullet-time. ms = duration; depth = starting time-scale
    // (0.35 default; 0.1 = dramatic 90% slowdown); holdFrac = fraction of the
    // duration to STAY at depth before ramping back up (story-beat profile:
    // one second clearly slow, then one second accelerating to normal).
    function triggerSlomo(ms, depth, holdFrac) {
      var n = performance.now();
      // Don't shorten an already-active slomo
      if (state.slomoUntil - n < ms) {
        state.slomoUntil = n + ms;
        state.slomoDuration = ms;
        state.slomoDepth = depth || 0.35;
        state.slomoHold = holdFrac || 0;
      }
    }
    // Returns time-scale factor (depth → hold → ramp to 1.0).
    function currentTimeScale(now) {
      if (now >= state.slomoUntil) return 1;
      var d = state.slomoDepth || 0.35;
      var hold = state.slomoHold || 0;
      var progress = 1 - (state.slomoUntil - now) / state.slomoDuration; // 0 → 1
      if (progress < hold) return d;
      var ease = (progress - hold) / Math.max(0.0001, 1 - hold);
      return d + (1 - Math.pow(1 - ease, 3)) * (1 - d);
    }

    // === Event spawners (Klima Kleber, EAT ZE BUGS, chemtrails) =========
    function maybeSpawnKleber(now) {
      var elapsed = now - state.startedAt;
      if (elapsed < PHASE_AT.kleber) return;
      if (state.kleber) return; // one at a time
      if (now < state.nextKleberAt) return;
      // Schedule first one ~5s after phase opens, then every 75-100s
      if (!state.nextKleberAt) {
        state.nextKleberAt = now + 5000;
        return;
      }
      state.kleber = {
        x: 60 + Math.random() * (W - 120),
        signIdx: Math.floor(Math.random() * KLEBER_SIGNS.length),
        spawnedAt: now,
        copAt: 0,
        tomatoTaps: 0,
        gone: false
      };
      addStatus('🦠 KLIMA-KLEBER GESICHTET', 1800);
      triggerSlomo(1800);
      state.nextKleberAt = now + (75000 + Math.random() * 25000);
    }
    function maybeSpawnBugEvent(now) {
      var elapsed = now - state.startedAt;
      if (elapsed < PHASE_AT.bugsEvent) return;
      if (now < state.bugEventUntil) return;
      if (!state.nextBugEventAt) {
        state.nextBugEventAt = now + 3000;
        return;
      }
      if (now < state.nextBugEventAt) return;
      state.bugEventUntil = now + 5000;
      state.bugsRefusedThisEvent = 0;
      addStatus('⚠ WEF FOOD UPDATE — EAT ZE BUGS', 2400);
      triggerSlomo(1800);
      state.nextBugEventAt = now + (50000 + Math.random() * 25000);
    }
    function maybeSpawnBoss3(now) {
      if (state.boss3Spawned) return;
      if (phase !== 'playing') return;
      if (state.bossActive) return;
      if (!state.boss3SpawnAt || now < state.boss3SpawnAt) return;
      state.boss3Spawned = true;
      state.bossType = 'gates';
      state.bossActive = true;
      state.bossSpawned = true;
      state.bossEnteredAt = now;
      state.bossWalkInUntil = now + BOSS_WALK_IN_MS;
      state.bossUntil = now + BOSS_MAX_DURATION;
      state.bossHp = BOSS_HP_MAX;
      state.bossX = W + 80;
      state.bossLastThrowAt = state.bossWalkInUntil;
      state.bossThrowCount = 0;
      // Phase 1 = dodge only; after ~8 throws a wave knocks Bill's laptop
      // overboard — catching it unlocks DEBUG MODE (phase 2).
      state.bossPhase = 'phase1';
      state.nextRacketAt = BOSS_THROWS_BEFORE_RACKET;
      state.racketDropped = false;
      state.hasRacket = false;
      state.disksCollected = 0;
      state.bossDefeated = false;
      state.bossQuoteIdx = 0;
      state.items = [];
      // Shuffle Gates intros
      var shuf3 = BOSS3_INTROS.slice();
      for (var sh3 = shuf3.length - 1; sh3 > 0; sh3--) {
        var j3 = Math.floor(Math.random() * (sh3 + 1));
        var tmp3 = shuf3[sh3]; shuf3[sh3] = shuf3[j3]; shuf3[j3] = tmp3;
      }
      state.bossIntros = shuf3.slice(0, BOSS_INTRO_QUOTES);
      addStatus('⚠ BOSS — GILL BATES ⚠', 3500);
      triggerSlomo(3500);
      try { startBossMusic(); } catch (e) {}
    }

    function maybeSpawnBoss2(now) {
      if (state.boss2Spawned) return;
      if (phase !== 'playing') return;
      if (state.bossActive) return; // wait for Greta cleanup
      if (!state.boss2SpawnAt || now < state.boss2SpawnAt) return;
      state.boss2Spawned = true;
      // Reuse boss state for Klaus — full reset
      state.bossType = 'klaus';
      state.bossActive = true;
      state.bossSpawned = true; // mark so phase gates don't double-spawn
      state.bossEnteredAt = now;
      state.bossWalkInUntil = now + BOSS_WALK_IN_MS;
      state.bossUntil = now + BOSS_MAX_DURATION;
      state.bossHpMax = BOSS_HP_MAX * 2; // Klausebär is twice as tough
      state.bossHp = state.bossHpMax;
      state.bossX = W + 80;
      state.bossLastThrowAt = state.bossWalkInUntil;
      state.bossThrowCount = 0;
      state.bossPhase = 'walkin';
      state.nextRacketAt = BOSS_THROWS_BEFORE_RACKET;
      state.racketDropped = false;
      state.hasRacket = false;
      state.throwsSinceLastBall = 0;
      state.nextBallAt = 5 + Math.floor(Math.random() * 6);
      state.bossDefeated = false;
      state.bossQuoteIdx = 0;
      // Clear in-flight so Klaus's arrival is clean
      state.items = [];
      // His iconic line ALWAYS opens the intro; the rest is shuffled
      var iconic = BOSS2_INTROS[0]; // 'YOU VILL OWN NOTHING AND BE HAPPY!'
      var shuf = BOSS2_INTROS.slice(1);
      for (var sh = shuf.length - 1; sh > 0; sh--) {
        var jj = Math.floor(Math.random() * (sh + 1));
        var tmp2 = shuf[sh]; shuf[sh] = shuf[jj]; shuf[jj] = tmp2;
      }
      state.bossIntros = [iconic].concat(shuf.slice(0, BOSS_INTRO_QUOTES - 1));
      addStatus('⚠ BOSS — DAVOS KLAUSEBÄR ⚠', 3500);
      triggerSlomo(3500);
      try { startBossMusic(); } catch (e) {}
    }

    function maybeSpawnBoss(now) {
      if (state.bossSpawned) return;
      if (phase !== 'playing') return;
      if (now - state.startedAt < BOSS_AT) return;
      state.bossSpawned = true;
      state.bossActive = true;
      state.bossEnteredAt = now;
      state.bossWalkInUntil = now + BOSS_WALK_IN_MS;
      state.bossUntil = now + BOSS_MAX_DURATION;
      state.bossHpMax = BOSS_HP_MAX;
      state.bossHp = BOSS_HP_MAX;
      state.bossX = W + 80;
      state.bossLastThrowAt = state.bossWalkInUntil;
      state.bossThrowCount = 0;
      state.bossPhase = 'walkin';
      state.nextRacketAt = BOSS_THROWS_BEFORE_RACKET;
      state.racketDropped = false;
      state.hasRacket = false;
      state.bossDefeated = false;
      state.bossWonByPlayer = false;
      // SCORCH THE EARTH — boss fight takes over the screen completely.
      // Wipe every existing item + every other ongoing event so the player
      // has nothing competing with Greta for their attention.
      state.items = [];
      state.kleber = null;
      state.plane = null;
      state.bugEventUntil = 0;
      state.chemtrailUntil = 0;
      state.maskUntil = 0;
      state.wearsMask = false;
      state.inflamedUntil = 0;
      state.popups = [];
      // Pick 4 distinct intro quotes for this fight (random, no repeats)
      var shuffled = BOSS_INTROS.slice();
      for (var sh = shuffled.length - 1; sh > 0; sh--) {
        var j = Math.floor(Math.random() * (sh + 1));
        var tmp = shuffled[sh]; shuffled[sh] = shuffled[j]; shuffled[j] = tmp;
      }
      state.bossIntros = shuffled.slice(0, BOSS_INTRO_QUOTES);
      addStatus('⚠ BOSS — TETRA VON DUNGPACK ⚠', 3500);
      triggerSlomo(3500);
      try { startBossMusic(); } catch (e) {}
    }

    // Greta's projectile pool — categorized for variety + visual fun.
    // Phase 1: mix of everything. Phase 2: mostly round veg (deflectable).
    // isRound = can be deflected back at boss when racket is equipped.
    function _makeSpeech() {
      var q = BOSS_QUOTES[state.bossQuoteIdx % BOSS_QUOTES.length];
      state.bossQuoteIdx++;
      return { key: 'speech', emoji: '💬', dmg: 10, isSpeech: true, quote: q };
    }
    function _makeRound() {
      // Round veggies damage on contact — they are NOT deflectable.
      // Only tennis balls (_makeTennisBall) can be sent back at Greta.
      var roundies = [
        { key: 'cabbage', emoji: '🥬', dmg: 14 },
        { key: 'tomato',  emoji: '🍅', dmg: 14 },
        { key: 'onion',   emoji: '🧅', dmg: 14 }
      ];
      return roundies[Math.floor(Math.random() * roundies.length)];
    }
    function _makeTennisBall() {
      // The ONLY deflectable projectile. Pulsing yellow-green glow + label
      // ensure the player can spot it immediately in the chaos.
      return { key: 'ball', emoji: '🎾', dmg: 10, isRound: true, isTennisBall: true };
    }
    // === Klaus projectile pool — BUGS (eat ze bugs joke) ===
    function _makeKlausThing() {
      var pool = [
        { key: 'cricket',  emoji: '🦗',  dmg: 12, bug: true },
        { key: 'beetle',   emoji: '🪲',  dmg: 14, bug: true },
        { key: 'roach',    emoji: '🪳',  dmg: 16, bug: true },
        { key: 'ant',      emoji: '🐜',  dmg: 10, bug: true },
        { key: 'spider',   emoji: '🕷️',  dmg: 18, bug: true },
        { key: 'scorpion', emoji: '🦂',  dmg: 18, bug: true },
        { key: 'worm',     emoji: '🪱',  dmg: 12, bug: true },
        { key: 'fly',      emoji: '🪰',  dmg: 10, bug: true },
        { key: 'mosquito', emoji: '🦟',  dmg: 14, bug: true }
      ];
      return pool[Math.floor(Math.random() * pool.length)];
    }
    function _makeKlausSpeech() {
      var q = BOSS2_QUOTES[(state.bossQuoteIdx || 0) % BOSS2_QUOTES.length];
      state.bossQuoteIdx = (state.bossQuoteIdx || 0) + 1;
      return { key: 'speech', emoji: '💬', dmg: 10, isSpeech: true, quote: q };
    }
    function _makeMeatChunk() {
      // Legacy — kept for reference; Klaus now uses transformer parts.
      return { key: 'meat', emoji: '🍖', dmg: 10, isRound: true, isTennisBall: true, isMeatChunk: true };
    }
    // One emoji per build stage: bolts → gear → dome glass → antenna → thruster
    var TRANSFORMER_PARTS = ['🔩', '⚙️', '🪟', '📡', '🚀'];
    function _makeTransformerPart() {
      // Visually distinct collectible — pulsing gold ring (rendered specially).
      var emoji = TRANSFORMER_PARTS[Math.min(state.klausParts || 0, 4)];
      return {
        key: 'part', emoji: emoji, pts: 25, xp: 0, heal: 0,
        isTransformerPart: true, label: 'TRANSFORMER PART'
      };
    }
    // Gill Bates — pure computer junk. Viruses damage; floppies + CDs become
    // COLLECTIBLE once the cow has his laptop (they feed the virus upload bar).
    function _makeGatesThing() {
      var pool = [
        { key: 'virus',  emoji: '🦠', dmg: 14, isVirus: true },
        { key: 'virus',  emoji: '🦠', dmg: 14, isVirus: true },
        { key: 'floppy', emoji: '💾', dmg: 12, isDisk: true },
        { key: 'floppy', emoji: '💾', dmg: 12, isDisk: true },
        { key: 'cd',     emoji: '📀', dmg: 12, isDisk: true },
        { key: 'cd',     emoji: '📀', dmg: 12, isDisk: true },
        { key: 'skull',  emoji: '💀', dmg: 22 }  // rare "FATAL ERROR"
      ];
      return pool[Math.floor(Math.random() * pool.length)];
    }
    function _makeGatesSpeech() {
      var q = BOSS3_QUOTES[(state.bossQuoteIdx || 0) % BOSS3_QUOTES.length];
      state.bossQuoteIdx = (state.bossQuoteIdx || 0) + 1;
      return { key: 'speech', emoji: '💬', dmg: 10, isSpeech: true, quote: q };
    }
    function _makeMisc() {
      var pool = [
        { key: 'bug',     emoji: '🦗', dmg: 16, bug: true },
        { key: 'sprout',  emoji: '🌱', dmg: 12 },
        { key: 'corn',    emoji: '🌽', dmg: 14 },
        { key: 'train',   emoji: '🚂', dmg: 14 },
        { key: 'takeout', emoji: '🥡', dmg: 12 },
        { key: 'recycle', emoji: '♻️', dmg: 10 },
        { key: 'earth',   emoji: '🌍', dmg: 12 },
        { key: 'broccoli',emoji: '🥦', dmg: 14 }
      ];
      return pool[Math.floor(Math.random() * pool.length)];
    }

    function _pushBossItem(def, spawnX) {
      // Transformer parts fall slower + are catchable (good).
      // Klaus bugs after transformation are catchable as protein ammo.
      // Gill Bates viruses are catchable as patch ammo (mech persists).
      var isPart = def && def.isTransformerPart;
      var isBugAfterTransform = state.bossType === 'klaus' && state.klausTransformed && def && def.bug;
      // Gates: floppies + CDs become collectible AFTER the laptop is caught
      var isDiskAmmo = state.bossType === 'gates' && state.hasRacket && def && def.isDisk;
      state.items.push({
        def: def,
        good: isPart || isBugAfterTransform || isDiskAmmo,
        x: spawnX,
        y: 110,
        rot: (Math.random() - 0.5) * 0.3,
        vr: (Math.random() - 0.5) * 0.05,
        fromBoss: true,
        bossSpeedMul: isPart ? 0.55 : 1.5
      });
      state.bossThrowCount++;
    }
    function bossThrowSomething(now) {
      var def;
      var isBallThrow = false;
      var isKlaus = state.bossType === 'klaus';
      var isGates = state.bossType === 'gates';
      // KLAUS: throws bugs + transformer parts. After transformation, bugs become catchable (handled in collision).
      if (isKlaus) {
        // Parts are NOT thrown — they drop when his helicopter crashes into
        // the towers (handled in the boss update loop). He only throws bugs.
        def = Math.random() < (state.klausTransformed ? 0.20 : 0.30)
          ? _makeKlausSpeech()
          : _makeKlausThing();
      } else if (isGates) {
        // Gill Bates: viruses, computer bugs + retro junk. In phase 1 everything
        // damages (dodge until the laptop drops); in phase 2 bugs/viruses become
        // catchable debug ammo (flagged in _pushBossItem via hasRacket).
        def = Math.random() < 0.25 ? _makeGatesSpeech() : _makeGatesThing();
      } else if (state.bossPhase === 'phase2') {
        // Greta phase 2: tennis ball injection
        state.throwsSinceLastBall = (state.throwsSinceLastBall || 0) + 1;
        if (!state.nextBallAt) state.nextBallAt = 5 + Math.floor(Math.random() * 6);
        if (state.throwsSinceLastBall >= state.nextBallAt) {
          def = _makeTennisBall();
          state.throwsSinceLastBall = 0;
          state.nextBallAt = 5 + Math.floor(Math.random() * 6);
          isBallThrow = true;
        } else {
          def = Math.random() < 0.35 ? _makeSpeech() : _makeMisc();
        }
      } else {
        // Greta phase 1
        var r = Math.random();
        if (r < 0.40) def = _makeSpeech();
        else if (r < 0.70) def = _makeRound();
        else def = _makeMisc();
      }
      // Tennis balls aim straight at the cow so the player can position the paddle
      var aimAtCow = (isBallThrow) || (state.bossPhase === 'phase2' && Math.random() < 0.55);
      var spawnX = aimAtCow
        ? state.cow.x + state.cow.w / 2 + (Math.random() - 0.5) * (isBallThrow ? 30 : 20)
        : state.bossX + (Math.random() - 0.5) * 60;
      _pushBossItem(def, spawnX);
      // VOLLEY — never volley AFTER a tennis ball (so player has clean lane to deflect)
      if (isBallThrow) return;
      var volleyChance = state.bossPhase === 'phase2' ? 0.40 : 0.30;
      if (Math.random() < volleyChance) {
        var def2;
        if (state.bossPhase === 'phase2') {
          def2 = Math.random() < 0.50 ? _makeSpeech() : _makeMisc();
        } else {
          def2 = Math.random() < 0.50 ? _makeRound() : _makeMisc();
        }
        var spawnX2 = state.bossX + (Math.random() - 0.5) * 200;
        _pushBossItem(def2, spawnX2);
      }
    }

    function dropTennisRacket() {
      state.racketDropped = true;
      state.items = [];
      var isKlaus = state.bossType === 'klaus';
      var isGates = state.bossType === 'gates';
      var dropEmoji, dropLabel;
      if (isGates) {
        // 🌊 ID4 MOMENT — a HUGE visible wave rolls in first; the laptop
        // drops when it slams the yacht (handled in the update loop).
        state.gatesWaveAt = performance.now();
        state.gatesWaveDropped = false;
        state.bossSpeech = 'WAS IST DAS FÜR EINE WELLE?!';
        state.bossSpeechUntil = performance.now() + 1600;
        addStatus('🌊 RAUE SEE — GLEICH PASSIERT ES…', 2600);
        triggerSlomo(2800, 0.25, 0.35);
        return; // the item spawns after the wave impact
      } else if (isKlaus) {
        state.bossSpeech = 'NEIN! NICHT ZE KNOCHEN!';
        addStatus('🦴 GREIF DEN KNOCHEN — DEINE EINZIGE WAFFE GEGEN KLAUSEBÄR!', 5000);
        dropEmoji = '🦴';
        dropLabel = 'MARROW BONE';
      } else {
        state.bossSpeech = 'OH NEIN, MEIN PING-PONG-SCHLÄGER!';
        addStatus('🏓 GREIF DEN SCHLÄGER — DEINE EINZIGE WAFFE GEGEN TETRA!', 5000);
        dropEmoji = '🏓';
        dropLabel = 'PING-PONG-SCHLÄGER';
      }
      state.bossSpeechUntil = performance.now() + 5500;
      state.bossSpeechBig = true;
      triggerSlomo(3200);
      state.items.push({
        def: {
          key: 'racket',
          emoji: dropEmoji,
          pts: 50, xp: 0, heal: 0,
          isRacket: true,
          label: dropLabel
        },
        good: true,
        x: state.bossX,
        y: 130,
        rot: 0,
        vr: 0.06,
        fromBoss: true,
        bossSpeedMul: 0.4
      });
    }

    // Called every throw in phase1 — drops a racket when threshold is hit,
    // re-drops if the previous one fell off-screen without being caught.
    function maybeDropRacket() {
      if (state.hasRacket) return;
      if (state.bossThrowCount < state.nextRacketAt) return;
      // Is there already a racket on screen?
      for (var i = 0; i < state.items.length; i++) {
        if (state.items[i].def && state.items[i].def.isRacket) return;
      }
      dropTennisRacket();
      // Schedule another attempt after N more throws if she still doesn't have it
      state.nextRacketAt = state.bossThrowCount + BOSS_RACKET_RETRY;
    }

    function maybeSpawnChemtrail(now) {
      var elapsed = now - state.startedAt;
      if (elapsed < PHASE_AT.chemtrails) return;
      if (state.plane) return;
      if (now < state.nextChemtrailAt) return;
      if (!state.nextChemtrailAt) {
        state.nextChemtrailAt = now + 4000;
        return;
      }
      var dir = Math.random() < 0.5 ? 1 : -1;
      state.plane = {
        x: dir > 0 ? -50 : W + 50,
        y: 40 + Math.random() * 40,
        dir: dir,
        hasReleased: false
      };
      triggerSlomo(1500);
      state.nextChemtrailAt = now + (35000 + Math.random() * 20000);
    }

    // Stupid sound effects (WebAudio, no deps)
    var audioCtx = null;
    var audioUnlocked = false;
    function unlockAudio() {
      try {
        if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        if (audioCtx.state === 'suspended') audioCtx.resume();
        // Play a 1-sample silent buffer to satisfy iOS unlock requirement
        var b = audioCtx.createBuffer(1, 1, 22050);
        var src = audioCtx.createBufferSource();
        src.buffer = b; src.connect(audioCtx.destination); src.start(0);
        audioUnlocked = true;
      } catch (e) {}
    }
    function sfx(type) {
      if (!audioUnlocked) return;
      try {
        var ctx = audioCtx;
        if (!ctx) return;
        if (ctx.state === 'suspended') ctx.resume();
        var t = ctx.currentTime;
        function beep(freq, dur, wave, vol, slide) {
          var o = ctx.createOscillator(), g = ctx.createGain();
          o.type = wave || 'square';
          o.frequency.setValueAtTime(freq, t);
          if (slide) o.frequency.exponentialRampToValueAtTime(Math.max(40, slide), t + dur);
          g.gain.setValueAtTime(vol || 0.12, t);
          g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
          o.connect(g); g.connect(ctx.destination);
          o.start(t); o.stop(t + dur + 0.02);
        }
        if (type === 'catch')   beep(740, 0.08, 'square', 0.10, 1200);
        else if (type === 'bad')  { beep(160, 0.18, 'sawtooth', 0.14, 60); }
        else if (type === 'power') { beep(520, 0.09, 'square', 0.12, 900); setTimeout(function(){ beep(880, 0.12, 'square', 0.12, 1400); }, 70); }
        else if (type === 'level') { [523, 659, 784, 1046].forEach(function(f, i){ setTimeout(function(){ beep(f, 0.1, 'square', 0.12); }, i * 70); }); }
        else if (type === 'over')  { [440, 330, 220, 110].forEach(function(f, i){ setTimeout(function(){ beep(f, 0.18, 'sawtooth', 0.14); }, i * 110); }); }
        else if (type === 'start') { beep(660, 0.08, 'square', 0.12); setTimeout(function(){ beep(990, 0.1, 'square', 0.12); }, 80); }
        else if (type === 'fart') {
          // Juicy wet fart via noise + downward-sweeping lowpass on sawtooth
          var pick = Math.floor(Math.random() * 3);
          var baseF = [95, 72, 140][pick];
          var durF = [0.32, 0.42, 0.22][pick];
          var o1 = ctx.createOscillator(), g1 = ctx.createGain(), f1 = ctx.createBiquadFilter();
          o1.type = 'sawtooth';
          o1.frequency.setValueAtTime(baseF, t);
          o1.frequency.exponentialRampToValueAtTime(baseF * 0.45, t + durF);
          // Warble
          var lfo = ctx.createOscillator(), lfoG = ctx.createGain();
          lfo.frequency.value = 22 + Math.random() * 10;
          lfoG.gain.value = 18;
          lfo.connect(lfoG); lfoG.connect(o1.frequency);
          f1.type = 'lowpass';
          f1.frequency.setValueAtTime(900, t);
          f1.frequency.exponentialRampToValueAtTime(180, t + durF);
          g1.gain.setValueAtTime(0.001, t);
          g1.gain.exponentialRampToValueAtTime(0.22, t + 0.02);
          g1.gain.exponentialRampToValueAtTime(0.0001, t + durF);
          o1.connect(f1); f1.connect(g1); g1.connect(ctx.destination);
          o1.start(t); lfo.start(t);
          o1.stop(t + durF + 0.02); lfo.stop(t + durF + 0.02);
        }
      } catch (e) {}
    }

    // === Boss music — SNES-style chiptune loop ===========================
    // Cannot use the actual Mystic Quest track (Squaresoft copyright). This is
    // an evocative synth loop in a similar key/tempo built from WebAudio
    // oscillators. Bassline + arp lead. Loops while boss is active.
    var bossMusic = { timer: null, scheduledUntil: 0 };
    function startBossMusic() {
      if (!audioCtx || !audioUnlocked) return;
      try { stopAmbient(); } catch (e) {}
      stopBossMusic();
      bossMusic.scheduledUntil = audioCtx.currentTime;
      function tick() {
        if (!state.bossActive) { stopBossMusic(); return; }
        var t = audioCtx.currentTime;
        // Schedule the next 2 seconds of notes if we haven't already
        while (bossMusic.scheduledUntil < t + 1.5) {
          scheduleBossBar(bossMusic.scheduledUntil);
          bossMusic.scheduledUntil += 1.6; // bar length ~1.6s = 150 BPM
        }
      }
      bossMusic.timer = setInterval(tick, 200);
      tick();
    }
    function stopBossMusic() {
      if (bossMusic.timer) { clearInterval(bossMusic.timer); bossMusic.timer = null; }
    }
    function scheduleBossBar(barStart) {
      if (!audioCtx) return;
      // Bassline pattern (16th notes) — minor key, evil-boss vibe
      // More engaging but still pleasant: alternating two-bar pattern,
      // triangle bass groove + sine melody + soft off-beat "hat" ticks.
      var barIdx = Math.floor(barStart / 1.6) % 2;
      var bass = barIdx === 0
        ? [55, 0, 55, 65, 0, 55, 73, 65]
        : [49, 0, 49, 55, 0, 49, 65, 55];
      var lead = barIdx === 0
        ? [220, 0, 262, 0, 330, 262, 196, 0]
        : [196, 0, 247, 0, 294, 247, 220, 0];
      var stepDur = 1.6 / 8;
      for (var i = 0; i < 8; i++) {
        var stepT = barStart + i * stepDur;
        // BASS — triangle groove
        if (bass[i] > 0) {
          var bo = audioCtx.createOscillator(), bg = audioCtx.createGain();
          bo.type = 'triangle';
          bo.frequency.setValueAtTime(bass[i], stepT);
          bg.gain.setValueAtTime(0.001, stepT);
          bg.gain.exponentialRampToValueAtTime(0.05, stepT + 0.02);
          bg.gain.exponentialRampToValueAtTime(0.001, stepT + stepDur * 1.1);
          bo.connect(bg); bg.connect(audioCtx.destination);
          bo.start(stepT); bo.stop(stepT + stepDur * 1.2);
        }
        // LEAD — soft sine melody
        if (lead[i] > 0) {
          var lo = audioCtx.createOscillator(), lg = audioCtx.createGain();
          lo.type = 'sine';
          lo.frequency.setValueAtTime(lead[i], stepT);
          lg.gain.setValueAtTime(0.001, stepT);
          lg.gain.exponentialRampToValueAtTime(0.026, stepT + 0.015);
          lg.gain.exponentialRampToValueAtTime(0.001, stepT + stepDur * 0.9);
          lo.connect(lg); lg.connect(audioCtx.destination);
          lo.start(stepT); lo.stop(stepT + stepDur);
        }
        // HAT — tiny high tick on the off-beats for drive
        if (i % 2 === 1) {
          var ho = audioCtx.createOscillator(), hg = audioCtx.createGain();
          ho.type = 'square';
          ho.frequency.setValueAtTime(6200, stepT);
          hg.gain.setValueAtTime(0.001, stepT);
          hg.gain.exponentialRampToValueAtTime(0.012, stepT + 0.004);
          hg.gain.exponentialRampToValueAtTime(0.001, stepT + 0.05);
          ho.connect(hg); hg.connect(audioCtx.destination);
          ho.start(stepT); ho.stop(stepT + 0.06);
        }
      }
    }

    // === Ambient music — gentle background loop during normal play ========
    // The same scheduler also serves the ⭐ invincibility riff and the 🍄 trip
    // loop: each scheduled bar checks the power-up state and picks its flavor.
    var ambientMusic = { timer: null, scheduledUntil: 0 };
    function startAmbient() {
      if (!audioCtx || !audioUnlocked) return;
      if (ambientMusic.timer) return;
      ambientMusic.scheduledUntil = audioCtx.currentTime;
      function tick() {
        if (phase !== 'playing' || (state && state.bossActive)) { stopAmbient(); return; }
        var t = audioCtx.currentTime;
        // Short lookahead so a fresh star/shroom switches flavor within ~1 bar
        while (ambientMusic.scheduledUntil < t + 0.7) {
          var pn = performance.now();
          if (state && pn < state.starUntil) {
            scheduleStarBar(ambientMusic.scheduledUntil);
            ambientMusic.scheduledUntil += 0.8;
          } else if (state && pn < state.shroomUntil) {
            scheduleTripBar(ambientMusic.scheduledUntil);
            ambientMusic.scheduledUntil += 2.4;
          } else {
            scheduleAmbientBar(ambientMusic.scheduledUntil);
            ambientMusic.scheduledUntil += 3.2;
          }
        }
      }
      ambientMusic.timer = setInterval(tick, 150);
      tick();
    }
    function stopAmbient() {
      if (ambientMusic.timer) { clearInterval(ambientMusic.timer); ambientMusic.timer = null; }
    }
    // Cut pending quiet bars and restart scheduling NOW — called on star/shroom
    // pickup so the special music kicks in immediately instead of a bar later.
    function resyncMusic() {
      try {
        if (!audioCtx || !audioUnlocked) return;
        ambientMusic.scheduledUntil = audioCtx.currentTime;
        startAmbient();
      } catch (e) {}
    }
    // ⭐ Invincibility riff — fast, bright, relentless (Mario-star energy,
    // original melody). 0.8s bars, driving square-wave 8ths + octave bass.
    function scheduleStarBar(barStart) {
      if (!audioCtx) return;
      var barIdx = Math.floor(barStart / 0.8) % 2;
      // Two alternating major shapes a whole step apart — endless upward drive
      var riff = barIdx === 0
        ? [523, 659, 784, 659, 523, 659, 784, 880]
        : [587, 740, 880, 740, 587, 740, 880, 988];
      var bassF = barIdx === 0 ? 131 : 147;
      var stepDur = 0.8 / 8;
      for (var i = 0; i < 8; i++) {
        var stepT = barStart + i * stepDur;
        var o = audioCtx.createOscillator(), g = audioCtx.createGain();
        o.type = 'square';
        o.frequency.setValueAtTime(riff[i], stepT);
        g.gain.setValueAtTime(0.001, stepT);
        g.gain.exponentialRampToValueAtTime(0.02, stepT + 0.008);
        g.gain.exponentialRampToValueAtTime(0.001, stepT + stepDur * 0.85);
        o.connect(g); g.connect(audioCtx.destination);
        o.start(stepT); o.stop(stepT + stepDur);
        // Bass pulse on every other 8th
        if (i % 2 === 0) {
          var bo = audioCtx.createOscillator(), bg = audioCtx.createGain();
          bo.type = 'triangle';
          bo.frequency.setValueAtTime(bassF, stepT);
          bg.gain.setValueAtTime(0.001, stepT);
          bg.gain.exponentialRampToValueAtTime(0.045, stepT + 0.01);
          bg.gain.exponentialRampToValueAtTime(0.001, stepT + stepDur * 1.6);
          bo.connect(bg); bg.connect(audioCtx.destination);
          bo.start(stepT); bo.stop(stepT + stepDur * 1.8);
        }
      }
    }
    // 🍄 Trip loop — woozy detuned pads that bend pitch, plus watery blips.
    function scheduleTripBar(barStart) {
      if (!audioCtx) return;
      var barIdx = Math.floor(barStart / 2.4) % 2;
      var root = barIdx === 0 ? 110 : 98;
      // Two detuned oscillators sliding up a fifth and back — seasick sway
      [1, 1.013].forEach(function (det, k) {
        var o = audioCtx.createOscillator(), g = audioCtx.createGain();
        o.type = k === 0 ? 'sine' : 'triangle';
        o.frequency.setValueAtTime(root * det, barStart);
        o.frequency.linearRampToValueAtTime(root * 1.5 * det, barStart + 1.2);
        o.frequency.linearRampToValueAtTime(root * det, barStart + 2.35);
        g.gain.setValueAtTime(0.001, barStart);
        g.gain.linearRampToValueAtTime(k === 0 ? 0.028 : 0.016, barStart + 0.4);
        g.gain.linearRampToValueAtTime(0.001, barStart + 2.35);
        o.connect(g); g.connect(audioCtx.destination);
        o.start(barStart); o.stop(barStart + 2.4);
      });
      // Watery downward blips at random spots — the "bubbles"
      for (var b = 0; b < 3; b++) {
        var bt = barStart + 0.3 + Math.random() * 1.8;
        var f0 = 500 + Math.random() * 700;
        var po = audioCtx.createOscillator(), pg = audioCtx.createGain();
        po.type = 'sine';
        po.frequency.setValueAtTime(f0, bt);
        po.frequency.exponentialRampToValueAtTime(f0 * 0.35, bt + 0.35);
        pg.gain.setValueAtTime(0.001, bt);
        pg.gain.exponentialRampToValueAtTime(0.02, bt + 0.02);
        pg.gain.exponentialRampToValueAtTime(0.001, bt + 0.38);
        po.connect(pg); pg.connect(audioCtx.destination);
        po.start(bt); po.stop(bt + 0.42);
      }
    }
    // 🌊 Underwater dream loop — ORIGINAL composition evoking the mood of
    // classic SNES aquatic levels (think DKC's water stages): slow rolling
    // ninth-chord arpeggios on a soft e-piano voice, watery echo taps, a
    // deep sighing bass and a detuned pad. No copyrighted melody is used.
    var AQUA_CHORDS = [
      // [bassHz, arpeggio tone ladder (low→high)]
      [110.0, [164.8, 220.0, 261.6, 329.6, 392.0, 493.9, 587.3]], // Am9
      [87.3,  [130.8, 174.6, 220.0, 261.6, 329.6, 392.0, 523.3]], // Fmaj9
      [73.4,  [110.0, 146.8, 174.6, 220.0, 261.6, 329.6, 440.0]], // Dm9
      [82.4,  [123.5, 164.8, 196.0, 246.9, 293.7, 329.6, 493.9]]  // Esus9
    ];
    // Rising-falling wave through the chord ladder — reads as gentle swells
    var AQUA_PATTERN = [0, 2, 4, 6, 5, 3, 4, 2];
    function scheduleAmbientBar(barStart) {
      if (!audioCtx) return;
      var barIdx = Math.floor(barStart / 3.2) % AQUA_CHORDS.length;
      var chord = AQUA_CHORDS[barIdx];
      var bass = chord[0], tones = chord[1];
      // BASS — deep slow sigh, one note per bar
      var bo = audioCtx.createOscillator(), bg = audioCtx.createGain();
      bo.type = 'sine';
      bo.frequency.setValueAtTime(bass, barStart);
      bg.gain.setValueAtTime(0.001, barStart);
      bg.gain.linearRampToValueAtTime(0.045, barStart + 0.7);
      bg.gain.linearRampToValueAtTime(0.001, barStart + 3.15);
      bo.connect(bg); bg.connect(audioCtx.destination);
      bo.start(barStart); bo.stop(barStart + 3.2);
      // PAD — root+fifth, gently detuned, swelling under everything
      [1, 1.5, 1.007].forEach(function (mul, k) {
        var po = audioCtx.createOscillator(), pg = audioCtx.createGain();
        po.type = 'triangle';
        po.frequency.setValueAtTime(bass * 2 * mul, barStart);
        pg.gain.setValueAtTime(0.001, barStart);
        pg.gain.linearRampToValueAtTime(k === 1 ? 0.008 : 0.011, barStart + 1.1);
        pg.gain.linearRampToValueAtTime(0.001, barStart + 3.15);
        po.connect(pg); pg.connect(audioCtx.destination);
        po.start(barStart); po.stop(barStart + 3.2);
      });
      // ARPEGGIO — 8 slow e-piano notes with vibrato, lowpass and two
      // fading echo taps (the "watery" shimmer)
      var stepDur = 3.2 / 8;
      for (var i = 0; i < 8; i++) {
        var noteT = barStart + i * stepDur;
        var f = tones[AQUA_PATTERN[i]];
        // main hit + 2 echoes
        for (var e = 0; e < 3; e++) {
          var t = noteT + e * 0.30;
          var vol = [0.028, 0.014, 0.007][e];
          var o = audioCtx.createOscillator(), g = audioCtx.createGain();
          var lp = audioCtx.createBiquadFilter();
          lp.type = 'lowpass';
          lp.frequency.setValueAtTime(1400 - e * 350, t);
          o.type = 'sine';
          o.frequency.setValueAtTime(f, t);
          // slow vibrato — the wobble that makes it feel submerged
          var lfo = audioCtx.createOscillator(), lg = audioCtx.createGain();
          lfo.type = 'sine';
          lfo.frequency.setValueAtTime(4.2, t);
          lg.gain.setValueAtTime(f * 0.006, t);
          lfo.connect(lg); lg.connect(o.frequency);
          g.gain.setValueAtTime(0.001, t);
          g.gain.exponentialRampToValueAtTime(vol, t + 0.04);
          g.gain.exponentialRampToValueAtTime(0.001, t + stepDur * 1.4);
          o.connect(lp); lp.connect(g); g.connect(audioCtx.destination);
          o.start(t); o.stop(t + stepDur * 1.5);
          lfo.start(t); lfo.stop(t + stepDur * 1.5);
        }
      }
    }

    // === Victory fanfare — classic rising jingle on boss defeat ===========
    function playVictoryJingle() {
      if (!audioCtx || !audioUnlocked) return;
      try {
        var t0 = audioCtx.currentTime + 0.05;
        var notes = [
          [523, 0.00, 0.16], [659, 0.14, 0.16], [784, 0.28, 0.16],
          [1047, 0.42, 0.30], [784, 0.70, 0.12], [1047, 0.82, 0.5]
        ];
        notes.forEach(function (n) {
          var o = audioCtx.createOscillator(), g = audioCtx.createGain();
          o.type = 'triangle';
          o.frequency.setValueAtTime(n[0], t0 + n[1]);
          g.gain.setValueAtTime(0.001, t0 + n[1]);
          g.gain.exponentialRampToValueAtTime(0.09, t0 + n[1] + 0.02);
          g.gain.exponentialRampToValueAtTime(0.001, t0 + n[1] + n[2]);
          o.connect(g); g.connect(audioCtx.destination);
          o.start(t0 + n[1]); o.stop(t0 + n[1] + n[2] + 0.05);
        });
      } catch (e) {}
    }

    function tryLevelUp() {
      while (state.level < LEVELS.length - 1 && state.xp >= LEVELS[state.level].xp) {
        state.level++;
        sfx('level');
        addStatus(LEVELS[state.level].name.toUpperCase() + ' UNLOCKED', 2200);
        addParticles(W / 2, H / 2, '#ffd700', 20);
        state.xpFlash = 30;
      }
    }

    function catchGood(it) {
      var def = it.def;
      var base = def.pts;
      // Eating resets the hunger clock
      state.lastAteAt = performance.now();
      state.hungerWarned = false;
      state.streak++;
      if (state.streak > state.maxStreak) state.maxStreak = state.streak;
      state.itemsCaught++;

      var mult = 1, comboBonus = 0;
      if (state.streak >= 5) mult = 3;
      else if (state.streak >= 3) mult = 2;
      else if (state.streak === 2) comboBonus = state.streak * 2;

      var pts = base * mult + comboBonus;
      if (performance.now() < state.carnivoroUntil) pts *= 2;

      state.score += pts;
      state.xp += def.xp;

      addPopup(it.x, it.y, '+' + pts, performance.now() < state.carnivoroUntil);
      addParticles(it.x, it.y, CI.gold, 8);
      var isPower = def.carnivoro || def.butter || def.shield || def.testicles || def.antidote;
      sfx(isPower ? 'power' : 'catch');

      // 🎯 Boss damage — every meat catch during the boss fight chips her HP.
      // Steak/ribs/bacon hit hardest, smaller foods less.
      if (state.bossActive && !state.bossDefeated && def.heal) {
        var dmg = Math.min(20, def.pts);
        state.bossHp = Math.max(0, state.bossHp - dmg);
        addPopup(state.bossX, 140, '-' + dmg + ' HP', true);
      }

      // Baseline heal from any animal food
      if (def.heal && !def.antidote) {
        var h = def.heal;
        state.hp = Math.min(state.maxHp, state.hp + h);
        state.healFlash = 18;
      }

      if (def.carnivoro) {
        state.carnivoroUntil = performance.now() + 5000;
        addStatus('CARNIVORO MODE ACTIVE', 1500);
      }
      if (def.butter) {
        // Butter is the seed-oil antidote
        if (performance.now() < state.inflamedUntil) {
          state.inflamedUntil = 0;
          addStatus('🧈 BUTTER — INFLAMMATION GONE', 1800);
        } else {
          addStatus('GRASS-FED BUTTER +HEAL', 1500);
        }
      }
      if (def.shield) {
        state.shieldUntil = performance.now() + 8000;
        state.shieldHits = 1;
        addStatus('SHIELD UP', 1500);
      }
      if (def.testicles) {
        state.testiclesUntil = performance.now() + 10000;
        addStatus('BEAST MODE — TESTOSTERONE SURGE', 1800);
        addParticles(it.x, it.y, '#ffd700', 14);
      }
      if (def.star) {
        state.starUntil = performance.now() + 8000;
        state.stats.touchedGrass++;
        addStatus('☀️ TOUCHED GRASS — INVINCIBLE', 2000);
        addParticles(it.x, it.y, '#ffe14a', 24);
        triggerSlomo(1200);
        resyncMusic(); // ⭐ invincibility riff kicks in immediately
      }
      if (def.shroom) {
        // 5.5s trip — shorter so it doesn't dominate the demo loop or the run.
        state.shroomUntil = performance.now() + 5500;
        addStatus('🍄 TRIP MODE ACTIVATED', 2000);
        addParticles(it.x, it.y, '#ff4ad6', 20);
        triggerSlomo(1500);
        resyncMusic(); // 🍄 woozy trip loop takes over
      }
      if (def.milk) {
        var prevGrowth = state.growth;
        state.growth = Math.min(1.6, state.growth + 0.2);
        var wasOnFire = performance.now() < state.overheatUntil;
        if (wasOnFire) {
          state.overheatUntil = 0;
          addStatus('🥛 FIRE OUT — MILK SAVES THE DAY', 2000);
        } else {
          addStatus('🥛 RAW MILK — KUH WÄCHST ▲ ' + state.growth.toFixed(1) + 'x', 2200);
        }
        // Sparkle burst from the cow itself so the grow is obvious
        var ccx = state.cow.x + state.cow.w / 2;
        var ccy = state.cow.y + state.cow.h / 2;
        addParticles(ccx, ccy, '#fff', 18);
        addParticles(ccx, ccy, '#ffd66b', 8);
        addPopup(ccx, ccy - 28, '▲ ' + state.growth.toFixed(1) + 'x', true);
      }
      if (def.antidote) {
        state.hp = Math.min(state.maxHp, state.hp + def.heal);
        state.healFlash = 24;
        state.poisonUntil = 0;
        addStatus('POISON CURED', 1500);
        addParticles(it.x, it.y, '#4af', 16);
      }
      if (def.tinfoil) { // (tinfoil removed — branch kept inert for safety)
        addParticles(it.x, it.y, '#c8ccd0', 16);
        triggerSlomo(900);
      }

      tryLevelUp();
    }

    function hitBad(it) {
      // ⭐ Star power — plants phase through, no damage, bonus points.
      if (performance.now() < state.starUntil) {
        state.score += 10;
        addPopup(it.x, it.y, '+10 ⭐', true);
        addParticles(it.x, it.y, '#ffe14a', 12);
        sfx('power');
        return;
      }
      if (state.shieldHits > 0 && performance.now() < state.shieldUntil) {
        state.shieldHits = 0;
        state.shieldUntil = 0;
        addStatus('SHIELD ABSORBED HIT', 1500);
        addParticles(it.x, it.y, '#4af', 10);
        return;
      }
      var dmg = it.def.dmg || 15;
      state.hp -= dmg;
      state.streak = 0;
      sfx('fart');
      // Visual punch — headline baddies get bigger shake + flash than plain veg
      var headline = it.def.bug || it.def.seedOil || it.def.mask;
      state.shakeFrames = headline ? 14 : 6;
      state.dangerFlash = headline ? 18 : 10;
      addParticles(it.x, it.y, headline ? '#ff5040' : '#888', headline ? 14 : 6);
      addPopup(it.x, it.y, '-' + dmg + ' HP', false);
      if (it.def.antinutrient) {
        state.popups.push({
          x: state.cow.x + state.cow.w / 2,
          y: state.cow.y - 8,
          text: '\u26A0 ' + it.def.antinutrient,
          life: 80,
          gold: false,
          danger: true
        });
      }
      if (it.def.status) addStatus(it.def.status, 2000);
      if (it.def.overheat) {
        // Chili sets mouth on fire — HOT until milk is caught. Max 12s safety.
        state.overheatUntil = performance.now() + 12000;
        addStatus('🔥 MOUTH ON FIRE — GRAB MILK', 2200);
      }
      if (it.def.shrink) {
        state.fiberUntil = performance.now() + 6000;
        addStatus('🌽 LECTINS — KUH GESCHRUMPFT ▼ 0.65x', 2200);
        var ccx2 = state.cow.x + state.cow.w / 2;
        var ccy2 = state.cow.y + state.cow.h / 2;
        addParticles(ccx2, ccy2, '#b06030', 14);
        addPopup(ccx2, ccy2 - 28, '▼ 0.65x', false);
      }
      if (it.def.fart) state.fartUntil = performance.now() + 2500;

      // 🌍 GLOBAL WARMING — only plants make the cow fart. Seed oil/masks/bugs
      // damage the player but don't ironically heat the planet.
      var isPlant = !it.def.seedOil && !it.def.mask && !it.def.bug;
      if (isPlant) {
        state.planetTemp += 1;
        var alerts = [
          { at: 3,  msg: '🌡 +1.5°C · CLIMATE CONCERN' },
          { at: 5,  msg: '🔥 +2°C · GLOBAL WARMING ALERT' },
          { at: 8,  msg: '🌋 +3°C · PARIS ACCORD VIOLATED' },
          { at: 12, msg: '☠ +4°C · ICE CAPS GONE' },
          { at: 16, msg: '💀 +5°C · PLANETARY MELTDOWN' }
        ];
        for (var ai = 0; ai < alerts.length; ai++) {
          if (state.planetTemp === alerts[ai].at && state.lastClimateAlert < alerts[ai].at) {
            state.lastClimateAlert = alerts[ai].at;
            addStatus(alerts[ai].msg, 2400);
            break;
          }
        }
      }
      if (it.def.nausea) state.nauseaUntil = performance.now() + 2500;
      if (it.def.poison) {
        state.poisonUntil = performance.now() + 8000;
        state.poisonTick = performance.now();
      }
      // === New mechanic effects ============================
      if (it.def.seedOil) {
        state.inflamedUntil = performance.now() + 8000;
        state.inflamedTick = performance.now();
        state.stats.seedOilHits++;
        addStatus('🧪 INFLAMED — grab butter or tallow', 2200);
      }
      if (it.def.mask) {
        state.wearsMask = true;
        state.maskUntil = performance.now() + 5000;
        state.maskTaps = 0;
        state.stats.masksWorn++;
        addStatus('😷 MASK ON FACE — tap to remove', 2200);
      }
      if (it.def.bug) {
        state.stats.bugsEaten++;
        addStatus('🦗 INSECT PROTEIN CONSUMED 😊', 1800);
      }

      if (state.hp <= 0) { state.hp = 0; endGame(); }
    }

    function endGame() {
      if (phase === 'over') return;
      // Demo mode never ends — heal and continue so the AI keeps showcasing
      if (phase === 'start') {
        state.hp = state.maxHp;
        return;
      }
      phase = 'over';
      sfx('over');
      var now = performance.now();
      // Capture personal-best status BEFORE we update state.best, so the
      // discount-tier "bumped by PB" logic knows whether this run beat
      // the previous record.
      var prevBest = highscores.length ? highscores[0].score : 0;
      var isNewPB = state.score > prevBest;
      state.gameData = {
        rawScore:     state.score,
        durationMs:   Math.round(now - state.startedAt),
        levelReached: state.level,
        rankName:     (LEVELS[state.level] && LEVELS[state.level].name) || '',
        itemsCaught:  state.itemsCaught,
        itemsMissed:  state.itemsMissed,
        maxStreak:    state.maxStreak,
        planetTemp:   state.planetTemp,
        isNewPB:      isNewPB,
        prevBest:     prevBest,
        bossWon:      !!state.bossWonByPlayer,
        boss2Won:     !!state.boss2WonByPlayer,
        boss3Won:     !!state.boss3WonByPlayer,
        victory:      !!state.victoryEnding,   // all three bosses beaten — the "true ending"
        // Cosmetic state at game end — composed into the share image
        wearsMask:    !!state.wearsMask,
        wearsTinfoil: !!state.wearsTinfoil,
        stats:        state.stats,
        clientTs:     Date.now()
      };
      // Compute discount tier (after gameData so it can read isNewPB/level)
      state.gameData.discountTier = computeDiscountTier(state.gameData);
      var initialName = '';
      try { initialName = localStorage.getItem(NAME_KEY) || ''; } catch (e) {}
      var entry = { score: state.score, date: fmtDate(new Date()), id: Date.now() + Math.random(), name: initialName };
      currentEntryId = entry.id;
      highscores.push(entry);
      highscores.sort(function (a, b) { return b.score - a.score; });
      highscores = highscores.slice(0, 10);
      saveHS(highscores);
      updateLeaderPanel();
      if (state.score > state.best) state.best = state.score;
      // Wipe lingering floating popups (+12 / -10 HP / etc.) so they don't
      // briefly bleed through behind the overlay on slower devices.
      state.popups = [];
      // Open the share overlay immediately — no flash of the old canvas GAME OVER screen.
      showEmailOverlay();
    }

    function startGame() {
      resetState();
      sfx('start');
      phase = 'playing';
      currentEntryId = null;
      lastTime = performance.now();
      // Fresh run — drop the previous run's boss snapshot
      bossSnapCanvas = null;
      lastBossSnapAt = 0;
      hideEmailOverlay();
      try { startAmbient(); } catch (e) {}
    }

    // Input
    function onKeyDown(e) {
      if (!audioUnlocked) unlockAudio();
      if (['ArrowLeft', 'ArrowRight', 'a', 'A', 'd', 'D'].indexOf(e.key) !== -1) {
        keys[e.key.toLowerCase()] = true;
        e.preventDefault();
      }
      // 🎮 Dash: Z = left dash, X = right dash (desktop parity with mobile A/B)
      // 🧃 Fire: Leertaste or F shoots Bug Juice (Klausebär fight)
      if (phase === 'playing') {
        if (e.key === 'z' || e.key === 'Z') { tryDash(-1); e.preventDefault(); }
        if (e.key === 'x' || e.key === 'X') { tryDash(1);  e.preventDefault(); }
        if (e.key === ' ' || e.key === 'f' || e.key === 'F') { fireJuice(); e.preventDefault(); }
      }
      if ((phase === 'start' || phase === 'over') && (e.key === 'Enter' || e.key === ' ')) {
        startGame();
        e.preventDefault();
      }
    }
    function onKeyUp(e) { keys[e.key.toLowerCase()] = false; }

    var touchDir = 0;
    function canvasPoint(e) {
      var r = canvas.getBoundingClientRect();
      var t = e.touches ? e.touches[0] : e;
      return {
        x: (t.clientX - r.left) * (W / r.width),
        y: (t.clientY - r.top) * (H / r.height)
      };
    }
    function onPointerDown(e) {
      if (!audioUnlocked) unlockAudio();
      var p = canvasPoint(e);
      if (phase === 'start') {
        // Demo mode — ANY click starts the real game
        startGame();
        e.preventDefault();
        return;
      }
      if (phase !== 'playing') {
        var btn = overBtn;
        if (btn && p.x >= btn.x && p.x <= btn.x + btn.w && p.y >= btn.y && p.y <= btn.y + btn.h) {
          startGame();
          return;
        }
      } else {
        // 🦠 Tap on Klima Kleber 5 times → "Suppe geworfen!" exit
        if (state.kleber && !state.kleber.gone && !state.kleber.copAt) {
          var dx = Math.abs(p.x - state.kleber.x);
          if (dx < 40 && p.y > GROUND_Y - 70 && p.y < GROUND_Y) {
            state.kleber.tomatoTaps++;
            addParticles(state.kleber.x, GROUND_Y - 30, '#d44', 8);
            if (state.kleber.tomatoTaps >= 5) {
              addStatus('🍅 SUPPE GEWORFEN — KLEBER VERTRIEBEN', 1800);
              state.stats.klebersTomatoed++;
              state.stats.klebersSurvived++;
              state.kleber = null;
            }
            e.preventDefault();
            return;
          }
        }
        // 😷 Tap to remove mask (3 taps)
        if (state.wearsMask) {
          state.maskTaps++;
          if (state.maskTaps >= 3) {
            state.wearsMask = false;
            state.maskTaps = 0;
            addStatus('😷 MASK OFF', 1200);
            e.preventDefault();
            return;
          }
        }
        touchDir = p.x < W / 2 ? -1 : 1;
      }
      e.preventDefault();
    }
    function onPointerUp() { touchDir = 0; }

    canvas.addEventListener('keydown', onKeyDown);
    canvas.addEventListener('keyup', onKeyUp);
    window.addEventListener('keydown', function (e) { if (document.activeElement === canvas) return; if (phase === 'playing') onKeyDown(e); });
    window.addEventListener('keyup', onKeyUp);
    canvas.addEventListener('mousedown', onPointerDown);
    canvas.addEventListener('mouseup', onPointerUp);
    canvas.addEventListener('touchstart', onPointerDown, { passive: false });
    canvas.addEventListener('touchend', onPointerUp);
    canvas.addEventListener('click', function () { canvas.focus(); });

    // 🎮 FORGIVING TOUCH ZONES — taps that land on the Game-Boy CASE next to
    // the screen (gold bezel, area around the buttons) also steer the cow.
    // Players often miss the canvas edge by a few px; the whole shell half
    // now counts. Buttons (FIRE/A/B/START) keep their own behavior.
    function onShellPointerDown(e) {
      if (e.target === canvas) return; // canvas has its own handler
      if (e.target && e.target.closest && e.target.closest('button')) return;
      if (phase === 'start') { startGame(); e.preventDefault(); return; }
      if (phase !== 'playing') return;
      var cx = (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX;
      var r = canvas.getBoundingClientRect();
      touchDir = cx < r.left + r.width / 2 ? -1 : 1;
      e.preventDefault();
    }
    if (wrap) {
      wrap.addEventListener('mousedown', onShellPointerDown);
      wrap.addEventListener('touchstart', onShellPointerDown, { passive: false });
      wrap.addEventListener('mouseup', onPointerUp);
      wrap.addEventListener('touchend', onPointerUp);
    }

    // Button geometry
    var startBtn = { x: W / 2 - 100, y: H - 140, w: 200, h: 46 };
    var overBtn  = { x: W / 2 - 100, y: H - 80,  w: 200, h: 46 };

    // Simple AI for demo mode — moves cow toward closest good item near catch zone,
    // away from bad ones. Greedy, dumb, but reads as "skilled human play" on a demo.
    function demoAI() {
      if (!state || !state.items.length) { touchDir = 0; return; }
      var cowCx = state.cow.x + state.cow.w / 2;
      var best = null, bestScore = -Infinity;
      for (var i = 0; i < state.items.length; i++) {
        var it = state.items[i];
        if (it.y < GROUND_Y - 220 || it.y > GROUND_Y + 30) continue;
        // Avoid Klima Kleber blockade
        if (state.kleber && Math.abs(it.x - state.kleber.x) < 40) continue;
        var goodness = it.good ? 12 : -16;
        // Prefer power-ups
        if (it.def && (it.def.star || it.def.shroom || it.def.carnivoro)) goodness += 8;
        var score = goodness - Math.abs(it.x - cowCx) / 40;
        if (score > bestScore) { bestScore = score; best = it; }
      }
      if (!best) { touchDir = 0; return; }
      var diff = best.x - cowCx;
      if (Math.abs(diff) < 8) touchDir = 0;
      else touchDir = diff > 0 ? 1 : -1;
    }

    // Update
    function update(dt) {
      if (phase === 'over') return;
      if (phase !== 'playing' && phase !== 'start') return;
      var isDemo = phase === 'start';
      var now = performance.now();
      var lv = currentLevel();

      // Demo: AI controls cow + never dies + scripted event timeline
      if (isDemo) {
        demoAI();
        if (state.hp < 40) state.hp = Math.min(state.maxHp, state.hp + 0.5);

        var demoT = now - state.startedAt;

        // 10s — Klima-Kleber appears (override its normal phase gate)
        if (demoT > 10000 && !state.kleber && !state._demoKleberDone) {
          state._demoKleberDone = true;
          state.nextKleberAt = now - 1;
          state.kleber = {
            x: 60 + Math.random() * (W - 120),
            signIdx: Math.floor(Math.random() * KLEBER_SIGNS.length),
            spawnedAt: now,
            copAt: 0,
            tomatoTaps: 0,
            gone: false
          };
        }

        // 20s — boss teaser: start Greta's walk-in (override phase==='playing' gate)
        if (demoT > 20000 && !state.bossSpawned) {
          state.bossSpawned = true;
          state.bossActive = true;
          state.bossEnteredAt = now;
          state.bossWalkInUntil = now + 8000; // shorter demo walk-in
          state.bossUntil = now + 60000;
          state.bossHp = BOSS_HP_MAX;
          state.bossX = W + 80;
          state.bossPhase = 'walkin';
          // Demo teaser always shows the same iconic quote — instantly recognizable
          state.bossIntros = ['DU HAST MEINE KINDHEIT GESTOHLEN!'];
          // Clear other clutter so the boss is the focus
          state.items = [];
        }

        // 26s — snap boss to center + FREEZE the demo so "READY?" message reads
        if (demoT > 26000 && !state._demoFrozen) {
          state._demoFrozen = true;
          state.bossX = W / 2;
          state.bossWalkInUntil = now - 100; // boss done walking
        }

        // 30s — loop the demo: full reset
        if (demoT > 30000) {
          // Soft reset for looping
          resetState();
          state.startedAt = now;
          state.hp = 80;
          state._demoKleberDone = false;
          state._demoFrozen = false;
          return; // skip rest of this frame
        }

        // While frozen: skip all the normal update logic below
        if (state._demoFrozen) return;
      }

      // No hard time limit anymore — the game is endless after the third boss.
      // Runs end through HP loss (including the hunger drain below).

      // 🍽 HUNGER — dodging everything is not a strategy. The cow must EAT.
      // Grace period ~7s without food, then HP drains. Paused during boss
      // fights (no regular food spawns there) and in the demo.
      if (isDemo || state.bossActive) {
        state.lastAteAt = now;
        state.hungerWarned = false;
      } else {
        var sinceAte = now - (state.lastAteAt || state.startedAt);
        if (sinceAte > 4500 && !state.hungerWarned) {
          state.hungerWarned = true;
          addStatus('🍽 DEINE KUH HAT HUNGER — ISS FLEISCH!', 2000);
        }
        if (sinceAte > 7000) {
          if (!state.hungerTick) state.hungerTick = now;
          if (now - state.hungerTick > 1000) {
            state.hungerTick = now;
            state.hp -= 4;
            addPopup(state.cow.x + state.cow.w / 2, state.cow.y, '-4 🍽', false);
            if (state.hp <= 0) { state.hp = 0; endGame(); return; }
          }
        } else {
          state.hungerTick = 0;
        }
      }

      // Overheat tick: drain 4 HP/sec while mouth on fire (cure = milk)
      if (now < state.overheatUntil) {
        if (!state.overheatTick) state.overheatTick = now;
        if (now - state.overheatTick > 1000) {
          state.overheatTick = now;
          state.hp -= 4;
          addPopup(state.cow.x + state.cow.w / 2, state.cow.y, '-4 🔥', false);
          if (state.hp <= 0) { state.hp = 0; endGame(); return; }
        }
      } else {
        state.overheatTick = 0;
      }

      // Inflamed tick (seed oil) — drain 3 HP/sec, cured by butter
      if (now < state.inflamedUntil) {
        if (now - state.inflamedTick > 1000) {
          state.inflamedTick = now;
          state.hp -= 3;
          addPopup(state.cow.x + state.cow.w / 2, state.cow.y, '-3 🧪', false);
          if (state.hp <= 0) { state.hp = 0; endGame(); return; }
        }
      }

      // Mask auto-removal — 5s timeout, otherwise tap 3x to remove early
      if (state.wearsMask && now >= state.maskUntil) {
        state.wearsMask = false;
        state.maskTaps = 0;
      }
      // Tinfoil expiry
      if (state.wearsTinfoil && now >= state.tinfoilUntil) {
        state.wearsTinfoil = false;
      }

      // Event spawners — ALL other mechanics suspended while a boss is on screen
      if (!state.bossActive) {
        maybeSpawnKleber(now);
        maybeSpawnBugEvent(now);
        maybeSpawnChemtrail(now);
      }
      maybeSpawnBoss(now);
      maybeSpawnBoss2(now);
      maybeSpawnBoss3(now);

      // Boss lifecycle — walk-in → phase1 (15 throws) → racket → phase2 (deflect) → defeat
      if (state.bossActive) {
        var walkingIn = now < state.bossWalkInUntil;
        // Position: slide in during walk-in, sway after
        if (walkingIn) {
          var wi = 1 - (state.bossWalkInUntil - now) / BOSS_WALK_IN_MS;
          var ease = 1 - Math.pow(1 - wi, 3);
          state.bossX = (W + 80) + ((W / 2) - (W + 80)) * ease;
          if (state.bossPhase !== 'walkin') state.bossPhase = 'walkin';
        } else {
          // Klausebär swings WIDE — wide enough to clip the warning towers.
          var swayT = (now - state.bossWalkInUntil) / 1000;
          var swayAmp = state.bossType === 'klaus' ? 0.45 : 0.32;
          state.bossX = W / 2 + Math.sin(swayT * 0.8) * (W * swayAmp);
          // Phase transitions (once walk-in is over)
          if (state.bossPhase === 'walkin') state.bossPhase = 'phase1';

          // 🏗 TOWER CRASH — parts ONLY drop when his helicopter hits a tower
          if (state.bossType === 'klaus' && !state.klausTransformed &&
              state.klausPartsDropped < KLAUS_PARTS_NEEDED && now > state.nextCrashOkAt) {
            var structL = 26, structR = W - 26;
            if (Math.abs(state.bossX - structL) < 26 || Math.abs(state.bossX - structR) < 26) {
              state.klausPartsDropped++;
              state.nextCrashOkAt = now + 3500;
              state.shakeFrames = 10;
              addParticles(state.bossX, 160, '#ffb020', 20);
              addParticles(state.bossX, 160, '#888', 10);
              state.bossSpeech = ['AUTSCH! MEIN ROTOR!', 'WER HAT ZE TURM DAHIN GEBAUT?!', 'MEIN HELIKOPTER!'][Math.floor(Math.random() * 3)];
              state.bossSpeechUntil = now + 1600;
              sfx('bad');
              // The lost part tumbles down from the crash point
              state.items.push({
                def: _makeTransformerPart(),
                good: true,
                x: Math.max(30, Math.min(W - 30, state.bossX)),
                y: 180,
                rot: 0,
                vr: 0.1,
                fromBoss: true,
                bossSpeedMul: 0.5
              });
            }
          }
        }

        // 🌊 Wave impact (Gates): after ~1.1s the wave slams the yacht and
        // the laptop flies out — big shake, big yell.
        if (state.bossType === 'gates' && state.gatesWaveAt && !state.gatesWaveDropped) {
          if (now - state.gatesWaveAt > 1100) {
            state.gatesWaveDropped = true;
            state.shakeFrames = 16;
            state.bossSpeech = 'NOOO! MEIN LAPTOP!';
            state.bossSpeechUntil = now + 4000;
            state.bossSpeechBig = true;
            addStatus('💻 FANG DEN LAPTOP!', 4000);
            triggerSlomo(3000, 0.12, 0.4);
            sfx('over');
            state.items.push({
              def: { key: 'racket', emoji: '💻', pts: 50, xp: 0, heal: 0, isRacket: true, label: 'LAPTOP' },
              good: true,
              x: state.bossX,
              y: 150,
              rot: 0,
              vr: 0.06,
              fromBoss: true,
              bossSpeedMul: 0.4
            });
          }
        }

        // PHASE 1 — fast and relentless. Throws every 1.1s.
        if (state.bossPhase === 'phase1' && !state.bossDefeated) {
          if (now - state.bossLastThrowAt > 1100) {
            state.bossLastThrowAt = now;
            bossThrowSomething(now);
            // Tetra drops her paddle, Gill Bates loses his laptop to a wave;
            // Klaus uses transformer parts instead (injected in bossThrowSomething)
            if (state.bossType === 'greta' || state.bossType === 'gates') maybeDropRacket();
          }
        }
        // PHASE 2 — Brutal. Throws every 550ms (was 900ms) + 40% volley chance.
        if (state.bossPhase === 'phase2' && !state.bossDefeated) {
          if (now - state.bossLastThrowAt > 550) {
            state.bossLastThrowAt = now;
            bossThrowSomething(now);
          }
        }

        // Defeated by deflection (HP=0) → confetti, slide off
        if (state.bossHp <= 0 && !state.bossDefeated) {
          state.bossDefeated = true;
          state.bossWonByPlayer = true;
          state.bossDefeatedAt = now;
          state.bossPhase = 'defeated';
          var rewardScore = state.bossType === 'gates' ? 2000
                          : state.bossType === 'klaus' ? 1500
                          : 1000;
          state.score += rewardScore;
          var defeatMsg;
          if (state.bossType === 'gates') defeatMsg = '💪 GILL BATES BESIEGT — SEIN BOOT BOOTET NICHT MEHR!';
          else if (state.bossType === 'klaus') defeatMsg = '💪 KLAUSEBÄR BESIEGT — 12% RABATT FREIGESCHALTET!';
          else defeatMsg = '💪 TETRA BESIEGT — 10% RABATT FREIGESCHALTET!';
          addStatus(defeatMsg, 3500);
          // Deep, cinematic slow-mo for the whole death animation
          triggerSlomo(3200, 0.15);
          state._defHitL = false;
          state._defHitR = false;
          try { stopBossMusic(); } catch (e) {}
          try { playVictoryJingle(); } catch (e) {}
          // Confetti
          for (var ci = 0; ci < 40; ci++) {
            addParticles(W/2 + (Math.random() - 0.5) * 200,
                         H/2 + (Math.random() - 0.5) * 100,
                         ['#ffd66b','#ff5040','#fff','#6B8E4E'][ci % 4], 4);
          }
          // After defeating Greta, schedule Klaus to arrive 30 seconds later
          if (state.bossType === 'greta' && !state.boss2Spawned && !state.boss2SpawnAt) {
            state.boss2SpawnAt = now + BOSS2_DELAY_AFTER_BOSS1;
          }
          if (state.bossType === 'klaus') {
            state.boss2WonByPlayer = true;
            // Schedule Dr. Windows in 2 min — cow keeps its transformer
            if (!state.boss3Spawned && !state.boss3SpawnAt) {
              state.boss3SpawnAt = now + BOSS3_DELAY_AFTER_BOSS2;
            }
          }
          if (state.bossType === 'gates') state.boss3WonByPlayer = true;
        }
        // Hard time-out at 3 min total → stalemate +200
        if (now >= state.bossUntil && !state.bossDefeated) {
          state.bossDefeated = true;
          state.bossDefeatedAt = now;
          state.bossPhase = 'defeated';
          state.score += 200;
          addStatus('🛡 ÜBERLEBT — TETRA SEGELT WEITER · +200', 3000);
        }
        // GATES FINALE — he escapes Skeletor-style, then endless mode begins
        if (state.gatesEscaping) {
          if (now - state.gatesEscapeAt > 3400) {
            state.gatesEscaping = false;
            state.bossActive = false;
            state.hasRacket = false;
            state.boss3WonByPlayer = true; // outlasting his troll = fight completed
            state.score += 1500;
            addStatus('🏆 ALLE 3 BOSSE ÜBERSTANDEN — 15% GESICHERT! 🚀 UND ES WIRD SCHNELLER…', 4000);
            state.endlessStartAt = now; // Tetris-style ramp until speed or hunger wins
            try { stopBossMusic(); } catch (e) {}
            try { playVictoryJingle(); } catch (e) {}
            try { startAmbient(); } catch (e) {}
          }
        } else if (state.bossDefeated &&
                   now - state.bossDefeatedAt > (state.bossType === 'klaus' ? 4600 : 3400)) {
          // Tetra sinks (3.4s), Klausebär double-crashes + explodes (4.6s),
          // then the game continues.
          state.bossActive = false;
          state.hasRacket = false;
          try { stopBossMusic(); } catch (e) {}
          try { startAmbient(); } catch (e) {}
        }
      }

      // Bug event ending — count refused bugs and award bonus
      if (state.bugEventUntil > 0 && now >= state.bugEventUntil) {
        // Count crickets currently on screen that fell off as "refused"
        var refused = state.bugsRefusedThisEvent;
        if (refused > 0) {
          state.stats.bugsRefused += refused;
          state.score += 100;
          addPopup(W / 2, H / 2 - 60, '+100 YOU REFUSED THE BUGS', true);
        }
        state.bugEventUntil = 0;
        state.bugsRefusedThisEvent = 0;
      }

      // Klima Kleber lifecycle
      if (state.kleber) {
        var k = state.kleber;
        if (!k.gone && now - k.spawnedAt >= KLEBER_DURATION) {
          // Cop arrives, drag-off starts
          if (!k.copAt) {
            k.copAt = now;
            addStatus('👮 POLIZEI — KLEBER ABTRANSPORTIERT', 2400);
            sfx('over');
          }
          // Run-in (900ms) + drag-off (1500ms), then mark gone
          if (now - k.copAt > 2400) {
            state.stats.klebersSurvived++;
            state.kleber = null;
          }
        }
      }

      // Chemtrail plane motion
      if (state.plane) {
        var pl = state.plane;
        pl.x += pl.dir * 2.4 * (dt / 16.67);
        // Apply chemtrail debuff once plane has crossed half the screen
        if (!pl.hasReleased && pl.x > W * 0.3 && pl.x < W * 0.7) {
          pl.hasReleased = true;
          if (!state.wearsTinfoil) {
            state.chemtrailUntil = now + 3000;
            state.stats.chemtrailHits++;
            addStatus('✈️ CHEMTRAILS — CONTROLS FLIPPED', 2000);
          } else {
            addStatus('🪖 TINFOIL DEFLECTED CHEMTRAIL', 1500);
          }
        }
        if (pl.x < -80 || pl.x > W + 80) state.plane = null;
      }

      // Poison tick: drain 3 HP/sec while poisoned
      if (now < state.poisonUntil) {
        if (now - state.poisonTick > 1000) {
          state.poisonTick = now;
          state.hp -= 3;
          addPopup(state.cow.x + state.cow.w / 2, state.cow.y, '-3', false);
          if (state.hp <= 0) { state.hp = 0; endGame(); return; }
        }
      }

      // Testicles beast mode: +30% size, +20% speed
      var beast = now < state.testiclesUntil;
      var shrunk = now < state.fiberUntil;
      var sizeMul = state.growth * (beast ? 1.30 : 1) * (shrunk ? 0.65 : 1);
      state.cow.w = state.cow.baseW * sizeMul;
      state.cow.h = state.cow.baseH * sizeMul;

      // Cow movement
      var left = keys['arrowleft'] || keys['a'] || touchDir === -1;
      var right = keys['arrowright'] || keys['d'] || touchDir === 1;

      // ✈️ Chemtrails — controls inverted while debuff active and no tinfoil
      if (now < state.chemtrailUntil) {
        var tmpL = left; left = right; right = tmpL;
      }

      // Cow base movement speed — tuned down so the game is more entertaining
      // than punishing. Carnivoro / Beast / Inflamed still scale from this.
      var baseSpeed = 5.0;
      if (now < state.carnivoroUntil) baseSpeed = 9.5;
      if (now < state.fiberUntil) baseSpeed = 3.2;
      // 🧪 Inflamed (seed oil) — 60% movement speed
      if (now < state.inflamedUntil) baseSpeed *= 0.6;
      if (beast) baseSpeed *= 1.20;

      var dir = 0;
      if (left) dir -= 1;
      if (right) dir += 1;

      // 🎮 Dash burst — forces direction + 2.4× speed for 250ms
      if (now < state.dashUntil) {
        dir = state.dashDir;
        baseSpeed *= 2.4;
        // Sprinkle particles as cow dashes for visible motion trail
        if (Math.random() < 0.5) {
          var cowCx2 = state.cow.x + state.cow.w / 2;
          state.particles.push({
            x: cowCx2 - state.dashDir * (12 + Math.random() * 6),
            y: state.cow.y + state.cow.h / 2 + (Math.random() - 0.5) * 6,
            vx: -state.dashDir * 1.5,
            vy: 0,
            life: 12,
            color: '#ffd66b'
          });
        }
      }

      state.cow.vx = dir * baseSpeed;

      state.cow.x += state.cow.vx * (dt / 16.67);
      if (state.cow.x < 4) { state.cow.x = 4; state.cow.vx = 0; }
      if (state.cow.x > W - state.cow.w - 4) { state.cow.x = W - state.cow.w - 4; state.cow.vx = 0; }

      // 🦠 Klima Kleber — solid blocker. Cow can't cross their column…
      // …UNLESS star power is active: then the cow just steamrolls them.
      if (state.kleber && !state.kleber.gone) {
        var kx = state.kleber.x;
        var kHalf = 40; // ~80px column
        var cowCx = state.cow.x + state.cow.w / 2;
        if (cowCx > kx - kHalf && cowCx < kx + kHalf) {
          if (now < state.starUntil) {
            // ⭐ INVINCIBLE — flatten the Kleber and keep rolling
            state.score += 150;
            state.stats.klebersTomatoed++;
            addPopup(kx, GROUND_Y - 40, '+150 ÜBERFAHREN! ⭐', true);
            addStatus('⭐ KLEBER PLATTGEWALZT!', 2000);
            addParticles(kx, GROUND_Y - 30, '#ffd66b', 14);
            addParticles(kx, GROUND_Y - 30, '#d44', 8);
            sfx('power');
            state.kleber = null;
          } else {
            // Push cow out if overlapping
            if (cowCx < kx) {
              state.cow.x = kx - kHalf - state.cow.w / 2;
            } else {
              state.cow.x = kx + kHalf - state.cow.w / 2;
            }
            state.cow.vx = 0;
          }
        }
      }

      // Spawn — normal game items are SUSPENDED during the entire boss fight.
      // Items also freeze in place during the walk-in animation.
      var bossWalkingIn = state.bossActive && now < state.bossWalkInUntil;
      var bossOngoing  = state.bossActive && !state.bossDefeated;
      // 🚀 Endless-mode multiplier — after Gill Bates, speed climbs Tetris-style:
      // +35% every 45 seconds, capped at 3x total.
      var endlessMul = 1;
      if (state.endlessStartAt) {
        endlessMul = 1 + Math.min(2.0, ((now - state.endlessStartAt) / 45000) * 0.35);
      }
      if (!bossOngoing && now - state.lastSpawn > lv.spawn / endlessMul) {
        state.lastSpawn = now;
        spawnItem();
      }

      // Items
      var timeScale = currentTimeScale(now);
      var fallSpeed = bossWalkingIn ? 0 : lv.speed * timeScale * endlessMul;
      for (var i = state.items.length - 1; i >= 0; i--) {
        var it = state.items[i];
        // Deflected items follow their own arcade physics with wall bouncing.
        // Lighter gravity (0.30 vs the old 0.42) so they reach Greta.
        if (it.deflected) {
          it.vy = (it.vy || -19) + 0.30;
          it.x += (it.vx || 0);
          it.y += it.vy;
          // Wall bounce — lose a bit of energy each time so they eventually rest
          if (it.x < 16) { it.x = 16; it.vx = Math.abs(it.vx || 0) * 0.82; it.rot = -it.rot; }
          if (it.x > W - 16) { it.x = W - 16; it.vx = -Math.abs(it.vx || 0) * 0.82; it.rot = -it.rot; }
          // Floor bounce — they can come back up
          if (it.y > GROUND_Y - 8) {
            it.y = GROUND_Y - 8;
            it.vy = -Math.abs(it.vy) * 0.6;
            it.vx *= 0.85;
            if (Math.abs(it.vy) < 1.5) { state.items.splice(i, 1); continue; }
          }
          it.rot += (it.vx || 0) * 0.04; // spin while flying
        } else {
          // Boss-thrown items fall faster than regular items
          var mult = it.bossSpeedMul || 1;
          it.y += fallSpeed * mult * (dt / 16.67);
          it.rot += it.vr;
        }

        // Deflected item reaches boss → register a hit (generous hitbox)
        if (it.deflected && state.bossActive && !state.bossDefeated && it.y < 240) {
          if (Math.abs(it.x - state.bossX) < 90) {
            state.bossHp = Math.max(0, state.bossHp - 1);
            addParticles(it.x, it.y, '#ff5040', 14);
            addPopup(state.bossX, 140, '-1 HP', true);
            sfx('power');
            // Greta yelps when hit
            if (state.bossHp > 0) {
              var yelps = state.bossType === 'klaus'
                ? ['NEIN!', 'WAS IST ZAT?!', 'UNMÖGLICH!', 'STOP ZAT!', 'COMPLY!']
                : ['AUTSCH!', 'WIE GEMEIN!', 'BLA!', 'NEIN!', 'WAS?!'];
              state.bossSpeech = yelps[Math.floor(Math.random() * yelps.length)];
              state.bossSpeechUntil = performance.now() + 900;
            }
            state.items.splice(i, 1);
            continue;
          }
        }
        // Deflected item flew off-screen up — clean up
        if (it.deflected && it.y < -40) {
          state.items.splice(i, 1);
          continue;
        }

        // 🏓 PADDLE collision — tennis balls deflect off EITHER the paddle OR
        // the cow body when the racket is equipped (more forgiving = more fun).
        if (state.hasRacket && it.def.isRound && !it.deflected) {
          var paddleX = state.cow.x + state.cow.w + 6 + Math.sin(now / 180) * 2;
          var paddleY = state.cow.y + state.cow.h / 2;
          var paddleHitR = isMobile ? 32 : 24;
          var pdx = it.x - paddleX;
          var pdy = it.y - paddleY;
          if (pdx * pdx + pdy * pdy < paddleHitR * paddleHitR) {
            it.deflected = true;
            it.vy = -19;
            var arcFrames = 19 / 0.3; // ≈ 63
            it.vx = (state.bossX - it.x) / arcFrames;
            addParticles(it.x, it.y, '#fff', 16);
            addParticles(it.x, it.y, '#ffd66b', 8);
            sfx('catch');
            continue;
          }
        }

        // Cow collision — deflected/outgoing projectiles never interact with the cow
        var cx = state.cow.x + 8, cy = state.cow.y;
        var cw = state.cow.w - 16, ch = state.cow.h;
        if (!it.deflected && it.y + 14 > cy && it.y - 14 < cy + ch && it.x + 14 > cx && it.x - 14 < cx + cw) {
          // Tennis ball bouncing off the cow's BODY (not just paddle) counts
          // as a deflection too when the racket is equipped. No damage.
          if (state.hasRacket && it.def.isTennisBall && !it.deflected) {
            it.deflected = true;
            it.vy = -19;
            var arcF = 19 / 0.3;
            it.vx = (state.bossX - it.x) / arcF;
            addParticles(it.x, it.y, '#dafa64', 16);
            addParticles(it.x, it.y, '#fff', 8);
            sfx('catch');
            continue;
          }
          // 🔩 TRANSFORMER PART pickup (Klaus fight)
          if (it.def.isTransformerPart) {
            state.klausParts = (state.klausParts || 0) + 1;
            addParticles(it.x, it.y, '#ffd66b', 18);
            addParticles(it.x, it.y, '#fff', 8);
            sfx('power');
            var partsLeft = KLAUS_PARTS_NEEDED - state.klausParts;
            if (state.klausParts >= KLAUS_PARTS_NEEDED && !state.klausTransformed) {
              // TRANSFORM! Deep slow-mo so the finished ship gets its moment.
              state.klausTransformed = true;
              state.bossPhase = 'phase2';
              addStatus('🛸 KUH-RAUMSCHIFF KOMPLETT! Bugs fangen → 🧃 Juice → ' + (isMobile ? 'FIRE-Knopf' : 'LEERTASTE') + ' = Schuss!', 5000);
              triggerSlomo(2800, 0.1, 0.45);
              state.bossSpeech = 'WAS IST ZAT?! ZE MECH?!';
              state.bossSpeechUntil = performance.now() + 3000;
              state.bossSpeechBig = true;
            } else {
              // Every part pickup: ~90% slowdown for 2s so players SEE the
              // ship grow and can read the counter.
              triggerSlomo(2000, 0.1, 0.5);
              addStatus('🔧 TEIL ' + state.klausParts + '/' + KLAUS_PARTS_NEEDED + ' — DEIN SCHIFF WÄCHST! (' + partsLeft + ' noch)', 2600);
            }
            state.items.splice(i, 1);
            continue;
          }
          // 🐛→🧃 BUG JUICE: the ship's converter turns caught bugs into ammo.
          // Firing is MANUAL via the FIRE button / Leertaste — way more fun.
          if (state.klausTransformed && state.bossType === 'klaus' && it.def.bug) {
            if ((state.bugJuice || 0) < 5) {
              state.bugJuice = (state.bugJuice || 0) + 1;
              addPopup(it.x, it.y, '🧃 +1 BUG JUICE', true);
              addParticles(it.x, it.y, '#7CFC00', 14);
            } else {
              addPopup(it.x, it.y, '🧃 TANK VOLL!', true);
            }
            sfx('catch');
            state.items.splice(i, 1);
            continue;
          }
          // 💾📀 VIRUS-UPLOAD (Gill Bates, laptop equipped): every disk feeds
          // the upload bar +10%. The 10th lands on 99% (Windows loading-bar
          // joke) — then 10 MORE disks are needed before it finally completes.
          if (state.hasRacket && state.bossType === 'gates' && it.def.isDisk) {
            state.disksCollected = (state.disksCollected || 0) + 1;
            var n = state.disksCollected;
            addParticles(it.x, it.y, '#80ffd6', 12);
            sfx('catch');
            if (n === 1) {
              // FIRST disk: super slow-mo + full explanation of the mechanic
              triggerSlomo(2800, 0.08, 0.5);
              addStatus('⬆ JEDE 💾/📀 = +10% VIRUS-UPLOAD AN MICROSOFT!', 4000);
              addPopup(it.x, it.y, '⬆ UPLOAD 10%', true);
            } else if (n === 2 || n === 3) {
              // Disks 2+3 also slow down (less each time) — eases the player
              // into the hectic phase instead of dropping them into it cold.
              triggerSlomo(n === 2 ? 2200 : 1700, n === 2 ? 0.12 : 0.18, 0.45);
              addPopup(it.x, it.y, '⬆ UPLOAD ' + (n * 10) + '%', true);
            } else if (n < 10) {
              addPopup(it.x, it.y, '⬆ UPLOAD ' + (n * 10) + '%', true);
            } else if (n === 10) {
              addPopup(it.x, it.y, '⬆ UPLOAD 99%', true);
              addStatus('⏳ 99%… NATÜRLICH HÄNGT ES BEI 99%. WEITER SAMMELN!', 3500);
              state.bossSpeech = 'HAHA! ZU FRÜH GEFREUT!';
              state.bossSpeechUntil = performance.now() + 2000;
              triggerSlomo(1200);
            } else if (n < 20) {
              var stuck = ['99%…', 'IMMER NOCH 99%…', '99%. WINDOWS HALT.', 'DER BALKEN LÜGT!', '99,9%…'];
              addPopup(it.x, it.y, stuck[Math.floor(Math.random() * stuck.length)], true);
              if (n === 15) addStatus('⏳ FAST GESCHAFFT — DER BALKEN LÜGT, SAMMLE WEITER!', 2500);
            } else {
              // n >= 20 — THE PUNCHLINE: the upload NEVER finishes. Windows.
              // Gates trolls the player and takes off Skeletor-style.
              state.bossSpeech = 'DU DACHTEST WIRKLICH, DER UPLOAD WIRD FERTIG?! MUHAHAHA!';
              state.bossSpeechUntil = performance.now() + 3400;
              state.bossSpeechBig = true;
              state.gatesEscaping = true;
              state.gatesEscapeAt = performance.now();
              state.bossPhase = 'defeated'; // stops his throws during the exit
              addStatus('🛸 GATES HAUT AB — DER BALKEN BLEIBT FÜR IMMER BEI 99%!', 3500);
              triggerSlomo(2200);
            }
            state.items.splice(i, 1);
            continue;
          }
          // Weapon pickup — paddle (Tetra) or laptop (Gill Bates)
          if (it.def.isRacket) {
            state.hasRacket = true;
            state.bossPhase = 'phase2';
            if (state.bossType === 'gates') {
              addStatus('💻 LAPTOP GESCHNAPPT — DEBUG-MODUS AKTIV!', 2800);
            } else {
              addStatus('🏓 SCHLÄGER GESCHNAPPT — Schlag die Bälle zurück!', 2800);
            }
            triggerSlomo(1200);
            state.items.splice(i, 1);
            continue;
          }
          if (it.good) catchGood(it); else hitBad(it);
          state.items.splice(i, 1);
          continue;
        }

        if (it.y > H + 30) {
          if (it.good && !it.def.shield && !it.def.carnivoro && !it.def.testicles && !it.def.antidote && !it.def.isRacket) {
            state.streak = 0;
            state.itemsMissed++;
          }
          // Crickets that fall off during the WEF event = refused (good)
          if (it.def.bug && now < state.bugEventUntil) {
            state.bugsRefusedThisEvent++;
          }
          // Masks that fall off without landing on cow = dodged
          if (it.def.mask) state.stats.masksDodged++;
          // Missed spaceship part → free up the crash counter so Klausebär
          // clips another tower and drops a replacement in a few seconds.
          if (it.def.isTransformerPart) {
            state.klausPartsDropped = Math.max(0, (state.klausPartsDropped || 0) - 1);
            addStatus('🔧 TEIL VERPASST — ER CRASHT GLEICH WIEDER!', 2200);
          }
          state.items.splice(i, 1);
        }
      }

      // Popups
      for (var j = state.popups.length - 1; j >= 0; j--) {
        state.popups[j].y -= 1;
        state.popups[j].life--;
        if (state.popups[j].life <= 0) state.popups.splice(j, 1);
      }

      // Particles
      for (var k = state.particles.length - 1; k >= 0; k--) {
        var p = state.particles[k];
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.2;
        p.life--;
        if (p.life <= 0) state.particles.splice(k, 1);
      }

      if (state.xpFlash > 0) state.xpFlash--;
      if (state.healFlash > 0) state.healFlash--;
      if (state.shakeFrames > 0) state.shakeFrames--;
      if (state.dangerFlash > 0) state.dangerFlash--;
    }

    // Carnivoro bull-head logo — 16x14 pixel-art sprite.
    // Wide curved horns, broad angular head, eye sockets, nostrils, narrow chin.
    var LOGO_BITMAP = [
      '1100000000000011',
      '1110000000000111',
      '0111000000001110',
      '0011100000011100',
      '0001111111111000',
      '0011111111111100',
      '0111011111101110',
      '0111011111101110',
      '0011111111111100',
      '0011111111111100',
      '0001110110111000',
      '0000111111110000',
      '0000011111100000',
      '0000001111000000'
    ];
    function drawLogo(cx, cy, size) {
      var rows = LOGO_BITMAP.length;
      var cols = LOGO_BITMAP[0].length;
      var px = Math.max(2, Math.floor(size / cols));
      var w = cols * px, h = rows * px;
      var x0 = Math.round(cx - w / 2);
      var y0 = Math.round(cy - h / 2);
      ctx.fillStyle = CI.gold;
      for (var r = 0; r < rows; r++) {
        var row = LOGO_BITMAP[r];
        for (var c = 0; c < cols; c++) {
          if (row.charAt(c) === '1') {
            ctx.fillRect(x0 + c * px, y0 + r * px, px, px);
          }
        }
      }
    }

    // Cheap supermarket cooking-oil bottle sprite — NOT the 🧴 lotion emoji.
    // Yellow plastic body, screw cap, red SEED OIL label, yellowish liquid visible.
    // Drawn at the origin of a translated/rotated context (item is at 0,0).
    function drawSeedOilBottle(_x, _y) {
      var w = 28, h = 42;
      ctx.save();
      ctx.translate(-w / 2, -h / 2);
      // Cap (dark screw cap)
      ctx.fillStyle = '#262521';
      ctx.fillRect(w / 2 - 5, 0, 10, 5);
      // Neck (narrower)
      ctx.fillStyle = '#c8b370';
      ctx.fillRect(w / 2 - 4, 5, 8, 4);
      // Bottle body — tall plastic jug with rounded shoulders
      ctx.fillStyle = '#e0bb56'; // amber-yellow oil-in-plastic look
      ctx.beginPath();
      ctx.moveTo(w / 2 - 4, 9);
      ctx.lineTo(2, 14);
      ctx.lineTo(0, h - 4);
      ctx.quadraticCurveTo(0, h, 4, h);
      ctx.lineTo(w - 4, h);
      ctx.quadraticCurveTo(w, h, w, h - 4);
      ctx.lineTo(w - 2, 14);
      ctx.lineTo(w / 2 + 4, 9);
      ctx.closePath();
      ctx.fill();
      // Body outline
      ctx.strokeStyle = '#7a5a30';
      ctx.lineWidth = 1.2;
      ctx.stroke();
      // Red label band
      ctx.fillStyle = '#b91c1c';
      ctx.fillRect(2, 18, w - 4, 14);
      // Label text "OIL" (tiny)
      ctx.fillStyle = '#fff';
      ctx.font = 'bold 7px -apple-system, Helvetica, Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('SEED OIL', w / 2, 25);
      // Cheap-looking yellow "fill line" indicator at bottom
      ctx.fillStyle = '#f0d068';
      ctx.fillRect(3, h - 7, w - 6, 4);
      ctx.restore();
    }

    // Speech-bubble projectile (thrown by Greta von Dungberg).
    // Width scales with text length so longer quotes still fit.
    function drawSpeechBubble(text) {
      var fontSize = 10;
      ctx.font = 'bold ' + fontSize + 'px -apple-system, Helvetica, Arial';
      var measured = ctx.measureText(text).width;
      var w = Math.max(72, measured + 18);
      var h = 26;
      ctx.save();
      ctx.translate(-w / 2, -h / 2);
      // Soft red shadow (it's a baddie)
      ctx.shadowColor = 'rgba(255, 60, 40, 0.55)';
      ctx.shadowBlur = 10;
      // Bubble body — rounded white rect
      ctx.fillStyle = '#fff';
      roundedRectPath(ctx, 0, 0, w, h, 6);
      ctx.fill();
      ctx.shadowBlur = 0;
      // Outline
      ctx.strokeStyle = '#b91c1c';
      ctx.lineWidth = 1.5;
      ctx.stroke();
      // Tail (downward triangle)
      ctx.fillStyle = '#fff';
      ctx.beginPath();
      ctx.moveTo(w / 2 - 5, h);
      ctx.lineTo(w / 2 + 5, h);
      ctx.lineTo(w / 2, h + 7);
      ctx.closePath();
      ctx.fill();
      ctx.strokeStyle = '#b91c1c';
      ctx.beginPath();
      ctx.moveTo(w / 2 - 5, h);
      ctx.lineTo(w / 2, h + 7);
      ctx.lineTo(w / 2 + 5, h);
      ctx.stroke();
      // Text — capital case, red
      ctx.fillStyle = '#b91c1c';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(text, w / 2, h / 2);
      ctx.restore();
    }

    // Cheap supermarket cooking-oil bottle sprite — NOT the 🧴 lotion emoji.
    // Called inside a translated/rotated ctx (item is at origin).
    function drawSprite(kind, label) {
      // Base jar (testicles, organpill) or pouch (broth, tallow) or bottle (electrolytes)
      var isPouch = kind === 'bonebroth' || kind === 'tallow';
      var isBottle = kind === 'electrolytes';
      var w, h;
      if (isPouch) { w = 30; h = 38; }
      else if (isBottle) { w = 22; h = 38; }
      else { w = 28; h = 34; }

      ctx.save();
      ctx.translate(-w / 2, -h / 2);

      // Drop shadow
      ctx.fillStyle = 'rgba(0,0,0,0.55)';
      ctx.fillRect(2, h - 1, w, 3);

      if (isPouch) {
        // Kraft pouch shape
        ctx.fillStyle = CI.cream;
        ctx.fillRect(0, 4, w, h - 4);
        ctx.fillStyle = CI.bg;
        ctx.fillRect(0, 0, w, 5);
        // Label band
        ctx.fillStyle = kind === 'tallow' ? CI.gold : CI.brown;
        ctx.fillRect(2, h - 16, w - 4, 12);
      } else if (isBottle) {
        // Bottle body
        ctx.fillStyle = CI.bg;
        ctx.fillRect(6, 0, w - 12, 5);
        ctx.fillStyle = CI.cream;
        ctx.fillRect(0, 5, w, h - 5);
        ctx.fillStyle = CI.gold;
        ctx.fillRect(2, h - 14, w - 4, 10);
      } else {
        // Amber glass jar
        ctx.fillStyle = CI.bg;
        ctx.fillRect(2, 0, w - 4, 5);
        ctx.fillStyle = CI.brown;
        ctx.fillRect(0, 5, w, h - 5);
        // Label
        ctx.fillStyle = CI.cream;
        ctx.fillRect(2, 10, w - 4, h - 14);
        // Label band
        ctx.fillStyle = CI.gold;
        ctx.fillRect(2, h - 12, w - 4, 8);
      }

      // Carnivoro bull mark (tiny gold dot) top of label
      ctx.fillStyle = CI.gold;
      ctx.fillRect(w / 2 - 1, 12, 2, 2);

      // Tiny label text
      ctx.fillStyle = isPouch && kind === 'bonebroth' ? CI.cream : CI.bg;
      ctx.font = 'bold 5px -apple-system, Helvetica Neue, Arial, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var lbl = (label || '').toUpperCase();
      // Split long labels onto 2 lines
      if (lbl.length > 9) {
        var mid = lbl.indexOf(' ');
        if (mid === -1) mid = Math.floor(lbl.length / 2);
        ctx.fillText(lbl.slice(0, mid), w / 2, h - 9);
        ctx.fillText(lbl.slice(mid + 1), w / 2, h - 3);
      } else {
        ctx.fillText(lbl, w / 2, h - 6);
      }

      ctx.restore();
    }

    // Draw helpers
    function drawText(text, x, y, size, color, align, weight) {
      ctx.fillStyle = color;
      ctx.font = (weight || '700') + ' ' + size + "px -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif";
      ctx.textAlign = align || 'left';
      ctx.textBaseline = 'top';
      ctx.fillText(text, x, y);
    }

    function drawGame() {
      var now = performance.now();

      // 🍄 Trip mode — subtle hue-shift + light blur, still playable
      var tripping = now < state.shroomUntil;
      if (tripping) {
        var hue = (now / 10) % 360;
        try { ctx.filter = 'hue-rotate(' + hue.toFixed(0) + 'deg) blur(1.4px) saturate(2.0)'; } catch (e) {}
      }

      // 💥 Screen shake on bad catches — translates the entire frame a few px
      var shaking = state.shakeFrames > 0;
      if (shaking) {
        ctx.save();
        var amp = state.shakeFrames * 0.6;
        ctx.translate((Math.random() - 0.5) * amp * 2, (Math.random() - 0.5) * amp * 2);
      }

      // BG
      ctx.fillStyle = tripping ? '#140a1e' : '#0d0d0d';
      ctx.fillRect(0, 0, W, H);

      // ground line
      ctx.strokeStyle = '#1a1a1a';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(0, GROUND_Y + 2);
      ctx.lineTo(W, GROUND_Y + 2);
      ctx.stroke();

      // 🌍 Global warming — angry sun in the corner only, NO screen tint.
      // (Tints were darkening the play area. Visual feedback stays in HUD + sun.)
      if (state.planetTemp >= 3) {
        var heat = Math.min(1, state.planetTemp / 16);
        ctx.save();
        ctx.globalAlpha = 0.55 + heat * 0.4;
        ctx.font = Math.round(22 + heat * 16) + 'px serif';
        ctx.textAlign = 'right';
        ctx.textBaseline = 'top';
        ctx.fillText(heat > 0.75 ? '🥵' : (heat > 0.4 ? '☀️' : '🌤'), W - 10, 62);
        ctx.globalAlpha = 1;
        ctx.restore();
      }

      // Items — bad items get bigger + a red danger aura so they're spottable at speed
      for (var i = 0; i < state.items.length; i++) {
        var it = state.items[i];
        ctx.save();
        ctx.translate(it.x, it.y);
        ctx.rotate(it.rot);
        var size = 36;
        if (!it.good && it.def && it.def.dmg) {
          size = 44;
          // Special-mechanic baddies get extra visual punch
          var hi = it.def.bug || it.def.seedOil || it.def.mask;
          var pulse = 0.7 + 0.3 * Math.sin(now / 110);
          ctx.shadowColor = hi
            ? 'rgba(255, 60, 40,' + (0.85 * pulse).toFixed(2) + ')'
            : 'rgba(220, 60, 40, 0.55)';
          ctx.shadowBlur = hi ? 22 : 12;
          if (hi) size = 48;
          // Warning ring for the headline baddies
          if (hi) {
            ctx.strokeStyle = 'rgba(255, 80, 60,' + (0.7 * pulse).toFixed(2) + ')';
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.arc(0, 0, 28, 0, Math.PI * 2);
            ctx.stroke();
          }
        }
        // Special sprites
        if (it.def && it.def.seedOil) {
          drawSeedOilBottle(0, 0);
        } else if (it.def && it.def.isSpeech) {
          drawSpeechBubble(it.def.quote || 'HOW DARE YOU');
        } else if (it.def && it.def.isTransformerPart) {
          // 🔩 Transformer part — gold pulsing collectible
          var ppulse = 0.55 + 0.45 * Math.sin(now / 110);
          ctx.shadowColor = 'rgba(255, 215, 100,' + ppulse.toFixed(2) + ')';
          ctx.shadowBlur = 22;
          ctx.strokeStyle = 'rgba(255, 215, 100,' + (0.9 * ppulse).toFixed(2) + ')';
          ctx.lineWidth = 2.5;
          ctx.beginPath();
          ctx.arc(0, 0, 24, 0, Math.PI * 2);
          ctx.stroke();
          ctx.shadowBlur = 0;
          ctx.font = '36px serif';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(it.def.emoji, 0, 0);
          ctx.save();
          ctx.rotate(-it.rot);
          ctx.fillStyle = '#ffd66b';
          ctx.font = 'bold 10px -apple-system, Helvetica, Arial';
          ctx.fillText('TEIL!', 0, -32);
          ctx.restore();
        } else if (it.def && it.def.isTennisBall) {
          // 🎾 — bright yellow-green pulsing glow so it's instantly distinguishable
          var tpulse = 0.55 + 0.45 * Math.sin(now / 110);
          ctx.shadowColor = 'rgba(180, 240, 60,' + tpulse.toFixed(2) + ')';
          ctx.shadowBlur = 24;
          ctx.strokeStyle = 'rgba(220, 250, 100,' + (0.9 * tpulse).toFixed(2) + ')';
          ctx.lineWidth = 2.5;
          ctx.beginPath();
          ctx.arc(0, 0, 26, 0, Math.PI * 2);
          ctx.stroke();
          ctx.shadowBlur = 0;
          ctx.font = '40px serif';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText('🎾', 0, 0);
          // Counter-rotated "RETOUR!" label so it's always readable
          ctx.save();
          ctx.rotate(-it.rot);
          ctx.fillStyle = '#dafa64';
          ctx.font = 'bold 11px -apple-system, Helvetica, Arial';
          ctx.fillText('RETOUR!', 0, -36);
          ctx.restore();
        } else if (it.def && it.def.isRacket) {
          // 🏓 Racket — IMPOSSIBLE TO MISS
          var rpulse = 0.5 + 0.5 * Math.sin(now / 130);
          // Outer halo glow
          ctx.shadowColor = 'rgba(255, 215, 100,' + rpulse.toFixed(2) + ')';
          ctx.shadowBlur = 32;
          // Two concentric pulsing rings
          ctx.strokeStyle = 'rgba(255, 215, 100,' + (0.9 * rpulse).toFixed(2) + ')';
          ctx.lineWidth = 3;
          ctx.beginPath();
          ctx.arc(0, 0, 32, 0, Math.PI * 2);
          ctx.stroke();
          ctx.strokeStyle = 'rgba(255, 235, 180,' + (0.5 * rpulse).toFixed(2) + ')';
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.arc(0, 0, 44 + rpulse * 4, 0, Math.PI * 2);
          ctx.stroke();
          ctx.shadowBlur = 0;
          // Big weapon emoji — paddle, bone, or Bill's laptop (whatever dropped)
          ctx.font = '54px serif';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(it.def.emoji || '🏓', 0, 0);
          // Floating "GREIF ZU!" — counter-rotate so it's readable
          ctx.save();
          ctx.rotate(-it.rot);
          ctx.fillStyle = '#ffd66b';
          ctx.font = 'bold 13px -apple-system, Helvetica, Arial';
          ctx.textAlign = 'center';
          ctx.fillText('▼ GREIF ZU! ▼', 0, -52);
          ctx.restore();
        } else {
          ctx.font = size + 'px serif';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(it.def.emoji, 0, 0);
        }
        ctx.restore();
      }

      // Cow
      var cow = state.cow;
      ctx.save();
      if (now < state.starUntil) {
        var hueS = (now / 4) % 360;
        ctx.shadowColor = 'hsl(' + hueS + ',100%,60%)';
        ctx.shadowBlur = 22;
      }
      if (now < state.carnivoroUntil) {
        ctx.shadowColor = CI.gold;
        ctx.shadowBlur = 14;
      }
      if (state.healFlash > 0) {
        ctx.shadowColor = CI.cream;
        ctx.shadowBlur = 10 + state.healFlash * 0.5;
      }
      // 🧪 Inflamed glow — red pulsing aura
      if (now < state.inflamedUntil) {
        var puls = 0.6 + 0.4 * Math.sin(now / 120);
        ctx.shadowColor = 'rgba(220, 60, 40,' + puls.toFixed(2) + ')';
        ctx.shadowBlur = 24;
      }
      if (now < state.shieldUntil && state.shieldHits > 0) {
        ctx.strokeStyle = 'rgba(80, 170, 255, 0.9)';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(cow.x + cow.w / 2, cow.y + cow.h / 2, 34, 0, Math.PI * 2);
        ctx.stroke();
      }
      var beastScale = now < state.testiclesUntil ? 1.30 : 1;
      // 🛸 SPACESHIP build-up — each collected part visibly adds to the ship.
      // The cow ends up sitting in a saucer cockpit with bug-conversion machinery.
      var shipStage = (state.klausTransformed || state.bossType === 'gates') ? 5 : (state.klausParts || 0);
      var scx = cow.x + cow.w / 2;
      var scy = cow.y + cow.h / 2;
      if (shipStage >= 1) {
        ctx.save();
        ctx.shadowBlur = 0;
        // Part 1 — saucer hull under the cow
        var hullGrad = ctx.createLinearGradient(scx - 40, 0, scx + 40, 0);
        hullGrad.addColorStop(0, '#8a8f98');
        hullGrad.addColorStop(0.5, '#c9ced6');
        hullGrad.addColorStop(1, '#8a8f98');
        ctx.fillStyle = hullGrad;
        ctx.beginPath();
        ctx.ellipse(scx, scy + 18, 40, 12, 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = '#565b63';
        ctx.lineWidth = 1.5;
        ctx.stroke();
        if (shipStage >= 2) {
          // Part 2 — side machinery pods with rivets
          ctx.fillStyle = '#6b7078';
          ctx.fillRect(scx - 48, scy + 6, 12, 14);
          ctx.fillRect(scx + 36, scy + 6, 12, 14);
          ctx.fillStyle = '#ffd66b';
          ctx.fillRect(scx - 45, scy + 9, 3, 3);
          ctx.fillRect(scx + 42, scy + 9, 3, 3);
        }
        if (shipStage >= 3) {
          // Part 3 — glass cockpit dome over the cow
          ctx.fillStyle = 'rgba(160, 220, 255, 0.22)';
          ctx.beginPath();
          ctx.arc(scx, scy + 2, 34, Math.PI, 0);
          ctx.fill();
          ctx.strokeStyle = 'rgba(200, 240, 255, 0.7)';
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.arc(scx, scy + 2, 34, Math.PI, 0);
          ctx.stroke();
        }
        if (shipStage >= 4) {
          // Part 4 — bug intake funnel + pipe into the converter
          ctx.fillStyle = '#565b63';
          ctx.beginPath();
          ctx.moveTo(scx - 44, scy - 18);
          ctx.lineTo(scx - 28, scy - 18);
          ctx.lineTo(scx - 33, scy - 6);
          ctx.lineTo(scx - 39, scy - 6);
          ctx.closePath();
          ctx.fill();
          ctx.fillRect(scx - 38, scy - 6, 4, 16);
          // Suction sparkle
          if (Math.floor(now / 300) % 2 === 0) {
            ctx.font = '10px serif';
            ctx.fillText('✨', scx - 36, scy - 24);
          }
        }
        if (shipStage >= 5) {
          // Part 5 — juice tank (mini fill level) + cannon on top
          var tankX = scx + 40, tankY = scy - 14;
          ctx.fillStyle = '#2a2d33';
          ctx.fillRect(tankX, tankY, 10, 24);
          var fillH = Math.round(((state.bugJuice || 0) / 5) * 20);
          ctx.fillStyle = '#7CFC00';
          ctx.fillRect(tankX + 2, tankY + 22 - fillH, 6, fillH);
          ctx.strokeStyle = '#9aa0a8';
          ctx.lineWidth = 1;
          ctx.strokeRect(tankX, tankY, 10, 24);
          // Cannon barrel pointing up
          ctx.fillStyle = '#565b63';
          ctx.fillRect(scx - 3, scy - 40, 6, 16);
          ctx.fillStyle = '#7CFC00';
          ctx.fillRect(scx - 2, scy - 42, 4, 3);
          // Engine glow when transformed
          var mechPulse = 0.5 + 0.5 * Math.sin(now / 160);
          ctx.fillStyle = 'rgba(124, 252, 0,' + (0.25 * mechPulse).toFixed(2) + ')';
          ctx.beginPath();
          ctx.ellipse(scx, scy + 30, 30, 6, 0, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
      }
      ctx.font = Math.round(44 * beastScale) + 'px serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('🐄', cow.x + cow.w / 2, cow.y + cow.h / 2);
      // 😷 Mask on cow's face
      if (state.wearsMask) {
        var mcx = cow.x + cow.w / 2;
        var mcy = cow.y + cow.h / 2 + 6;
        ctx.save();
        ctx.shadowBlur = 0;
        ctx.fillStyle = '#f2f3f5';
        ctx.strokeStyle = '#b9bcc1';
        ctx.lineWidth = 1.2;
        ctx.beginPath();
        ctx.moveTo(mcx - 14, mcy - 3);
        ctx.quadraticCurveTo(mcx, mcy - 7, mcx + 14, mcy - 3);
        ctx.lineTo(mcx + 14, mcy + 7);
        ctx.quadraticCurveTo(mcx, mcy + 11, mcx - 14, mcy + 7);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        ctx.restore();
      }
      // 🏓 Ping-pong paddle equipped — drawn next to cow's body with hitbox glow
      if (state.hasRacket) {
        var rx = cow.x + cow.w + 6 + Math.sin(now / 180) * 2;
        var ry = cow.y + cow.h / 2;
        ctx.save();
        ctx.shadowBlur = 0;
        // Pulsing aim-ring so the player sees the deflection sweet spot
        var ringPulse = 0.4 + 0.3 * Math.sin(now / 220);
        ctx.strokeStyle = 'rgba(255, 215, 100, ' + ringPulse.toFixed(2) + ')';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(rx, ry, 24, 0, Math.PI * 2);
        ctx.stroke();
        // Equipped weapon — paddle vs. Bill's laptop
        ctx.font = '34px serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(state.bossType === 'gates' ? '💻' : '🏓', rx, ry);
        ctx.restore();
      }

      // 🪖 Tinfoil hat on cow's head
      if (state.wearsTinfoil) {
        var hcx = cow.x + cow.w / 2;
        var hy = cow.y - 6;
        ctx.save();
        ctx.shadowBlur = 0;
        ctx.fillStyle = '#c8ccd0';
        ctx.strokeStyle = '#7a7e84';
        ctx.lineWidth = 1.4;
        ctx.beginPath();
        ctx.moveTo(hcx - 14, hy + 4);
        ctx.lineTo(hcx + 14, hy + 4);
        ctx.lineTo(hcx + 7,  hy - 12);
        ctx.lineTo(hcx + 2,  hy - 6);
        ctx.lineTo(hcx - 3,  hy - 11);
        ctx.lineTo(hcx - 10, hy - 5);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        if (Math.floor(now / 200) % 2 === 0) {
          ctx.fillStyle = '#fff';
          ctx.font = 'bold 10px sans-serif';
          ctx.fillText('✨', hcx + 12, hy - 10);
        }
        ctx.restore();
      }
      if (now < state.testiclesUntil) {
        ctx.font = 'bold 8px sans-serif';
        ctx.fillStyle = '#ffd700';
        ctx.fillText('BEAST', cow.x + cow.w / 2, cow.y - 8);
      }
      if (now < state.poisonUntil) {
        ctx.font = '16px serif';
        ctx.fillText('🤢', cow.x + cow.w / 2 - 22 + Math.sin(now / 120) * 2, cow.y + cow.h / 2 - 18);
      }
      if (now < state.fartUntil) {
        ctx.font = '22px serif';
        ctx.fillText('💨', cow.x - 4 + Math.sin(now / 100) * 3, cow.y + cow.h / 2 + 8);
        ctx.fillText('💨', cow.x + cow.w + 6 + Math.sin(now / 130) * 3, cow.y + cow.h / 2 + 4);
      }
      if (now < state.overheatUntil) {
        ctx.font = '18px serif';
        ctx.fillText('🔥', cow.x + cow.w / 2 - 14, cow.y - 18 + Math.sin(now / 120) * 2);
        ctx.fillText('🔥', cow.x + cow.w / 2 + 14, cow.y - 18 + Math.sin(now / 140) * 2);
      }
      if (now < state.nauseaUntil) {
        ctx.font = '20px serif';
        ctx.fillText('🤢', cow.x + cow.w / 2 - 22 + Math.sin(now / 120) * 2, cow.y - 4);
      }
      if (state.healFlash > 0) {
        ctx.font = '18px serif';
        ctx.fillText('❤️', cow.x + cow.w / 2 + 20, cow.y - 8 - (18 - state.healFlash));
      }
      if (now < state.starUntil) {
        ctx.font = '22px serif';
        ctx.fillText('⭐', cow.x + cow.w / 2 - 22, cow.y - 18);
        ctx.fillText('⭐', cow.x + cow.w / 2 + 22, cow.y - 18);
      }
      ctx.restore();

      // 🍄 Reset trip filter so HUD/text stays readable
      if (tripping) {
        try { ctx.filter = 'none'; } catch (e) {}
      }

      // 🏗 Warning towers (Klausebär fight) — the obstacles his helicopter
      // keeps clipping. Hazard-striped pylons at both screen edges.
      if (state.bossActive && state.bossType === 'klaus') {
        ctx.save();
        [26, W - 26].forEach(function (tx) {
          // Pylon
          ctx.fillStyle = '#565b63';
          ctx.fillRect(tx - 5, 96, 10, 130);
          // Hazard stripes
          for (var hs = 0; hs < 6; hs++) {
            ctx.fillStyle = hs % 2 === 0 ? '#ffb020' : '#242329';
            ctx.fillRect(tx - 5, 96 + hs * 21, 10, 11);
          }
          // Blinking warning light on top
          if (Math.floor(now / 400) % 2 === 0) {
            ctx.fillStyle = '#ff4030';
            ctx.beginPath();
            ctx.arc(tx, 90, 4, 0, Math.PI * 2);
            ctx.fill();
          }
        });
        ctx.restore();

        // 🧃 BUG JUICE — big vertical tank on the left edge (after transformation)
        if (state.klausTransformed) {
          var jbX = 10, jbY = 250, jbW = 18, jbH = 140;
          ctx.save();
          ctx.fillStyle = 'rgba(0,0,0,0.65)';
          ctx.fillRect(jbX - 3, jbY - 22, jbW + 6, jbH + 30);
          // Tank glass
          ctx.fillStyle = '#14161a';
          ctx.fillRect(jbX, jbY, jbW, jbH);
          // Segment fill — 5 units bottom-up
          var units = state.bugJuice || 0;
          for (var ju = 0; ju < 5; ju++) {
            var segY = jbY + jbH - (ju + 1) * (jbH / 5) + 2;
            ctx.fillStyle = ju < units ? '#7CFC00' : 'rgba(124,252,0,0.12)';
            ctx.fillRect(jbX + 2, segY, jbW - 4, jbH / 5 - 4);
          }
          ctx.strokeStyle = '#9aa0a8';
          ctx.lineWidth = 1.5;
          ctx.strokeRect(jbX, jbY, jbW, jbH);
          // Label
          ctx.fillStyle = '#7CFC00';
          ctx.font = 'bold 8px -apple-system, Helvetica, Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText('🧃', jbX + jbW / 2, jbY - 12);
          ctx.save();
          ctx.translate(jbX + jbW / 2, jbY + jbH + 4);
          ctx.fillText('JUICE', 0, 0);
          ctx.restore();
          ctx.restore();
        }
      }

      // 🚢 TETRA VON DUNGPACK — sailship boss
      if (state.bossActive) {
        var bossY = 150;
        var bx = state.bossX;
        // Exit animations — every boss dies its own themed death:
        //  Tetra: sinks into the ocean.  Klausebär: crashes left, crashes
        //  right HARDER, explodes.  Gill Bates: Skeletor-style lift-off.
        var defeatT = 0;
        var klausExploding = false;
        var exiting = state.bossDefeated || state.gatesEscaping;
        if (exiting) {
          ctx.save();
          if (state.gatesEscaping) {
            var riseT = Math.min(1, (now - state.gatesEscapeAt) / 3400);
            bossY -= riseT * riseT * 420;      // accelerating ascent
            bx += Math.sin(now / 90) * 3;       // wobbling like a bad rocket
            ctx.globalAlpha = Math.max(0, 1 - Math.max(0, riseT - 0.65) / 0.35);
            // Exhaust under the flying yacht
            ctx.font = '18px serif';
            ctx.fillText('💨', bx - 14, bossY + 70);
            ctx.fillText('🔥', bx + 12, bossY + 74);
          } else if (state.bossType === 'greta') {
            // 🌊 Tetra sinks — accelerating descent, bubbles rising
            var sinkP = Math.min(1, (now - state.bossDefeatedAt) / 3400);
            bossY += sinkP * sinkP * 300;
            ctx.globalAlpha = Math.max(0, 1 - Math.max(0, sinkP - 0.55) / 0.45);
            ctx.font = '15px serif';
            for (var bb = 0; bb < 4; bb++) {
              var bubY2 = bossY - 10 - ((now / 7 + bb * 40) % 120);
              ctx.fillText('🫧', bx - 28 + bb * 19, bubY2);
            }
          } else if (state.bossType === 'klaus') {
            // 🚁 Death crash choreography: lurch LEFT (hit), swing RIGHT
            // harder (hit), then EXPLODE at the right tower.
            var tK = now - state.bossDefeatedAt;
            var structLx = 26, structRx = W - 26;
            if (tK < 1400) {
              var p1 = tK / 1400;
              bx = W / 2 + (structLx + 16 - W / 2) * (p1 * p1);   // accelerate left
              bossY += Math.sin(now / 60) * 3;                     // rattling
              if (!state._defHitL && p1 > 0.96) {
                state._defHitL = true;
                state.shakeFrames = 12;
                addParticles(structLx + 10, bossY, '#ffb020', 22);
                sfx('bad');
              }
            } else if (tK < 3000) {
              var p2 = (tK - 1400) / 1600;
              bx = (structLx + 16) + (structRx - 16 - structLx - 16) * (p2 * p2);
              bossY += Math.sin(now / 40) * 5;                     // rattling harder
              ctx.font = '14px serif';
              ctx.fillText('💨', bx - 30, bossY - 10);             // smoke trail
              if (!state._defHitR && p2 > 0.96) {
                state._defHitR = true;
                state.shakeFrames = 18;
                addParticles(structRx - 10, bossY, '#ffb020', 30);
                addParticles(structRx - 10, bossY, '#ff5040', 20);
                sfx('over');
              }
            } else {
              // 💥 EXPLOSION at the right tower — helicopter is gone
              klausExploding = true;
              bx = structRx - 16;
              var pe = Math.min(1, (tK - 3000) / 1600);
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.globalAlpha = Math.max(0, 1 - Math.max(0, pe - 0.5) / 0.5);
              ctx.font = Math.round(50 + pe * 70) + 'px serif';
              ctx.fillText('💥', bx, bossY);
              ctx.font = '22px serif';
              ctx.fillText('🔥', bx - 26 - pe * 20, bossY + 16 + pe * 40);
              ctx.fillText('🔥', bx + 24 + pe * 16, bossY + 10 + pe * 50);
              ctx.fillText('💨', bx, bossY - 30 - pe * 40);
            }
          } else {
            defeatT = Math.min(1, (now - state.bossDefeatedAt) / 1500);
            bx += defeatT * (W * 0.7);
            ctx.globalAlpha = 1 - defeatT;
          }
        }
        var isKlausRender = state.bossType === 'klaus';
        var isGatesRender = state.bossType === 'gates';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        var bobY = Math.sin(now / 220) * 2;
        if (isGatesRender) {
          // 🌊 Wave lurch — the whole yacht heaves up as the big wave passes under it
          if (state.gatesWaveAt) {
            var wvT = now - state.gatesWaveAt;
            var wvSpd = (bx + 160) / 1100;
            var wvX = -160 + wvSpd * wvT;
            var wvD = Math.abs(wvX - bx);
            if (wvT < 2600 && wvD < 90) bossY -= (1 - wvD / 90) * 36;
          }
          // Evil red pulsing aura around Gill Bates
          var evilPulse = 0.5 + 0.5 * Math.sin(now / 180);
          ctx.save();
          ctx.shadowColor = 'rgba(220, 30, 30,' + evilPulse.toFixed(2) + ')';
          ctx.shadowBlur = 38;
          ctx.fillStyle = 'rgba(220, 30, 30,0)';
          ctx.beginPath();
          ctx.arc(bx, bossY + 6, 60, 0, Math.PI * 2);
          ctx.fill();
          ctx.restore();
          // Speedboat waves — choppy water + spray behind the racing yacht
          bobY = Math.sin(now / 150) * 5; // harder bob: he's speeding over waves
          ctx.save();
          ctx.strokeStyle = 'rgba(140, 190, 220, 0.55)';
          ctx.lineWidth = 3;
          for (var wv = 0; wv < 3; wv++) {
            var wOffX = ((now / 60) + wv * 30) % 90 - 45;
            ctx.beginPath();
            ctx.arc(bx + wOffX, bossY + 62, 14, Math.PI * 0.15, Math.PI * 0.85);
            ctx.stroke();
          }
          // Spray droplets
          ctx.font = '14px serif';
          ctx.globalAlpha = 0.7;
          ctx.fillText('💦', bx - 52 + Math.sin(now / 90) * 4, bossY + 48);
          ctx.fillText('💦', bx + 52 + Math.cos(now / 110) * 4, bossY + 52);
          ctx.restore();
          // Super yacht
          ctx.font = '92px serif';
          ctx.fillText('🛥️', bx, bossY + 32 + bobY * 0.5);
          // Dr. Windows figure (pregnant-guy emoji per user spec)
          ctx.font = '40px serif';
          ctx.fillText('🫃', bx, bossY - 14 + bobY);
          // Laptop in his hand — the virus factory
          ctx.font = '24px serif';
          ctx.fillText('💻', bx + 30, bossY - 6 + bobY);
          // Skull on the yacht (extra evil flourish)
          ctx.font = '18px serif';
          ctx.fillText('💀', bx - 32, bossY + 18);
        } else if (isKlausRender && !klausExploding) {
          // Helicopter rotor blur — animated horizontal blade
          ctx.save();
          ctx.strokeStyle = 'rgba(200, 200, 200, 0.45)';
          ctx.lineWidth = 3;
          var rotorWidth = 90 + Math.sin(now / 25) * 6;
          ctx.beginPath();
          ctx.moveTo(bx - rotorWidth, bossY - 20);
          ctx.lineTo(bx + rotorWidth, bossY - 20);
          ctx.stroke();
          ctx.restore();
          // Big helicopter emoji
          ctx.font = '88px serif';
          ctx.fillText('🚁', bx, bossY + 24);
          // Klaus figure on top — old man
          ctx.font = '36px serif';
          ctx.fillText('👴', bx, bossY - 14 + bobY);
          // Briefcase floating beside
          ctx.font = '20px serif';
          ctx.fillText('💼', bx + 28, bossY - 6 + bobY);
        } else if (isKlausRender && klausExploding) {
          // Nothing — the explosion drawn above replaces the helicopter
        } else {
          // Wake/water lines under the ship
          ctx.fillStyle = 'rgba(120, 170, 200, 0.35)';
          for (var w = 0; w < 3; w++) {
            var wOff = ((now / 80) + w * 24) % 70 - 35;
            ctx.beginPath();
            ctx.ellipse(bx + wOff, bossY + 56, 24, 3, 0, 0, Math.PI * 2);
            ctx.fill();
          }
          ctx.font = '96px serif';
          ctx.fillText('⛵', bx, bossY + 24);
          ctx.font = '38px serif';
          ctx.fillText('👧', bx - 8, bossY - 18 + bobY);
          ctx.font = '18px serif';
          ctx.fillText('😡', bx + 16, bossY - 28 + bobY);
        }
        // Name tag — adapts to bossType. Hidden during the explosion finale.
        if (!klausExploding) {
          var nameTag = isGatesRender ? 'GILL BATES'
                      : isKlausRender ? 'DAVOS KLAUSEBÄR'
                      : 'TETRA VON DUNGPACK';
          ctx.fillStyle = 'rgba(0,0,0,0.7)';
          var tagW = isGatesRender ? 140 : isKlausRender ? 200 : 160;
          ctx.fillRect(bx - tagW/2, bossY - 56, tagW, 16);
          ctx.fillStyle = CI.gold;
          ctx.font = 'bold 10px -apple-system, Helvetica, Arial';
          ctx.fillText(nameTag, bx, bossY - 48);
        }
        // Bar above the ship — HP for Tetra/Klausebär. Gill Bates has no small
        // bar: his progress lives in the big ID4-style upload console below.
        var bossWalkingInDraw = now < state.bossWalkInUntil && !state.bossDefeated;
        if (!bossWalkingInDraw && !state.bossDefeated && !isGatesRender) {
          var hpW = 180, hpH = 8;
          var hpX = bx - hpW / 2;
          var hpY = bossY - 78;
          ctx.fillStyle = '#000';
          ctx.fillRect(hpX - 2, hpY - 2, hpW + 4, hpH + 4);
          ctx.fillStyle = '#1a0a0e';
          ctx.fillRect(hpX, hpY, hpW, hpH);
          var hpMaxD = state.bossHpMax || BOSS_HP_MAX;
          var hpFrac = state.bossHp / hpMaxD;
          ctx.fillStyle = hpFrac > 0.5 ? '#3fbf5b' : (hpFrac > 0.25 ? '#e0a93a' : '#d84a3a');
          ctx.fillRect(hpX, hpY, hpW * hpFrac, hpH);
          ctx.fillStyle = CI.cream;
          ctx.font = 'bold 9px -apple-system, Helvetica, Arial';
          ctx.fillText(Math.max(0, Math.round(state.bossHp)) + ' / ' + hpMaxD, bx, hpY - 8);
        }
        if (state.bossDefeated || state.gatesEscaping) ctx.restore();

        // Floating speech bubble anchored to Greta (yelps, racket announcement, etc.)
        if (state.bossSpeech && now < state.bossSpeechUntil && !bossWalkingInDraw) {
          var sFade = Math.min(1, (state.bossSpeechUntil - now) / 350);
          ctx.save();
          ctx.globalAlpha = sFade;
          var sText = state.bossSpeech;
          // Bigger font when the racket drop is being announced — but sized so
          // the bubble always fits the canvas.
          var bigBubble = !!state.bossSpeechBig;
          var sFontSize = bigBubble ? 15 : 13;
          if (now > state.bossSpeechUntil - 50) state.bossSpeechBig = false;
          ctx.font = 'bold ' + sFontSize + 'px -apple-system, Helvetica, Arial';
          var sMeasured = ctx.measureText(sText).width;
          // Shrink font further if the text would exceed the canvas width
          while (sMeasured > W - 40 && sFontSize > 10) {
            sFontSize--;
            ctx.font = 'bold ' + sFontSize + 'px -apple-system, Helvetica, Arial';
            sMeasured = ctx.measureText(sText).width;
          }
          var sW = Math.max(120, sMeasured + 20);
          var sH = 30;
          // Clamp the bubble inside the canvas even when the boss sways to the edge
          var bubbleCx = Math.max(sW / 2 + 8, Math.min(W - sW / 2 - 8, bx));
          var sX = bubbleCx - sW / 2;
          var sY = bossY - 96;
          // Bubble body
          ctx.fillStyle = 'rgba(0,0,0,0.55)';
          roundedRectPath(ctx, sX + 2, sY + 3, sW, sH, 10);
          ctx.fill();
          ctx.fillStyle = '#fff';
          roundedRectPath(ctx, sX, sY, sW, sH, 10);
          ctx.fill();
          ctx.strokeStyle = '#b91c1c';
          ctx.lineWidth = 1.5;
          ctx.stroke();
          // Downward tail — still points at the boss, clamped inside the bubble
          var tailX = Math.max(sX + 16, Math.min(sX + sW - 16, bx));
          ctx.fillStyle = '#fff';
          ctx.beginPath();
          ctx.moveTo(tailX - 6, sY + sH);
          ctx.lineTo(tailX + 6, sY + sH);
          ctx.lineTo(tailX, sY + sH + 10);
          ctx.closePath();
          ctx.fill();
          ctx.strokeStyle = '#b91c1c';
          ctx.beginPath();
          ctx.moveTo(tailX - 6, sY + sH);
          ctx.lineTo(tailX, sY + sH + 10);
          ctx.lineTo(tailX + 6, sY + sH);
          ctx.stroke();
          ctx.fillStyle = '#b91c1c';
          ctx.font = 'bold ' + sFontSize + 'px -apple-system, Helvetica, Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(sText, bubbleCx, sY + sH / 2);
          ctx.restore();
        }

        // 🌊 THE BIG WAVE — a huge wall of water rolling across the screen.
        // It slams the yacht at ~1.1s (that's when the laptop flies out).
        if (isGatesRender && state.gatesWaveAt) {
          var gwT = now - state.gatesWaveAt;
          var gwSpd = (bx + 160) / 1100;
          var gwX = -160 + gwSpd * gwT;
          if (gwX < W + 260) {
            var seaY = bossY + 70;
            ctx.save();
            var wGrad = ctx.createLinearGradient(0, seaY - 135, 0, seaY + 10);
            wGrad.addColorStop(0, 'rgba(185, 228, 255, 0.95)');
            wGrad.addColorStop(0.35, 'rgba(70, 150, 210, 0.9)');
            wGrad.addColorStop(1, 'rgba(18, 58, 118, 0.85)');
            ctx.fillStyle = wGrad;
            ctx.beginPath();
            ctx.moveTo(gwX - 220, seaY + 8);
            ctx.quadraticCurveTo(gwX - 120, seaY - 40, gwX - 40, seaY - 105);
            ctx.quadraticCurveTo(gwX + 10, seaY - 138, gwX + 55, seaY - 112);
            ctx.quadraticCurveTo(gwX + 92, seaY - 92, gwX + 60, seaY - 78);
            ctx.quadraticCurveTo(gwX + 96, seaY - 55, gwX + 132, seaY - 20);
            ctx.quadraticCurveTo(gwX + 162, seaY, gwX + 192, seaY + 8);
            ctx.closePath();
            ctx.fill();
            // Foam crest — churning white caps along the top
            ctx.fillStyle = 'rgba(255,255,255,0.9)';
            for (var fc = 0; fc < 6; fc++) {
              var fx = gwX - 34 + fc * 18 + Math.sin(now / 70 + fc) * 4;
              var fy = seaY - 112 + Math.sin(now / 90 + fc * 2) * 6 - fc * 2;
              ctx.beginPath();
              ctx.arc(fx, fy, 7 - fc * 0.5, 0, Math.PI * 2);
              ctx.fill();
            }
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = '46px serif';
            ctx.fillText('🌊', gwX - 74, seaY - 34);
            ctx.fillText('🌊', gwX + 64, seaY - 26);
            ctx.font = '30px serif';
            ctx.fillText('💦', gwX + 6, seaY - 130);
            ctx.restore();
          }
        }

        // 🖥️ ID4-STYLE VIRUS-UPLOAD CONSOLE — big, unmissable, and forever
        // stuck at 99%. That's the joke. It's Windows.
        if (isGatesRender && state.hasRacket && !bossWalkingInDraw) {
          var cnD = state.disksCollected || 0;
          var cPct = cnD >= 10 ? 99 : cnD * 10;
          var pnW = Math.min(360, W - 56), pnH = 58;
          var pnX = (W - pnW) / 2, pnY = 226;
          ctx.save();
          ctx.globalAlpha = 1;
          ctx.fillStyle = 'rgba(4, 12, 6, 0.88)';
          roundedRectPath(ctx, pnX, pnY, pnW, pnH, 6);
          ctx.fill();
          ctx.strokeStyle = 'rgba(74, 222, 128, 0.9)';
          ctx.lineWidth = 2;
          ctx.stroke();
          ctx.textBaseline = 'middle';
          ctx.textAlign = 'left';
          ctx.fillStyle = '#4ade80';
          ctx.font = 'bold 10px Menlo, Consolas, monospace';
          ctx.fillText('C:\\> VIRUS_UPLOAD.EXE → MICROSOFT-SERVER', pnX + 10, pnY + 12);
          // Segmented progress bar
          var pbX = pnX + 10, pbY = pnY + 22, pbW = pnW - 74, pbH = 14;
          ctx.fillStyle = '#04180a';
          ctx.fillRect(pbX, pbY, pbW, pbH);
          ctx.strokeStyle = 'rgba(74, 222, 128, 0.6)';
          ctx.lineWidth = 1;
          ctx.strokeRect(pbX, pbY, pbW, pbH);
          var segs = 20, segW = (pbW - segs - 1) / segs;
          var filled = Math.round(segs * cPct / 100);
          for (var sg = 0; sg < filled; sg++) {
            // At 99% the last segment flickers forever — it will NEVER complete
            ctx.fillStyle = (cPct >= 99 && sg === filled - 1)
              ? 'rgba(74, 222, 128,' + (0.3 + 0.7 * Math.abs(Math.sin(now / 160))).toFixed(2) + ')'
              : '#4ade80';
            ctx.fillRect(pbX + 2 + sg * (segW + 1), pbY + 2, segW, pbH - 4);
          }
          // Big percent readout
          ctx.textAlign = 'right';
          ctx.font = 'bold 20px Menlo, Consolas, monospace';
          if (cPct >= 99) {
            ctx.fillStyle = Math.sin(now / 170) > -0.2 ? '#facc15' : '#7f1d1d';
            ctx.fillText('99%', pnX + pnW - 10, pbY + pbH / 2 + 1);
          } else {
            ctx.fillStyle = '#4ade80';
            ctx.fillText(cPct + '%', pnX + pnW - 10, pbY + pbH / 2 + 1);
          }
          // Status line — Windows-style time estimates that only get worse
          ctx.textAlign = 'left';
          ctx.font = '9px Menlo, Consolas, monospace';
          var cCursor = (Math.floor(now / 400) % 2 === 0) ? '▮' : ' ';
          if (cPct >= 99) {
            var UPLOAD_QUIPS = [
              'VERBLEIBENDE ZEIT: 1 SEKUNDE…',
              'VERBLEIBENDE ZEIT: 47 MINUTEN…',
              'VERBLEIBENDE ZEIT: 4 STUNDEN…',
              'BERECHNE VERBLEIBENDE ZEIT…',
              'VERBLEIBENDE ZEIT: 12 TAGE…'
            ];
            ctx.fillStyle = '#facc15';
            ctx.fillText(UPLOAD_QUIPS[Math.floor(now / 1300) % UPLOAD_QUIPS.length] + ' ' + cCursor, pnX + 10, pnY + pnH - 11);
          } else {
            var cDots = '...'.slice(0, 1 + Math.floor(now / 350) % 3);
            ctx.fillStyle = '#4ade80';
            ctx.fillText('UPLOADING' + cDots + ' 💾/📀 SAMMELN = +10% ' + cCursor, pnX + 10, pnY + pnH - 11);
          }
          ctx.restore();
        }

        // BIG walk-in intro speech bubble — quotes split the walk-in EVENLY,
        // so no quote ever shows twice (the old fixed 3s slots made the last
        // quote linger and look repeated).
        if (bossWalkingInDraw) {
          var elapsed = now - state.bossEnteredAt;
          var walkDur = Math.max(1, state.bossWalkInUntil - state.bossEnteredAt);
          var perQuote = walkDur / Math.max(1, state.bossIntros.length);
          var slot = Math.min(state.bossIntros.length - 1, Math.floor(elapsed / perQuote));
          // Per-quote fade: 250ms in, 250ms out, hold in between
          var withinSlot = elapsed - slot * perQuote;
          var qFadeIn = Math.min(1, withinSlot / 250);
          var qFadeOut = Math.min(1, (perQuote - withinSlot) / 250);
          var alpha = Math.min(qFadeIn, qFadeOut);
          ctx.save();
          ctx.globalAlpha = alpha;
          var bubbleText = state.bossIntros[slot] || state.bossIntros[0];
          var fontSize = 16;
          ctx.font = 'bold ' + fontSize + 'px -apple-system, Helvetica, Arial';
          var metrics = ctx.measureText(bubbleText);
          var bubbleW = Math.max(220, metrics.width + 36);
          var bubbleH = 56;
          var bubbleX = (W - bubbleW) / 2;
          var bubbleY = bossY + 90;
          // Drop shadow
          ctx.fillStyle = 'rgba(0,0,0,0.5)';
          roundedRectPath(ctx, bubbleX + 3, bubbleY + 4, bubbleW, bubbleH, 12);
          ctx.fill();
          // Bubble body
          ctx.fillStyle = '#fff';
          roundedRectPath(ctx, bubbleX, bubbleY, bubbleW, bubbleH, 12);
          ctx.fill();
          ctx.strokeStyle = '#b91c1c';
          ctx.lineWidth = 2;
          ctx.stroke();
          // Upward-pointing tail (toward Greta)
          ctx.fillStyle = '#fff';
          ctx.beginPath();
          ctx.moveTo(bubbleX + bubbleW / 2 - 8, bubbleY);
          ctx.lineTo(bubbleX + bubbleW / 2 + 8, bubbleY);
          ctx.lineTo(bubbleX + bubbleW / 2, bubbleY - 14);
          ctx.closePath();
          ctx.fill();
          ctx.strokeStyle = '#b91c1c';
          ctx.beginPath();
          ctx.moveTo(bubbleX + bubbleW / 2 - 8, bubbleY);
          ctx.lineTo(bubbleX + bubbleW / 2, bubbleY - 14);
          ctx.lineTo(bubbleX + bubbleW / 2 + 8, bubbleY);
          ctx.stroke();
          // Text
          ctx.fillStyle = '#b91c1c';
          ctx.font = 'bold ' + fontSize + 'px -apple-system, Helvetica, Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(bubbleText, bubbleX + bubbleW / 2, bubbleY + bubbleH / 2);
          ctx.restore();
        }
      }

      // 🦠 Klima Kleber — activist glued to the playfield
      if (state.kleber) {
        var kk = state.kleber;
        var ky = GROUND_Y - 40;
        var kx = kk.x;
        var copX = 0, copDragging = false;
        ctx.save();
        // 👮 Police choreography: cop RUNS IN from the right (0–900ms with
        // flashing 🚨), then DRAGS the whole group off-screen (900–2400ms).
        if (kk.copAt) {
          var copT = now - kk.copAt;
          if (copT < 900) {
            var inP = copT / 900;
            var eased = 1 - Math.pow(1 - inP, 3);
            copX = (W + 50) - ((W + 50) - (kx + 48)) * eased;
          } else {
            copDragging = true;
            var outP = Math.min(1, (copT - 900) / 1500);
            kx += outP * (W - kk.x + 140);
            copX = kx + 48;
            ctx.globalAlpha = Math.max(0, 1 - outP * 0.85);
          }
        }
        // Sign on a stick (shared between 2 activists)
        ctx.fillStyle = '#222';
        ctx.fillRect(kx - 1, ky - 44, 2, 44);
        // Sign cardboard — sized to ACTUALLY fit the slogan (measured, padded)
        ctx.font = 'bold 11px -apple-system, Helvetica, Arial';
        var signText = KLEBER_SIGNS[kk.signIdx];
        var signW = Math.max(120, Math.ceil(ctx.measureText(signText).width) + 20);
        var signH = 30;
        ctx.fillStyle = '#f4eecd';
        ctx.strokeStyle = '#7a5a30';
        ctx.lineWidth = 1.5;
        ctx.fillRect(kx - signW/2, ky - 60, signW, signH);
        ctx.strokeRect(kx - signW/2, ky - 60, signW, signH);
        // Sign text
        ctx.fillStyle = '#b03020';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(signText, kx, ky - 45);
        // TWO activists holding hands — clearly reads as a group protest
        ctx.font = '32px serif';
        ctx.textBaseline = 'middle';
        ctx.fillText('🧎', kx - 16, ky);
        ctx.fillText('🧎', kx + 16, ky);
        // Linked-arms line between them
        ctx.strokeStyle = '#ffd700';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(kx - 8, ky - 2);
        ctx.lineTo(kx + 8, ky - 2);
        ctx.stroke();
        // Hi-vis stripes on each
        ctx.fillStyle = 'rgba(255, 220, 0, 0.85)';
        ctx.fillRect(kx - 28, ky - 4, 22, 6);
        ctx.fillRect(kx + 6,  ky - 4, 22, 6);
        // Wider glue puddle under both
        ctx.fillStyle = 'rgba(180, 180, 180, 0.5)';
        ctx.beginPath();
        ctx.ellipse(kx, ky + 20, 32, 5, 0, 0, Math.PI * 2);
        ctx.fill();
        // 👮 The cop himself — running lean-in, flashing siren, dust on drag
        if (kk.copAt) {
          ctx.font = '32px serif';
          ctx.fillText('👮', copX, ky + Math.sin(now / 60) * (copDragging ? 1 : 3));
          // 🚨 flashing blue light above the cop
          ctx.globalAlpha *= (Math.sin(now / 110) > 0 ? 1 : 0.25);
          ctx.font = '20px serif';
          ctx.fillText('🚨', copX, ky - 34);
          ctx.globalAlpha = copDragging ? Math.max(0, 1 - Math.min(1, (now - kk.copAt - 900) / 1500) * 0.85) : 1;
          if (copDragging) {
            // Dust clouds where the feet scrape the ground
            ctx.font = '16px serif';
            ctx.fillText('💨', kx - 40, ky + 14);
            ctx.fillText('💨', kx - 60, ky + 10);
          }
        }
        ctx.restore();
      }

      // ✈️ Chemtrail plane + persistent trail
      if (state.plane) {
        var pl = state.plane;
        ctx.save();
        // White trail behind plane
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.55)';
        ctx.lineWidth = 4;
        ctx.beginPath();
        if (pl.dir > 0) {
          ctx.moveTo(-30, pl.y);
          ctx.lineTo(pl.x - 14, pl.y);
        } else {
          ctx.moveTo(W + 30, pl.y);
          ctx.lineTo(pl.x + 14, pl.y);
        }
        ctx.stroke();
        // Plane
        ctx.font = '24px serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(pl.dir > 0 ? '✈️' : '🛩', pl.x, pl.y);
        ctx.restore();
      }

      // Chemtrail debuff — screen shimmer overlay
      if (now < state.chemtrailUntil && !state.wearsTinfoil) {
        ctx.save();
        ctx.fillStyle = 'rgba(80, 180, 255, ' + (0.06 + 0.04 * Math.sin(now / 80)).toFixed(2) + ')';
        ctx.fillRect(0, 0, W, H);
        ctx.restore();
      }

      // 🦗 EAT ZE BUGS event banner
      if (now < state.bugEventUntil) {
        var bannerY = 90;
        var pulse = 0.7 + 0.3 * Math.sin(now / 150);
        ctx.save();
        ctx.fillStyle = 'rgba(180, 30, 30, ' + (0.55 * pulse).toFixed(2) + ')';
        ctx.fillRect(0, bannerY - 14, W, 28);
        ctx.fillStyle = '#fff';
        ctx.font = 'bold 11px -apple-system, Helvetica, Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('⚠ WEF FOOD UPDATE — DO NOT EAT THE BUGS', W/2, bannerY);
        ctx.restore();
      }

      // 😷 Mask blur overlay — desaturated band over the cow's view
      if (state.wearsMask) {
        ctx.save();
        ctx.fillStyle = 'rgba(180, 180, 200, 0.18)';
        ctx.fillRect(0, 0, W, H);
        ctx.restore();
      }

      // 🐢 Bullet-time vignette — soft blue-violet edge tint when slow-mo is active
      if (now < state.slomoUntil) {
        var intensity = (state.slomoUntil - now) / state.slomoDuration; // 1 → 0
        ctx.save();
        var vg = ctx.createRadialGradient(W/2, H/2, W*0.3, W/2, H/2, W*0.75);
        vg.addColorStop(0, 'rgba(0,0,0,0)');
        vg.addColorStop(1, 'rgba(80, 100, 200, ' + (0.35 * intensity).toFixed(2) + ')');
        ctx.fillStyle = vg;
        ctx.fillRect(0, 0, W, H);
        ctx.restore();
      }

      // 🎯 Persistent boss-fight instructions — always visible above the ground
      // line so players never wonder what to do.
      if (state.bossActive && !state.bossDefeated && now >= state.bossWalkInUntil) {
        var hintText = '';
        if (state.bossType === 'greta') {
          hintText = state.hasRacket
            ? '🎾 TENNISBÄLLE MIT DEM SCHLÄGER ZURÜCKSCHLAGEN!'
            : '⚠ AUSWEICHEN — GLEICH KOMMT DEINE WAFFE!';
        } else if (state.bossType === 'klaus') {
          hintText = state.klausTransformed
            ? '🐛 FANGEN = 🧃 JUICE · ' + (isMobile ? '🧃 FIRE-KNOPF' : 'LEERTASTE') + ' = SCHUSS!'
            : '🚁 ER CRASHT IN DIE TÜRME → TEILE FANGEN (' + (state.klausParts || 0) + '/' + KLAUS_PARTS_NEEDED + ')!';
        } else if (state.bossType === 'gates') {
          hintText = state.hasRacket
            ? '💾📀 SAMMELN = VIRUS-UPLOAD · 🦠💀 AUSWEICHEN!'
            : '⚠ NICHTS SAMMELN — WARTE AUF DIE RIESENWELLE! 🌊';
        }
        if (hintText) {
          // Raised well above the ground so the spaceship build stays visible
          var hintPulse = 0.75 + 0.25 * Math.sin(now / 300);
          ctx.save();
          ctx.globalAlpha = hintPulse;
          ctx.fillStyle = 'rgba(0,0,0,0.65)';
          ctx.fillRect(0, GROUND_Y - 88, W, 20);
          ctx.fillStyle = '#ffd66b';
          ctx.font = 'bold 10px -apple-system, Helvetica, Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(hintText, W / 2, GROUND_Y - 78);
          ctx.restore();
        }
      }

      // 💥 Damage flash — red overlay that fades after a bad catch
      if (state.dangerFlash > 0) {
        ctx.save();
        ctx.fillStyle = 'rgba(220, 30, 30, ' + (state.dangerFlash / 36).toFixed(3) + ')';
        ctx.fillRect(0, 0, W, H);
        ctx.restore();
      }

      // 🐄 Size indicator HUD chip — only when not 1.0x so it draws attention to grow/shrink
      var sizeMulHud = state.growth * (now < state.testiclesUntil ? 1.30 : 1) * (now < state.fiberUntil ? 0.65 : 1);
      if (Math.abs(sizeMulHud - 1) > 0.05) {
        ctx.save();
        ctx.fillStyle = sizeMulHud > 1 ? 'rgba(255,210,80,0.95)' : 'rgba(180,80,80,0.95)';
        ctx.font = 'bold 12px -apple-system, Helvetica, Arial';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'top';
        var arrow = sizeMulHud > 1 ? '▲' : '▼';
        ctx.fillText('🐄 ' + sizeMulHud.toFixed(2) + 'x ' + arrow, 8, 86);
        ctx.restore();
      }

      // Close the shake transform
      if (shaking) ctx.restore();

      // Particles
      for (var p = 0; p < state.particles.length; p++) {
        var pa = state.particles[p];
        ctx.fillStyle = pa.color;
        ctx.globalAlpha = Math.max(0, pa.life / 30);
        ctx.fillRect(pa.x, pa.y, 3, 3);
      }
      ctx.globalAlpha = 1;

      // Popups
      for (var q = 0; q < state.popups.length; q++) {
        var po = state.popups[q];
        var col = po.danger ? CI.danger : (po.gold ? CI.gold : CI.cream);
        ctx.fillStyle = col;
        ctx.globalAlpha = Math.max(0, po.life / (po.danger ? 80 : 50));
        ctx.font = (po.danger ? 'bold 13px' : 'bold 16px') + " -apple-system, 'Helvetica Neue', Arial, sans-serif";
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(po.text, po.x, po.y);
      }
      ctx.globalAlpha = 1;

      // HUD — shown during gameplay AND demo so the preview matches the real game UI
      // HUD background — CI panel
      ctx.fillStyle = CI.panel;
      ctx.fillRect(0, 0, W, 68);
      ctx.fillStyle = CI.gold;
      ctx.fillRect(0, 67, W, 1);

      // HUD: score + level
      drawText(String(state.score), 12, 4, 20, CI.cream, 'left', '800');
      drawText('LV ' + (state.level + 1), 12, 26, 9, CI.muted, 'left', '700');

      // HUD: level name center — during boss fight, replace with boss banner
      if (state.bossActive && !state.bossDefeated) {
        var bannerPulse = 0.65 + 0.35 * Math.sin(now / 220);
        var bannerName, bannerBonus;
        if (state.bossType === 'gates') {
          bannerName = '⚔ BOSS — GILL BATES ⚔';
          bannerBonus = 'BESIEGE IHN FÜR 15% RABATT';
        } else if (state.bossType === 'klaus') {
          bannerName = '⚔ BOSS — DAVOS KLAUSEBÄR ⚔';
          bannerBonus = 'BESIEGE IHN FÜR 12% RABATT';
        } else {
          bannerName = '⚔ BOSS — TETRA VON DUNGPACK ⚔';
          bannerBonus = 'BESIEGE SIE FÜR 10% RABATT';
        }
        ctx.save();
        ctx.globalAlpha = bannerPulse;
        drawText(bannerName, W / 2, 6, 11, '#ff5040', 'center', '800');
        ctx.restore();
        drawText(bannerBonus, W / 2, 22, 9, CI.gold, 'center', '700');
      } else {
        drawText(currentLevel().name.toUpperCase(), W / 2, 10, 10, CI.gold, 'center', '700');
      }

      // HUD: best
      drawText('BEST ' + state.best, W - 12, 8, 11, CI.muted, 'right', '600');

      // Timer (90-second force-end) — top center
      var remaining = Math.max(0, 90 - (now - state.startedAt) / 1000);
      var mm = Math.floor(remaining / 60);
      var ss = Math.floor(remaining % 60);
      var tStr = mm + ':' + (ss < 10 ? '0' : '') + ss;
      drawText(tStr, W / 2, 26, 11, remaining < 30 ? CI.danger : CI.muted, 'center', '700');

      // HP bar — taller, bolder, HP-red when low
      var hbX = 56, hbY = 36, hbW = W - 68, hbH = 14;
      ctx.fillStyle = '#000';
      ctx.fillRect(hbX - 2, hbY - 2, hbW + 4, hbH + 4);
      ctx.fillStyle = '#0f0e12';
      ctx.fillRect(hbX, hbY, hbW, hbH);
      var hpFrac = Math.max(0, state.hp / state.maxHp);
      var hpColor = hpFrac > 0.55 ? '#3fbf5b' : (hpFrac > 0.28 ? '#e0a93a' : '#d84a3a');
      if (now < state.poisonUntil) hpColor = '#7fd958';
      ctx.fillStyle = hpColor;
      ctx.fillRect(hbX, hbY, hbW * hpFrac, hbH);
      drawText('HP', hbX - 28, hbY + 2, 12, CI.gold, 'left', '800');
      drawText(Math.max(0, Math.round(state.hp)) + '/' + state.maxHp, hbX + hbW - 6, hbY + 2, 11, '#fff', 'right', '800');

      // 🌡 Cow-Fart-Caused Global Warming bar — green → yellow → red
      var gbX = 56, gbY = 54, gbW = W - 68, gbH = 8;
      ctx.fillStyle = '#000';
      ctx.fillRect(gbX - 2, gbY - 2, gbW + 4, gbH + 4);
      ctx.fillStyle = '#0f0e12';
      ctx.fillRect(gbX, gbY, gbW, gbH);
      var warmFrac = Math.min(1, state.planetTemp / 16);
      // Gradient stops across the full bar so color matches fill level
      var grad = ctx.createLinearGradient(gbX, 0, gbX + gbW, 0);
      grad.addColorStop(0,    '#3fbf5b');
      grad.addColorStop(0.35, '#d6c73a');
      grad.addColorStop(0.65, '#e88a2a');
      grad.addColorStop(1,    '#d84a3a');
      ctx.fillStyle = grad;
      ctx.fillRect(gbX, gbY, gbW * warmFrac, gbH);
      drawText('🌡', gbX - 28, gbY - 1, 12, CI.gold, 'left', '800');
      var deg = (1.0 + state.planetTemp * 0.25).toFixed(1);
      drawText('+' + deg + '°C · ' + state.planetTemp + ' farts', gbX + gbW - 6, gbY - 2, 10, '#fff', 'right', '800');

      // Grace period banner
      var since = now - state.startedAt;
      if (since < 2500) {
        var fade = since > 1800 ? (2500 - since) / 700 : 1;
        ctx.globalAlpha = fade;
        drawText('WARM-UP · MEAT ONLY', W / 2, 76, 11, CI.gold, 'center', '800');
        ctx.globalAlpha = 1;
      }

      // Power-up bars bottom-left
      var barY = H - 60;
      if (now < state.carnivoroUntil) {
        var cf = (state.carnivoroUntil - now) / 5000;
        drawText('CARNIVORO', 12, barY - 10, 8, '#c00', 'left');
        ctx.fillStyle = '#2a0000';
        ctx.fillRect(12, barY, 100, 5);
        ctx.fillStyle = '#c00';
        ctx.fillRect(12, barY, 100 * cf, 5);
        barY -= 22;
      }
      if (now < state.shieldUntil && state.shieldHits > 0) {
        var sf = (state.shieldUntil - now) / 8000;
        drawText('SHIELD', 12, barY - 10, 8, '#4af', 'left');
        ctx.fillStyle = '#001830';
        ctx.fillRect(12, barY, 80, 5);
        ctx.fillStyle = '#4af';
        ctx.fillRect(12, barY, 80 * sf, 5);
        barY -= 22;
      }
      if (now < state.testiclesUntil) {
        var bf = (state.testiclesUntil - now) / 10000;
        drawText('BEAST MODE', 12, barY - 10, 8, '#ffd700', 'left');
        ctx.fillStyle = '#2a2000';
        ctx.fillRect(12, barY, 100, 5);
        ctx.fillStyle = '#ffd700';
        ctx.fillRect(12, barY, 100 * bf, 5);
        barY -= 22;
      }
      if (now < state.poisonUntil) {
        var pf = (state.poisonUntil - now) / 12000;
        drawText('POISONED — GET 💧', 12, barY - 10, 8, '#44dd44', 'left');
        ctx.fillStyle = '#002a00';
        ctx.fillRect(12, barY, 110, 5);
        ctx.fillStyle = '#44dd44';
        ctx.fillRect(12, barY, 110 * pf, 5);
      }

      // Combo
      if (state.streak >= 2) {
        var label = 'x2 STREAK';
        if (state.streak === 3) label = 'x3 ANCESTRAL';
        else if (state.streak === 4) label = 'x4 MEAT FURY';
        else if (state.streak >= 5) label = 'x' + state.streak + ' APEX PREDATOR';
        drawText(label, W / 2, H - 50, 13, '#ffd700', 'center');
      }

      // Status
      if (now < state.status.until && state.status.text) {
        var sfade = Math.min(1, (state.status.until - now) / 600);
        ctx.globalAlpha = sfade;
        drawText(state.status.text, W / 2, 52, 12, '#fff', 'center');
        ctx.globalAlpha = 1;
      }
      // XP bar at very bottom
      var lv = currentLevel();
      var prevXp = state.level > 0 ? LEVELS[state.level - 1].xp : 0;
      var xpRange = (lv.xp === Infinity ? 1000 : lv.xp) - prevXp;
      var xpProg = Math.min(1, (state.xp - prevXp) / xpRange);
      ctx.fillStyle = state.xpFlash > 0 ? '#ff4444' : '#c00';
      ctx.fillRect(0, H - 3, W * xpProg, 3);

      // 📱 Mobile touch-control hint — visible during the first 6s of real play
      // so users understand they can tap left/right halves to move the cow.
      // Fades out after that. Skipped on desktop.
      if (isMobile && phase === 'playing' && now - state.startedAt < 8000 && !state.bossActive) {
        var hintAlpha = Math.max(0, 1 - (now - state.startedAt) / 8000);
        // brief fade-in over 300ms
        hintAlpha *= Math.min(1, (now - state.startedAt) / 300);
        var hintPulse = 0.7 + 0.3 * Math.sin(now / 180);
        ctx.save();
        ctx.globalAlpha = hintAlpha * 0.9;
        // Left tap zone hint
        var grad = ctx.createLinearGradient(0, 0, W * 0.4, 0);
        grad.addColorStop(0, 'rgba(201,161,114,0.30)');
        grad.addColorStop(1, 'rgba(201,161,114,0)');
        ctx.fillStyle = grad;
        ctx.fillRect(0, H * 0.55, W * 0.4, H * 0.4);
        // Right tap zone hint
        var gradR = ctx.createLinearGradient(W * 0.6, 0, W, 0);
        gradR.addColorStop(0, 'rgba(201,161,114,0)');
        gradR.addColorStop(1, 'rgba(201,161,114,0.30)');
        ctx.fillStyle = gradR;
        ctx.fillRect(W * 0.6, H * 0.55, W * 0.4, H * 0.4);
        // Pulsing arrows
        ctx.fillStyle = CI.gold;
        ctx.globalAlpha = hintAlpha * hintPulse;
        ctx.font = 'bold 42px -apple-system, Helvetica, Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('◀', 38, H * 0.72);
        ctx.fillText('▶', W - 38, H * 0.72);
        ctx.font = 'bold 11px -apple-system, Helvetica, Arial';
        ctx.fillText('TIPPEN', 38, H * 0.72 + 32);
        ctx.fillText('TIPPEN', W - 38, H * 0.72 + 32);
        // BIG unmissable banner — this is how you steer the cow
        ctx.globalAlpha = hintAlpha * 0.95;
        var hbW = Math.min(W - 24, 400), hbH = 58;
        var hbX = (W - hbW) / 2, hbY = H * 0.60 - hbH;
        ctx.fillStyle = 'rgba(10, 9, 13, 0.92)';
        roundedRectPath(ctx, hbX, hbY, hbW, hbH, 10); ctx.fill();
        ctx.strokeStyle = CI.gold;
        ctx.lineWidth = 2;
        roundedRectPath(ctx, hbX, hbY, hbW, hbH, 10); ctx.stroke();
        ctx.fillStyle = CI.gold;
        ctx.font = 'bold 14px -apple-system, Helvetica, Arial';
        ctx.fillText('👈  TIPPE & HALTE LINKS / RECHTS  👉', W / 2, hbY + 21);
        ctx.fillStyle = CI.cream;
        ctx.font = 'bold 10px -apple-system, Helvetica, Arial';
        ctx.fillText('UNTEN AM BILDSCHIRMRAND — SO STEUERST DU DIE KUH', W / 2, hbY + 41);
        ctx.restore();
      }

      // 🔒 Final safety reset — guarantee no canvas-filter state leaks into
      // drawStart's overlays (PLAY NOW button, AUTO-PLAY chip, disclaimer).
      try { ctx.filter = 'none'; } catch (e) {}
      ctx.shadowBlur = 0;
      ctx.shadowColor = 'rgba(0,0,0,0)';
      ctx.globalAlpha = 1;
    }

    function drawHSTable(x, y, w) {
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      if (!highscores.length) {
        drawText('— no records yet —', x + w / 2, y, 11, '#555', 'center');
        return;
      }
      for (var i = 0; i < highscores.length; i++) {
        var e = highscores[i];
        var isCurrent = e.id === currentEntryId;
        var col = isCurrent ? '#ffd700' : '#aaa';
        drawText((i + 1) + '.', x, y + i * 18, 12, col, 'left');
        drawText(String(e.score), x + 30, y + i * 18, 12, col, 'left');
        drawText(e.date, x + w - 10, y + i * 18, 12, col, 'right');
      }
    }

    function drawButton(btn, label, color) {
      // Carnivoro CI button: gold fill, dark label, soft drop shadow.
      ctx.fillStyle = 'rgba(0,0,0,0.4)';
      ctx.fillRect(btn.x + 2, btn.y + 3, btn.w, btn.h);
      ctx.fillStyle = color;
      ctx.fillRect(btn.x, btn.y, btn.w, btn.h);
      drawText(label, btn.x + btn.w / 2, btn.y + 16, 14, CI.bg, 'center', '800');
    }

    // === Auto-running gameplay teaser + discount tease ===================
    // 16s loop: 4s per gameplay stage + 4s tease panel. Sprites scaled WAY up
    // so the demo reads at a glance, not as ghostly specks.
    var demoStartedAt = performance.now();
    var DEMO_CYCLE_MS = 16000;
    var DEMO_GAMEPLAY_MS = 12000;
    var STAGE_MS = 4000;
    var KLEBER_SIGNS_DEMO = ['LETZTE GENERATION', 'KLEBEN FÜRS KLIMA'];

    function drawDemoStage(t, zy, zh) {
      // Solid darker inset so big sprites pop off the page bg
      ctx.fillStyle = '#0a0a0c';
      ctx.fillRect(20, zy, W - 40, zh);
      ctx.strokeStyle = 'rgba(201,161,114,0.45)';
      ctx.lineWidth = 1.5;
      ctx.strokeRect(20, zy, W - 40, zh);

      // Visible ground line
      var groundY = zy + zh - 50;
      ctx.fillStyle = 'rgba(201,161,114,0.35)';
      ctx.fillRect(28, groundY, W - 56, 1);

      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      var COW_SIZE = 72;
      var ITEM_SIZE = 60;

      // Stage 1: STEAK CATCH (0 - 4000ms)
      if (t < STAGE_MS) {
        var cowX = W / 2;
        var cowBob = Math.sin(t / 200) * 2;
        var cowY = groundY - 30 + cowBob;
        ctx.font = COW_SIZE + 'px serif';
        ctx.fillText('🐄', cowX, cowY);
        if (t < 3000) {
          // Steak falls top → cow
          var prog = t / 3000;
          ctx.font = ITEM_SIZE + 'px serif';
          ctx.fillText('🥩', cowX, zy + 30 + prog * (groundY - zy - 80));
        } else {
          // Catch pop — gold particles + popup
          var pop = (t - 3000) / 1000;
          ctx.fillStyle = CI.gold;
          ctx.font = 'bold ' + Math.round(22 + pop * 14) + 'px -apple-system, Helvetica, Arial';
          ctx.globalAlpha = Math.max(0, 1 - pop);
          ctx.fillText('+12 🥩', cowX, cowY - 60 - pop * 30);
          ctx.globalAlpha = 1;
        }
        drawText('1. FLEISCH FANGEN', W / 2, zy + zh - 18, 13, CI.gold, 'center', '800');
        return;
      }

      // Stage 2: SHROOM TRIP (4000 - 8000ms)
      if (t < STAGE_MS * 2) {
        var st = t - STAGE_MS;
        var cowX2 = W / 2;
        var cowY2 = groundY - 30 + Math.sin(st / 150) * 4;
        var tripping = st > 2500;

        // Trippy BG ONLY (don't dim the sprites with hue-rotate)
        if (tripping) {
          var tripT = (st - 2500) / 1500;
          var hueBg = ((st - 2500) / 8) % 360;
          ctx.save();
          ctx.fillStyle = 'hsla(' + hueBg + ', 70%, 30%, ' + (0.18 + 0.10 * Math.sin(st / 120)).toFixed(2) + ')';
          ctx.fillRect(22, zy + 2, W - 44, zh - 4);
          ctx.restore();
        }

        ctx.font = COW_SIZE + 'px serif';
        ctx.fillText('🐄', cowX2, cowY2);
        if (st < 2500) {
          var prog2 = st / 2500;
          ctx.font = ITEM_SIZE + 'px serif';
          ctx.fillText('🍄', cowX2, zy + 30 + prog2 * (groundY - zy - 80));
        } else {
          // Rainbow sparkle ring around cow
          for (var sp = 0; sp < 8; sp++) {
            var ang = (st / 180 + sp * Math.PI / 4) % (Math.PI * 2);
            var rad = 56 + Math.sin(st / 130) * 10;
            ctx.font = '22px serif';
            ctx.fillText('✨', cowX2 + Math.cos(ang) * rad, cowY2 + Math.sin(ang) * rad);
          }
          ctx.fillStyle = CI.gold;
          ctx.font = 'bold 18px -apple-system, Helvetica, Arial';
          ctx.fillText('🍄 TRIP MODE 🍄', W / 2, cowY2 - 70);
        }
        drawText('2. AUF SHROOMS GEHEN', W / 2, zy + zh - 18, 13, CI.gold, 'center', '800');
        return;
      }

      // Stage 3: KLIMA KLEBER (8000 - 12000ms)
      var st3 = t - STAGE_MS * 2;
      var cowX3 = 80; // cow pushed left, blocked by activist
      var cowY3 = groundY - 30 + Math.sin(st3 / 200) * 2;
      ctx.font = COW_SIZE + 'px serif';
      ctx.fillText('🐄', cowX3, cowY3);

      // Activist drops in
      var kx = W - 110;
      var ky = groundY - 22;
      var ky2 = ky;
      if (st3 < 600) {
        var dropP = st3 / 600;
        ky2 = zy + 30 + dropP * (ky - zy - 30);
      }
      // Cop arrives at 2800ms, drags off over 1000ms
      var copPhase = st3 > 2800 ? Math.min(1, (st3 - 2800) / 1000) : 0;
      ctx.save();
      if (copPhase > 0) {
        ctx.translate(copPhase * 80, 0);
        ctx.globalAlpha = 1 - copPhase * 0.6;
      }
      // Sign stick
      ctx.fillStyle = '#333';
      ctx.fillRect(kx - 2, ky2 - 56, 3, 56);
      // Sign cardboard — bigger
      ctx.fillStyle = '#f4eecd';
      ctx.fillRect(kx - 70, ky2 - 80, 140, 32);
      ctx.strokeStyle = '#7a5a30';
      ctx.lineWidth = 2;
      ctx.strokeRect(kx - 70, ky2 - 80, 140, 32);
      ctx.fillStyle = '#b03020';
      ctx.font = 'bold 12px -apple-system, Helvetica, Arial';
      var signIdx = Math.floor(st3 / 900) % KLEBER_SIGNS_DEMO.length;
      ctx.fillText(KLEBER_SIGNS_DEMO[signIdx], kx, ky2 - 64);
      // Activist (bigger)
      ctx.font = '52px serif';
      ctx.fillText('🧎', kx, ky2);
      // Hi-vis vest stripe
      ctx.fillStyle = 'rgba(255, 220, 0, 0.85)';
      ctx.fillRect(kx - 18, ky2 - 4, 36, 7);
      // Glue puddle
      ctx.fillStyle = 'rgba(180,180,180,0.5)';
      ctx.beginPath();
      ctx.ellipse(kx, ky2 + 26, 24, 5, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
      // Cop sliding in to drag away
      if (copPhase > 0) {
        ctx.save();
        var copX = kx - 70 + copPhase * 40;
        ctx.font = '48px serif';
        ctx.fillText('👮', copX, ky);
        ctx.restore();
      }
      drawText('3. KLIMA-KLEBER ÜBERLEBEN', W / 2, zy + zh - 18, 13, CI.gold, 'center', '800');
    }

    function drawDiscountTease(t, zy, zh) {
      // Fade in over 300ms
      var fade = Math.min(1, t / 300);
      ctx.globalAlpha = fade;

      // Panel
      ctx.fillStyle = 'rgba(201,161,114,0.08)';
      ctx.fillRect(20, zy, W - 40, zh);
      ctx.strokeStyle = CI.gold;
      ctx.lineWidth = 2;
      ctx.strokeRect(20, zy, W - 40, zh);

      // Header
      drawText('DEIN RABATT WARTET', W / 2, zy + 14, 14, CI.gold, 'center', '800');
      drawText('Spiele gut. Hol dir bis zu 15% auf die erste Bestellung.', W / 2, zy + 36, 10, CI.cream, 'center', '600');

      var rows = [
        ['HAUPTMANN', '10%', 'Rang 3 erreichen'],
        ['OBERST',    '12%', 'Rang 5 erreichen'],
        ['BARON+',    '15%', 'Rang 7 erreichen']
      ];
      var rowY = zy + 64;
      for (var i = 0; i < rows.length; i++) {
        var ry = rowY + i * 38;
        ctx.fillStyle = 'rgba(0,0,0,0.32)';
        ctx.fillRect(36, ry, W - 72, 32);
        drawText(rows[i][0], 50, ry + 6,  11, CI.cream, 'left', '800');
        drawText(rows[i][2], 50, ry + 20, 8,  CI.muted, 'left', '600');
        drawText(rows[i][1], W - 50, ry + 16, 22, CI.gold, 'right', '800');
      }
      // Highscore bonus chip
      var bonusY = rowY + 3 * 38 + 8;
      ctx.fillStyle = 'rgba(255,210,80,0.16)';
      ctx.fillRect(36, bonusY, W - 72, 28);
      ctx.strokeStyle = '#ffd66b';
      ctx.lineWidth = 1;
      ctx.strokeRect(36, bonusY, W - 72, 28);
      drawText('🏆 NEUER HIGHSCORE = +1 TIER (max 15%)', W / 2, bonusY + 14, 10, '#ffd66b', 'center', '800');

      ctx.globalAlpha = 1;
    }

    function drawCompactScores(x, y, w) {
      if (!highscores.length) {
        drawText('— noch keine Highscores —', x + w / 2, y, 10, '#555', 'center');
        return;
      }
      var medals = ['🥇', '🥈', '🥉'];
      var n = Math.min(3, highscores.length);
      for (var i = 0; i < n; i++) {
        var e = highscores[i];
        var name = (e.name || 'Anon').slice(0, 24);
        drawText(medals[i] + '  ' + e.score + '   ' + name, x + w / 2, y + i * 18, 11, i === 0 ? CI.gold : CI.cream, 'center', '700');
      }
    }

    // Rotating disclaimer chip — picked once per page load
    var DISCLAIMERS = [
      'Vorsicht: Kann Veganer triggern.',
      'Nicht klimaneutral. Sehr lecker.',
      'Wissenschaftlich (noch) nicht erlaubt.',
      'Vom BUND nicht empfohlen.',
      'Achtung: enthält 0% Soja.',
      'Greta würde das nicht spielen.',
      'Alle Personen frei erfunden. Ähnlichkeiten rein zufällig.'
    ];
    var startDisclaimer = DISCLAIMERS[Math.floor(Math.random() * DISCLAIMERS.length)];

    // Funny fake "live counters" for the rotating ticker
    var FUNNY_STATS = [
      '🥩 Heute gerettete Steaks: 18,247',
      '🦗 Bugs verweigert: 91,003',
      '🌱 Veganer getriggert: 4,213',
      '🛡 Klima-Kleber überlebt: 384',
      '🌍 Erderwärmung korrigiert um: -0.4°C'
    ];

    function drawFoodLegend(y) {
      // YES / NO food strip — tells players in 1 second "we mean meat, not 'plant-based'"
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      var midY = y + 12;
      // YES side
      ctx.font = '18px serif';
      ctx.fillText('🥩🍖🍳🥛🧈', 28, midY);
      ctx.fillStyle = '#6B8E4E';
      ctx.font = 'bold 11px -apple-system, Helvetica, Arial';
      ctx.fillText('JA', 130, midY);
      // Divider
      ctx.fillStyle = CI.muted;
      ctx.font = 'bold 11px -apple-system, Helvetica, Arial';
      ctx.fillText('·', W / 2, midY);
      // NO side
      ctx.font = '18px serif';
      ctx.textAlign = 'right';
      ctx.fillText('🥗🌶️🦗🧴', W - 64, midY);
      ctx.fillStyle = '#b03020';
      ctx.font = 'bold 11px -apple-system, Helvetica, Arial';
      ctx.fillText('NEIN', W - 28, midY);
    }

    // Rounded-rect path helper (no native ctx.roundRect on older browsers)
    function roundedRectPath(c, x, y, w, h, r) {
      c.beginPath();
      c.moveTo(x + r, y);
      c.lineTo(x + w - r, y);
      c.quadraticCurveTo(x + w, y, x + w, y + r);
      c.lineTo(x + w, y + h - r);
      c.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      c.lineTo(x + r, y + h);
      c.quadraticCurveTo(x, y + h, x, y + h - r);
      c.lineTo(x, y + r);
      c.quadraticCurveTo(x, y, x + r, y);
      c.closePath();
    }

    function drawStart() {
      // Demo runs the REAL game underneath, complete with HUD — preview = actual UI
      drawGame();

      var now = performance.now();
      var pulse = 0.5 + 0.5 * Math.sin(now / 280);

      // CTA overlays — hidden during the boss teaser so Greta has the full upper canvas.
      // The whole canvas is still tap-to-play, so users can still launch the game.
      if (!state || !state.bossActive) {
        // AUTO-PLAY pulsing chip — small, top-right corner just below the HUD strip
        ctx.save();
        var apX = W - 96, apY = 74, apW = 88, apH = 20;
        ctx.fillStyle = 'rgba(0,0,0,0.78)';
        roundedRectPath(ctx, apX, apY, apW, apH, 6); ctx.fill();
        ctx.fillStyle = CI.gold;
        ctx.globalAlpha = 0.7 + pulse * 0.3;
        ctx.font = 'bold 9px -apple-system, Helvetica, Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('▶ AUTO-PLAY', apX + apW / 2, apY + apH / 2);
        ctx.restore();

        // === PLAY button — rounded pill, drop shadow, pulse alpha.
        // Two lines: big CTA + discount tease. (Separate teaser card removed.)
        var btnW = 360, btnH = 58;
        var btnX = (W - btnW) / 2;
        var btnY = 100;
        ctx.save();
        // Drop shadow
        ctx.fillStyle = 'rgba(0,0,0,0.55)';
        roundedRectPath(ctx, btnX + 2, btnY + 4, btnW, btnH, 28); ctx.fill();
        // Gold pill — fully opaque
        ctx.fillStyle = CI.gold;
        roundedRectPath(ctx, btnX, btnY, btnW, btnH, 28); ctx.fill();
        // Subtle inner highlight (top)
        ctx.fillStyle = 'rgba(255,255,255,0.18)';
        roundedRectPath(ctx, btnX + 2, btnY + 2, btnW - 4, btnH / 2 - 2, 26); ctx.fill();
        // Pulsing outline ring (so it always reads as "click me")
        ctx.strokeStyle = 'rgba(255, 235, 180, ' + (0.4 + pulse * 0.6).toFixed(2) + ')';
        ctx.lineWidth = 2;
        roundedRectPath(ctx, btnX - 2, btnY - 2, btnW + 4, btnH + 4, 30); ctx.stroke();
        // Label — line 1 big, line 2 the discount tease
        ctx.fillStyle = CI.bg;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = 'bold 16px -apple-system, Helvetica, Arial';
        ctx.fillText('▶  JETZT SPIELEN', W / 2, btnY + 21);
        ctx.font = 'bold 10.5px -apple-system, Helvetica, Arial';
        ctx.fillText('BIS ZU 20% AUF DEINE ERSTE BESTELLUNG GEWINNEN', W / 2, btnY + 41);
        ctx.restore();
      }

      // (Discount teaser card removed — the tease lives inside the PLAY pill.)

      // === RIDICULOUS RANK TEASER — fades in/out every 12s.
      // Readability first: bigger font, generous line height, dynamic backdrop,
      // shorter excerpt of the Habsburg title.
      var rankTopTier = LEVELS[LEVELS.length - 1].name;
      var teaserRank = rankTopTier.length > 72
        ? rankTopTier.substring(0, 72) + ' …'
        : rankTopTier;
      var teaserCycleMs = 12000;
      var teaserT = now % teaserCycleMs;
      if (teaserT > 4000 && teaserT < 9000) {
        var teaserFade;
        if (teaserT < 4500) teaserFade = (teaserT - 4000) / 500;
        else if (teaserT > 8500) teaserFade = (9000 - teaserT) / 500;
        else teaserFade = 1;
        ctx.save();
        ctx.globalAlpha = teaserFade * 0.95;
        // Measure first so the backdrop grows with the text
        ctx.font = 'bold 13px -apple-system, Helvetica, Arial';
        var lines = wrapTextLines(ctx, teaserRank, W - 56);
        if (lines.length > 3) lines = lines.slice(0, 3);
        var lineH = 19;
        var blockH = 34 + lines.length * lineH + 12;
        var teaserY = H / 2 - blockH / 2;
        // Backdrop — darker + gold hairlines top/bottom for polish
        ctx.fillStyle = 'rgba(0,0,0,0.85)';
        ctx.fillRect(0, teaserY, W, blockH);
        ctx.fillStyle = 'rgba(201,161,114,0.5)';
        ctx.fillRect(0, teaserY, W, 1);
        ctx.fillRect(0, teaserY + blockH - 1, W, 1);
        // Label
        ctx.fillStyle = CI.cream;
        ctx.font = 'bold 11px -apple-system, Helvetica, Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        ctx.fillText('WERDE …', W / 2, teaserY + 10);
        // Rank text — 13px, airy line height
        ctx.fillStyle = CI.gold;
        ctx.font = 'bold 13px -apple-system, Helvetica, Arial';
        var startY = teaserY + 32;
        for (var li = 0; li < lines.length; li++) {
          ctx.fillText(lines[li], W / 2, startY + li * lineH);
        }
        ctx.restore();
      }

      // 📱 Persistent small "TAP TO PLAY" chip during boss teaser before freeze.
      // The big PLAY NOW button hides while Greta is on screen, so users
      // (especially on mobile) need a constant fallback CTA.
      if (state && state.bossActive && !state._demoFrozen) {
        var tpPulse = 0.65 + 0.35 * Math.sin(now / 260);
        ctx.save();
        ctx.globalAlpha = tpPulse;
        var tpW = 160, tpH = 28;
        var tpX = (W - tpW) / 2;
        var tpY = H - 64;
        ctx.fillStyle = 'rgba(0,0,0,0.75)';
        roundedRectPath(ctx, tpX, tpY, tpW, tpH, 14); ctx.fill();
        ctx.strokeStyle = CI.gold;
        ctx.lineWidth = 1.5;
        roundedRectPath(ctx, tpX, tpY, tpW, tpH, 14); ctx.stroke();
        ctx.fillStyle = CI.gold;
        ctx.font = 'bold 12px -apple-system, Helvetica, Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('▶ TAP TO PLAY', tpX + tpW / 2, tpY + tpH / 2);
        ctx.restore();
      }

      // === FROZEN DEMO — "ARE YOU READY?" challenge overlay (after boss teaser)
      if (state && state._demoFrozen) {
        var rPulse = 0.6 + 0.4 * Math.sin(now / 240);
        ctx.save();
        // Darken everything else
        ctx.fillStyle = 'rgba(0, 0, 0, 0.55)';
        ctx.fillRect(0, 0, W, H);
        // Center prompt
        var ryY = H / 2;
        ctx.fillStyle = '#ff5040';
        ctx.globalAlpha = rPulse;
        ctx.font = 'bold 22px -apple-system, Helvetica, Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('ARE YOU READY', W / 2, ryY - 24);
        ctx.fillText('FOR THE ULTIMATE CHALLENGE?', W / 2, ryY);
        ctx.globalAlpha = 1;
        ctx.fillStyle = CI.gold;
        ctx.font = 'bold 12px -apple-system, Helvetica, Arial';
        ctx.fillText('▶ TAP TO PLAY', W / 2, ryY + 36);
        ctx.restore();
      }

      // === Tiny disclaimer at the very bottom edge
      ctx.save();
      ctx.fillStyle = 'rgba(0,0,0,0.55)';
      ctx.fillRect(0, H - 18, W, 18);
      ctx.fillStyle = CI.gold;
      ctx.font = 'italic 600 10px -apple-system, Helvetica, Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('« ' + startDisclaimer + ' »', W / 2, H - 9);
      ctx.restore();
    }

    function drawOver() {
      // Solid background — no faint gameplay bleed-through
      ctx.fillStyle = CI.bg;
      ctx.fillRect(0, 0, W, H);

      drawLogo(W / 2, 80, 64);
      drawText('GAME OVER', W / 2, 130, 30, CI.cream, 'center', '800');

      // Rank achieved
      var rankName = (LEVELS[state.level] && LEVELS[state.level].name) ? LEVELS[state.level].name.toUpperCase() : '';
      drawText('RANG ERREICHT', W / 2, 174, 9, CI.muted, 'center', '700');
      drawText(rankName, W / 2, 188, 13, CI.gold, 'center', '800');

      // Score + Best
      drawText('SCORE', W / 2 - 70, 222, 10, CI.muted, 'center', '700');
      drawText(String(state.score), W / 2 - 70, 238, 26, CI.cream, 'center', '800');
      drawText('BEST', W / 2 + 70, 222, 10, CI.muted, 'center', '700');
      drawText(String(state.best), W / 2 + 70, 238, 26, CI.gold, 'center', '800');

      // Top scores
      drawText('TOP SCORES', W / 2, 290, 10, CI.gold, 'center', '700');
      drawHSTable(W / 2 - 90, 308, 180);

      drawButton(overBtn, 'NOCHMAL', CI.gold);
    }

    // Loop
    // Snapshot of the game canvas taken during boss fights — used as the
    // share-image background so shared posts show the coolest moment.
    var bossSnapCanvas = null;
    var lastBossSnapAt = 0;

    function loop(ts) {
      if (!running) return;
      if (!lastTime) lastTime = ts;
      var dt = Math.min(50, ts - lastTime);
      lastTime = ts;

      update(dt);

      // Skip the redundant game-over canvas while the share overlay is up —
      // saves CPU and prevents bleed-through if anything ever goes translucent.
      var overlayOpen = emailOverlay && emailOverlay.classList.contains('active');
      if (phase === 'start') drawStart();
      else if (phase === 'playing') drawGame();
      else if (!overlayOpen) drawOver();

      // Capture a boss-fight frame every ~700ms (only in real play).
      // The last one taken becomes the share-image background.
      if (phase === 'playing' && state && state.bossActive && !state.bossDefeated) {
        var snapNow = performance.now();
        if (snapNow - lastBossSnapAt > 700) {
          lastBossSnapAt = snapNow;
          try {
            if (!bossSnapCanvas) {
              bossSnapCanvas = document.createElement('canvas');
              bossSnapCanvas.width = W;
              bossSnapCanvas.height = H;
            }
            bossSnapCanvas.getContext('2d').drawImage(canvas, 0, 0);
          } catch (e) {}
        }
      }

      requestAnimationFrame(loop);
    }

    function start() {
      if (running) return;
      running = true;
      resetState();
      // Demo runs a scripted 30-second cycle:
      //   0–10s: regular gameplay (cow catches meat, dodges veg)
      //   10s:  Klima-Kleber appears
      //   20s:  Greta von Dungberg boss teaser starts walking in
      //   ~26s: Demo FREEZES with "ARE YOU READY?" overlay
      //   30s:  Reset, loop
      state.startedAt = performance.now();
      state.hp = 80;
      lastTime = 0;
      requestAnimationFrame(loop);
    }

    // Debug/test hook — closure state is otherwise unreachable from the console.
    // Client-side anti-cheat is cosmetic anyway (validator runs separately).
    window.CG_TEST = {
      state: function () { return state; },
      warp: function (ms) { if (state) state.startedAt = performance.now() - ms; },
      startGame: startGame,
      fire: fireJuice,
      dropRacket: dropTennisRacket,
      phase: function () { return phase; }
    };

    // Lazy init via IntersectionObserver
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            start();
            io.disconnect();
            break;
          }
        }
      }, { threshold: 0.1 });
      io.observe(canvas);
    } else {
      start();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
